import { Children, Component, PureComponent, createElement } from 'react';
import { classNames, variationName } from '@shopify/react-utilities/styles';
import { __decorate, __rest } from 'tslib';
import { classNames as classNames$1, variationName as variationName$1 } from '@shopify/react-utilities';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { elementChildren, isElementOfType, layeredComponent, wrapWithComponent } from '@shopify/react-utilities/components';
import { autobind, debounce } from '@shopify/javascript-utilities/decorators';
import { createUniqueIDFactory, noop } from '@shopify/javascript-utilities/other';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import { bool, object } from 'prop-types';
import { addEventListener, removeEventListener } from '@shopify/javascript-utilities/events';
import { read, write } from '@shopify/javascript-utilities/fastdom';
import { clamp } from '@shopify/javascript-utilities/math';
import { Months, Weekdays, abbreviationForWeekday, dateIsInRange, dateIsSelected, getNewRange, getNextDisplayMonth, getNextDisplayYear, getPreviousDisplayMonth, getPreviousDisplayYear, getWeeksForMonth, isDateAfter, isDateBefore, isSameDay } from '@shopify/javascript-utilities/dates';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import { findFirstFocusableNode, focusFirstFocusableNode } from '@shopify/javascript-utilities/focus';
import { closest, nodeContainsDescendant } from '@shopify/javascript-utilities/dom';
import { Transition } from 'react-transition-group';
import { Rect, getRectForNode } from '@shopify/javascript-utilities/geometry';
import { findDOMNode } from 'react-dom';

var Keys;
(function (Keys) {
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["ENTER"] = 13] = "ENTER";
    Keys[Keys["SHIFT"] = 16] = "SHIFT";
    Keys[Keys["CTRL"] = 17] = "CTRL";
    Keys[Keys["ALT"] = 18] = "ALT";
    Keys[Keys["PAUSE"] = 19] = "PAUSE";
    Keys[Keys["CAPS_LOCK"] = 20] = "CAPS_LOCK";
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["PAGE_UP"] = 33] = "PAGE_UP";
    Keys[Keys["PAGE_DOWN"] = 34] = "PAGE_DOWN";
    Keys[Keys["END"] = 35] = "END";
    Keys[Keys["HOME"] = 36] = "HOME";
    Keys[Keys["LEFT_ARROW"] = 37] = "LEFT_ARROW";
    Keys[Keys["UP_ARROW"] = 38] = "UP_ARROW";
    Keys[Keys["RIGHT_ARROW"] = 39] = "RIGHT_ARROW";
    Keys[Keys["DOWN_ARROW"] = 40] = "DOWN_ARROW";
    Keys[Keys["INSERT"] = 45] = "INSERT";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    Keys[Keys["KEY_0"] = 48] = "KEY_0";
    Keys[Keys["KEY_1"] = 49] = "KEY_1";
    Keys[Keys["KEY_2"] = 50] = "KEY_2";
    Keys[Keys["KEY_3"] = 51] = "KEY_3";
    Keys[Keys["KEY_4"] = 52] = "KEY_4";
    Keys[Keys["KEY_5"] = 53] = "KEY_5";
    Keys[Keys["KEY_6"] = 54] = "KEY_6";
    Keys[Keys["KEY_7"] = 55] = "KEY_7";
    Keys[Keys["KEY_8"] = 56] = "KEY_8";
    Keys[Keys["KEY_9"] = 57] = "KEY_9";
    Keys[Keys["KEY_A"] = 65] = "KEY_A";
    Keys[Keys["KEY_B"] = 66] = "KEY_B";
    Keys[Keys["KEY_C"] = 67] = "KEY_C";
    Keys[Keys["KEY_D"] = 68] = "KEY_D";
    Keys[Keys["KEY_E"] = 69] = "KEY_E";
    Keys[Keys["KEY_F"] = 70] = "KEY_F";
    Keys[Keys["KEY_G"] = 71] = "KEY_G";
    Keys[Keys["KEY_H"] = 72] = "KEY_H";
    Keys[Keys["KEY_I"] = 73] = "KEY_I";
    Keys[Keys["KEY_J"] = 74] = "KEY_J";
    Keys[Keys["KEY_K"] = 75] = "KEY_K";
    Keys[Keys["KEY_L"] = 76] = "KEY_L";
    Keys[Keys["KEY_M"] = 77] = "KEY_M";
    Keys[Keys["KEY_N"] = 78] = "KEY_N";
    Keys[Keys["KEY_O"] = 79] = "KEY_O";
    Keys[Keys["KEY_P"] = 80] = "KEY_P";
    Keys[Keys["KEY_Q"] = 81] = "KEY_Q";
    Keys[Keys["KEY_R"] = 82] = "KEY_R";
    Keys[Keys["KEY_S"] = 83] = "KEY_S";
    Keys[Keys["KEY_T"] = 84] = "KEY_T";
    Keys[Keys["KEY_U"] = 85] = "KEY_U";
    Keys[Keys["KEY_V"] = 86] = "KEY_V";
    Keys[Keys["KEY_W"] = 87] = "KEY_W";
    Keys[Keys["KEY_X"] = 88] = "KEY_X";
    Keys[Keys["KEY_Y"] = 89] = "KEY_Y";
    Keys[Keys["KEY_Z"] = 90] = "KEY_Z";
    Keys[Keys["LEFT_META"] = 91] = "LEFT_META";
    Keys[Keys["RIGHT_META"] = 92] = "RIGHT_META";
    Keys[Keys["SELECT"] = 93] = "SELECT";
    Keys[Keys["NUMPAD_0"] = 96] = "NUMPAD_0";
    Keys[Keys["NUMPAD_1"] = 97] = "NUMPAD_1";
    Keys[Keys["NUMPAD_2"] = 98] = "NUMPAD_2";
    Keys[Keys["NUMPAD_3"] = 99] = "NUMPAD_3";
    Keys[Keys["NUMPAD_4"] = 100] = "NUMPAD_4";
    Keys[Keys["NUMPAD_5"] = 101] = "NUMPAD_5";
    Keys[Keys["NUMPAD_6"] = 102] = "NUMPAD_6";
    Keys[Keys["NUMPAD_7"] = 103] = "NUMPAD_7";
    Keys[Keys["NUMPAD_8"] = 104] = "NUMPAD_8";
    Keys[Keys["NUMPAD_9"] = 105] = "NUMPAD_9";
    Keys[Keys["MULTIPLY"] = 106] = "MULTIPLY";
    Keys[Keys["ADD"] = 107] = "ADD";
    Keys[Keys["SUBTRACT"] = 109] = "SUBTRACT";
    Keys[Keys["DECIMAL"] = 110] = "DECIMAL";
    Keys[Keys["DIVIDE"] = 111] = "DIVIDE";
    Keys[Keys["F1"] = 112] = "F1";
    Keys[Keys["F2"] = 113] = "F2";
    Keys[Keys["F3"] = 114] = "F3";
    Keys[Keys["F4"] = 115] = "F4";
    Keys[Keys["F5"] = 116] = "F5";
    Keys[Keys["F6"] = 117] = "F6";
    Keys[Keys["F7"] = 118] = "F7";
    Keys[Keys["F8"] = 119] = "F8";
    Keys[Keys["F9"] = 120] = "F9";
    Keys[Keys["F10"] = 121] = "F10";
    Keys[Keys["F11"] = 122] = "F11";
    Keys[Keys["F12"] = 123] = "F12";
    Keys[Keys["NUM_LOCK"] = 144] = "NUM_LOCK";
    Keys[Keys["SCROLL_LOCK"] = 145] = "SCROLL_LOCK";
    Keys[Keys["SEMICOLON"] = 186] = "SEMICOLON";
    Keys[Keys["EQUALS"] = 187] = "EQUALS";
    Keys[Keys["COMMA"] = 188] = "COMMA";
    Keys[Keys["DASH"] = 189] = "DASH";
    Keys[Keys["PERIOD"] = 190] = "PERIOD";
    Keys[Keys["FORWARD_SLASH"] = 191] = "FORWARD_SLASH";
    Keys[Keys["GRAVE_ACCENT"] = 192] = "GRAVE_ACCENT";
    Keys[Keys["OPEN_BRACKET"] = 219] = "OPEN_BRACKET";
    Keys[Keys["BACK_SLASH"] = 220] = "BACK_SLASH";
    Keys[Keys["CLOSE_BRACKET"] = 221] = "CLOSE_BRACKET";
    Keys[Keys["SINGLE_QUOTE"] = 222] = "SINGLE_QUOTE";
})(Keys || (Keys = {}));

function Image$1(_a) {
    var sourceSet = _a.sourceSet,
        source = _a.source,
        rest = __rest(_a, ["sourceSet", "source"]);

    var finalSourceSet = sourceSet ? sourceSet.map(function (_ref) {
        var subSource = _ref.source,
            descriptor = _ref.descriptor;
        return subSource + " " + descriptor;
    }).join(',') : null;
    return finalSourceSet ? createElement("img", Object.assign({ src: source, srcSet: finalSourceSet }, rest)) : createElement("img", Object.assign({ src: source }, rest));
}

var styles$1 = {
  "Avatar": "Polaris-Avatar",
  "sizeSmall": "Polaris-Avatar--sizeSmall",
  "sizeMedium": "Polaris-Avatar--sizeMedium",
  "sizeLarge": "Polaris-Avatar--sizeLarge",
  "styleOne": "Polaris-Avatar--styleOne",
  "styleTwo": "Polaris-Avatar--styleTwo",
  "styleThree": "Polaris-Avatar--styleThree",
  "styleFour": "Polaris-Avatar--styleFour",
  "styleFive": "Polaris-Avatar--styleFive",
  "styleSix": "Polaris-Avatar--styleSix",
  "Image": "Polaris-Avatar__Image",
  "Initials": "Polaris-Avatar__Initials",
  "skeletonShimmerAnimation": "Polaris-Avatar--skeletonShimmerAnimation",
};

var avatar1 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzI0NWI0OH0uY2xzLTJ7ZmlsbDojMmRiMTY3fS5jbHMtM3tmaWxsOiNmZmZ9LmNscy00e2ZpbGw6IzhkYzk1OH0uY2xzLTV7ZmlsbDojZWJlZGYxO29wYWNpdHk6LjJ9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMCAwaDEwMHYxMDBIMHoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik02OSAwdjY1LjY1bC0yLS4wMXYxOS44NWwyIC4wMlYxMDBIMFYwaDY5eiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTY3IDY1LjY0djE5Ljg1bC0yNS41Ny0uMTlDMzIgODUuMjIgMjUuNiA4MS40NiAyNS42OCA3Mi4wNnMuMjUtNi43NC4yNS02Ljc0eiIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTg2Ljk5IDU4SDY5VjBoMTAuOTNsNy4wNiA1OHoiLz48cGF0aCBjbGFzcz0iY2xzLTUiIGQ9Ik0yNC41MyA0MC4yOWExMi4yMyAxMi4yMyAwIDAgMSAyNC40NiAwIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNNTkuNjIgNThBMTAuNjkgMTAuNjkgMCAwIDEgODEgNTh6Ii8+PC9zdmc+';

var avatar2 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzFlMjY1Y30uY2xzLTJ7ZmlsbDojNWQ2Y2MxfS5jbHMtMywuY2xzLTV7ZmlsbDojZmZmfS5jbHMtNHtmaWxsOiNmZmMwNGR9LmNscy01e3N0cm9rZTojZmZmO3N0cm9rZS1taXRlcmxpbWl0OjEwfTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTS0uMDEgMGgxMDB2MTAwaC0xMDB6Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNLS4wMSAwaDY5LjAydjEwMEgtLjAxeiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTY4LjkzIDY1Ljg4bC0yNC40NC0uMTktLjA1IDYuMDljMCA1LjIyIDMuNDggOS40NyA4LjY5IDkuNTJsMTUuOC4xMnoiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik02OC45MSAxMS4zbDE5LjE3IDQ2LjI5LTE5LjE3LS4xNlYxMS4zeiIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0iTTIzLjI1IDM2LjQzYTMuMjIgMy4yMiAwIDEgMCAwIDYuNDRtMjEuMDEtNi40NGEzLjIyIDMuMjIgMCAwIDAgMCA2LjQ0bS0xMy41NSAzLjc0YTMuMjIgMy4yMiAwIDEgMCAwIDYuNDRtMy4yMi0yNS41MWEzLjIyIDMuMjIgMCAwIDAgMCA2LjQ0Ii8+PC9zdmc+';

var avatar3 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzVkNmNjMX0uY2xzLTJ7ZmlsbDojNmRjYWNlfS5jbHMtM3tmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjVweH0uY2xzLTR7ZmlsbDojZWJlZGYxO29wYWNpdHk6LjJ9LmNscy01e2ZpbGw6I2ZmZn08L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0tLjAyIDBoMTAwdjEwMGgtMTAweiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTS4zOSAwaDY5LjAydjEwMEguMzl6Ii8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjQuMTggMzEuMjF2My40N0ExMC40MyAxMC40MyAwIDAgMCAzNC40IDQ1LjIxYTEwLjQzIDEwLjQzIDAgMCAwIDEwLjIyLTEwLjUzdi0zLjQ3Ii8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNMjAuMTEgNDkuMDdhMTYuMjIgMTYuMjIgMCAxIDEgMCAzMi40NCIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0iTTY5LjQ0IDE4LjgzTDkwIDcxSDY5LjQ0VjE4LjgzeiIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0iTTU3LjU5IDcxYTYgNiAwIDAgMSAxMiAweiIvPjwvc3ZnPg==';

var avatar4 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZTBjM30uY2xzLTJ7ZmlsbDojNWQ2Y2MxfS5jbHMtM3tmaWxsOiNmZjk2N2R9LmNscy00e2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NXB4fS5jbHMtNXtmaWxsOiNlYmVkZjE7b3BhY2l0eTouMn08L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0wLS4wMWgxMDB2MTAwSDB6Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMCAwaDY5LjAydjEwMEgweiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTY5LjAyIDBsMjQuMDMgNjEuNjlINjkuMDJWMHoiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0zMC42OSAzMS45MXYtM2MwLTQuNzggMy40Ni04LjY1IDgtOC42NXM4IDMuODcgOCA4LjY1djMiLz48cGF0aCBjbGFzcz0iY2xzLTUiIGQ9Ik0xMi43NiA1Ni4wNmExMy4zNiAxMy4zNiAwIDEgMSAyNi43MiAwIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNODAgNjEuNDZsLTI5LjM0LjIzdi03LjMzYzAtNi4yOCA0LjA3LTExLjM2IDEwLjM0LTExLjQ0bDE5LS4xNHoiLz48L3N2Zz4=';

var avatar5 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzhkYzk1OH0uY2xzLTJ7ZmlsbDojMmRiMTY3fS5jbHMtM3tmaWxsOiMyNDViNDh9LmNscy00e2ZpbGw6I2ViZWRmMTtvcGFjaXR5Oi4yfTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAgMGg3MC4wMnYxMDBIMHoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik02OS45MiAwdjU2LjMyTDQ5IDY3bC0uMyAyNS4wN1YxMDBIMTAwVjB6Ii8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNNTkuMjcgNTguMjlhNS4yMiA1LjIyIDAgMCAwLTkuNDMgNC40OCIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI3LjEyIDkuMzNoNDQuNTN2Mi4xOUgyNy4xMnptLTEyLjQxIDkuNDloNTYuOTR2Mi4xOUgxNC43MXoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtNCIgY3g9IjE5LjY2IiBjeT0iNDQuOCIgcj0iMTEuMjIiLz48L3N2Zz4=';

var avatar6 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZTBjM30uY2xzLTJ7ZmlsbDojZmY5NjdkfS5jbHMtM3tmaWxsOiMzMmNhYzZ9LmNscy00e2ZpbGw6IzAwOTc5Nn0uY2xzLTUsLmNscy02e2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMH0uY2xzLTV7c3Ryb2tlLXdpZHRoOjVweH0uY2xzLTZ7c3Ryb2tlLXdpZHRoOjRweH08L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0tLjAyLS4wMWgxMDB2MTAwaC0xMDB6Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMCAwaDY5LjQxdjEwMEgweiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTY5LjkyIDB2NDQuMzJMNTEuMzQgNTV2NDVIMTAwVjB6Ii8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMzkuMzIgNzZhMTEuODUgMTEuODUgMCAwIDAgMTIgMTEuNjJWNzYiLz48cGF0aCBjbGFzcz0iY2xzLTQiIGQ9Ik0zOS4zMiA3NmExMiAxMiAwIDAgMSAxMi0xMS44MlY3NiIvPjxwYXRoIGNsYXNzPSJjbHMtNSIgZD0iTTQzLjc0IDE5LjgzYTEyLjgyIDEyLjgyIDAgMSAxLTI1LjY0IDAiLz48cGF0aCBjbGFzcz0iY2xzLTYiIGQ9Ik0yNy4zOSAzMS42bC0xLjU4IDUuOTZtOS4zNy01LjcybDIuNTUgNS40N200LjI2LTkuODVsMy41MyA0LjVtLTI1LjQzLTQuNWwtMy41MyA0LjUiLz48L3N2Zz4=';

var avatar7 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzhkYzk1OH0uY2xzLTJ7ZmlsbDojMmRiMTY3fS5jbHMtM3tmaWxsOiNmZmZ9LmNscy00e2ZpbGw6IzI0NWI0OH08L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0wIDBoMTAwdjEwMC40OEgweiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTgzIDY4djMybC0xNC0uMTZ2LjE2SDBWMGg2OXY2OGgxNHoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02OS4yOSA0MS42OUgyMC42NnMtLjA5LTMtLjE3IDcuMTUgNyAxOC41MSAxNy4zNSAxOC41OWwzMS40NS41N3oiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik02OC43IDEyLjRsMTEuNTQgMjkuMjlINjguN1YxMi40eiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTYyLjIyIDQxLjY5YTMuMzQgMy4zNCAwIDEgMSA2LjY5IDB6Ii8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNNDEuNDUgMTguMDZhMi41NyAyLjU3IDAgMCAwLTUuMTQgME0zMy4zMyAyNGEyLjU3IDIuNTcgMCAxIDAtNS4xNCAwbTIwLjM2IDIuNThhMi41NyAyLjU3IDAgMSAwLTUuMTQgMCIvPjwvc3ZnPg==';

var avatar8 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZWRiOX0uY2xzLTJ7ZmlsbDpub25lO3N0cm9rZTojZmZmO3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDo1cHh9LmNscy0ze2ZpbGw6I2ZmYzA0ZH0uY2xzLTR7ZmlsbDojNWQ2Y2MxfTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNjQuNjMgMTcuMzNhMTcgMTcgMCAwIDEgNSAyOS43MiAxNi43NSAxNi43NSAwIDAgMS01IDIuNjIiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0wIDBoNjkuMDJ2MTAwSDB6Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSI0NS4xMSIgY3k9IjMzLjQ5IiByPSIxNi45OCIgdHJhbnNmb3JtPSJyb3RhdGUoLTM3LjAyIDQ1LjEyNCAzMy40OTMpIi8+PHBhdGggY2xhc3M9ImNscy00IiBkPSJNNjkuMDIgMzQuNDhsMTkuNDcgMzguNzQtMTkuNDcgMS41M1YzNC40OHoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik02MS42IDMzLjY3YTEwLjE3IDEwLjE3IDAgMCAxIDE1LjQuMDgiLz48L3N2Zz4=';

var avatar9 = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmYzA0ZH0uY2xzLTJ7ZmlsbDojNWQ2Y2MxfS5jbHMtM3tmaWxsOiM0MTIzNmV9LmNscy00e2ZpbGw6I2ViZWRmMTtvcGFjaXR5Oi4yfTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTAgMGgxMDB2MTAwSDB6Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMCAwaDY5LjQxdjEwMEgweiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTcwLjIxIDgwLjg4aC0xNS4xYy00LjgxIDAtNS42OC01Ljg0LTUuNjgtNS44NGgyMC43OCIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTgyIDYwLjQ4bC0xNCAuMjVWMGgxMC4xN0M4MC41OSAyMC4xNCA4MiA2MC40OCA4MiA2MC40OHoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik01Ny43MSA2MC40OGE1LjQ0IDUuNDQgMCAxIDEgMTAuODcgMCIvPjxjaXJjbGUgY2xhc3M9ImNscy00IiBjeD0iMjQuNzciIGN5PSI0MC4xOSIgcj0iMTEuMjIiLz48L3N2Zz4=';



var avatars = Object.freeze({
	avatarOne: avatar1,
	avatarTwo: avatar2,
	avatarThree: avatar3,
	avatarFour: avatar4,
	avatarFive: avatar5,
	avatarSix: avatar6,
	avatarSeven: avatar7,
	avatarEight: avatar8,
	avatarNine: avatar9
});

var STYLE_CLASSES = ['one', 'two', 'three', 'four', 'five', 'six'];
var AVATAR_IMAGES = Object.keys(avatars).map(function (key) {
    return avatars[key];
});
function Avatar$1(_ref) {
    var name = _ref.name,
        source = _ref.source,
        initials = _ref.initials,
        customer = _ref.customer,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 'medium' : _ref$size,
        accessibilityLabel = _ref.accessibilityLabel;

    var nameString = name || initials;
    var finalSource = void 0;
    var label = void 0;
    if (accessibilityLabel) {
        label = accessibilityLabel;
    } else if (name) {
        label = name;
    } else if (initials) {
        label = 'Avatar with initials ' + initials.split('').join(' ');
    } else {
        label = 'Avatar';
    }
    if (source) {
        finalSource = source;
    } else if (customer) {
        finalSource = customerPlaceholder(nameString);
    }
    var className = classNames(styles$1.Avatar, styles$1[variationName('style', styleClass(nameString))], size && styles$1[variationName('size', size)]);
    var imageMarkUp = finalSource ? createElement(Image$1, { className: styles$1.Image, source: finalSource, alt: '', role: 'presentation' }) : null;
    var initialsMarkup = initials ? createElement(
        'span',
        { 'aria-hidden': true, className: styles$1.Initials },
        initials
    ) : null;
    return createElement(
        'span',
        { 'aria-label': label, role: 'img', className: className },
        initialsMarkup,
        imageMarkUp
    );
}
function styleClass(name) {
    return name ? STYLE_CLASSES[name.charCodeAt(0) % STYLE_CLASSES.length] : STYLE_CLASSES[0];
}
function customerPlaceholder(name) {
    return name ? AVATAR_IMAGES[name.charCodeAt(0) % AVATAR_IMAGES.length] : AVATAR_IMAGES[0];
}

function handleMouseUpByBlurring(_ref) {
    var currentTarget = _ref.currentTarget;

    currentTarget.blur();
}

var scrollable = {
    props: { 'data-polaris-scrollable': true },
    selector: '[data-polaris-scrollable]'
};
var overlay = {
    props: { 'data-polaris-overlay': true },
    selector: '[data-polaris-overlay]'
};
var layer = {
    props: { 'data-polaris-layer': true },
    selector: '[data-polaris-layer]'
};
var unstyled = {
    props: { 'data-polaris-unstyled': true },
    selector: '[data-polaris-unstyled]'
};

var LinkComponent = void 0;

var UnstyledLink$1 = function (_React$PureComponent) {
    _inherits(UnstyledLink, _React$PureComponent);

    function UnstyledLink() {
        _classCallCheck(this, UnstyledLink);

        return _possibleConstructorReturn(this, (UnstyledLink.__proto__ || Object.getPrototypeOf(UnstyledLink)).apply(this, arguments));
    }

    _createClass(UnstyledLink, [{
        key: 'render',
        value: function render() {
            if (LinkComponent) {
                return createElement(LinkComponent, Object.assign({}, unstyled.props, this.props));
            }
            var _a = this.props,
                external = _a.external,
                url = _a.url,
                rest = __rest(_a, ["external", "url"]);
            var target = external ? '_blank' : undefined;
            var rel = external ? 'noopener noreferrer' : undefined;
            return createElement('a', Object.assign({ target: target }, rest, { href: url, rel: rel }, unstyled.props));
        }
    }], [{
        key: 'use',
        value: function use(NewLinkComponent) {
            LinkComponent = NewLinkComponent;
        }
    }]);

    return UnstyledLink;
}(PureComponent);

var add = {"viewBox":"0 0 20 20","body":"<path d=\"M17 9h-6V3a1 1 0 1 0-2 0v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2\"  fill-rule=\"evenodd\"/>"};

var alert = {"viewBox":"0 0 20 20","body":"<path d=\"M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-8h2V6H9v4zm0 4h2v-2H9v2z\"  fill-rule=\"evenodd\"/>"};

var arrowDown = {"viewBox":"0 0 20 20","body":"<path d=\"M10.707 17.707l5-5a.999.999 0 1 0-1.414-1.414L11 14.586V3a1 1 0 1 0-2 0v11.586l-3.293-3.293a.999.999 0 1 0-1.414 1.414l5 5a.999.999 0 0 0 1.414 0\"  fill-rule=\"evenodd\"/>"};

var arrowLeft = {"viewBox":"0 0 20 20","body":"<path d=\"M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2\"  fill-rule=\"evenodd\"/>"};

var arrowRight = {"viewBox":"0 0 20 20","body":"<path d=\"M17.707 9.293l-5-5a.999.999 0 1 0-1.414 1.414L14.586 9H3a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414\"  fill-rule=\"evenodd\"/>"};

var arrowUp = {"viewBox":"0 0 20 20","body":"<path d=\"M11 17V5.414l3.293 3.293a.999.999 0 1 0 1.414-1.414l-5-5a.999.999 0 0 0-1.414 0l-5 5a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0L9 5.414V17a1 1 0 1 0 2 0\"  fill-rule=\"evenodd\"/>"};

var arrowUpDown = {"viewBox":"0 0 20 20","body":"<path d=\"M13 8l-3-3-3 3h6zm-.1 4L10 14.9 7.1 12h5.8z\"  fill-rule=\"evenodd\"/>"};

var calendar = {"viewBox":"0 0 20 20","body":"<path d=\"M4 8h12V6H4v2zm9 4h2v-2h-2v2zm-4 0h2v-2H9v2zm0 4h2v-2H9v2zm-4-4h2v-2H5v2zm0 4h2v-2H5v2zM17 4h-2V3a1 1 0 1 0-2 0v1H7V3a1 1 0 1 0-2 0v1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z\"  fill-rule=\"evenodd\"/>"};

var cancel = {"viewBox":"0 0 20 20","body":"<path d=\"M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z\"  fill-rule=\"evenodd\"/>"};

var cancelSmall = {"viewBox":"0 0 20 20","body":"<path d=\"M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z\"  fill-rule=\"evenodd\"/>"};

var caretDown = {"viewBox":"0 0 20 20","body":"<path d=\"M5 8l5 5 5-5z\"  fill-rule=\"evenodd\"/>"};

var caretUp = {"viewBox":"0 0 20 20","body":"<path d=\"M15 12l-5-5-5 5z\" />"};

var checkmark = {"viewBox":"0 0 20 20","body":"<g  fill-rule=\"evenodd\"><path d=\"M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.437.437 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0\"/><path d=\"M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.437.437 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0\"/></g>"};

var chevronDown = {"viewBox":"0 0 20 20","body":"<path d=\"M10 14a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 1 1 1.414-1.414L10 11.586l4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5A.997.997 0 0 1 10 14\"  fill-rule=\"evenodd\"/>"};

var chevronLeft = {"viewBox":"0 0 20 20","body":"<path d=\"M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16\"  fill-rule=\"evenodd\"/>"};

var chevronRight = {"viewBox":"0 0 20 20","body":"<path d=\"M8 16a.999.999 0 0 1-.707-1.707L11.586 10 7.293 5.707a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5A.997.997 0 0 1 8 16\"  fill-rule=\"evenodd\"/>"};

var chevronUp = {"viewBox":"0 0 20 20","body":"<path d=\"M15 13a.997.997 0 0 1-.707-.293L10 8.414l-4.293 4.293a.999.999 0 1 1-1.414-1.414l5-5a.999.999 0 0 1 1.414 0l5 5A.999.999 0 0 1 15 13\"  fill-rule=\"evenodd\"/>"};

var circleCancel = {"viewBox":"0 0 20 20","body":"<path d=\"M14.242 12.829l-1.414 1.414L10 11.413l-2.828 2.83-1.414-1.414 2.828-2.83-2.828-2.827 1.414-1.414L10 8.586l2.828-2.828 1.414 1.414L11.414 10l2.828 2.829zM10 1.999A8 8 0 1 0 10 18a8 8 0 0 0 0-16z\"  fill-rule=\"evenodd\"/>"};

var circleChevronDown = {"viewBox":"0 0 20 20","body":"<path d=\"M10 13.414L5.293 8.707l1.414-1.414L10 10.586l3.293-3.293 1.414 1.414L10 13.414zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z\"  fill-rule=\"evenodd\"/>"};

var circleChevronLeft = {"viewBox":"0 0 20 20","body":"<path d=\"M11.293 5.293l1.414 1.414L9.414 10l3.293 3.293-1.414 1.414L6.586 10l4.707-4.707zM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z\"  fill-rule=\"evenodd\"/>"};

var circleChevronRight = {"viewBox":"0 0 20 20","body":"<path d=\"M8.707 14.707l-1.414-1.414L10.586 10 7.293 6.707l1.414-1.414L13.414 10l-4.707 4.707zM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16z\"  fill-rule=\"evenodd\"/>"};

var circleChevronUp = {"viewBox":"0 0 20 20","body":"<path d=\"M14.707 11.293l-1.414 1.414L10 9.414l-3.293 3.293-1.414-1.414L10 6.586l4.707 4.707zM18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0z\"  fill-rule=\"evenodd\"/>"};

var circlePlus = {"viewBox":"0 0 20 20","body":"<path d=\"M15 11h-4v4H9v-4H5V9h4V5h2v4h4v2zm-5-9a8 8 0 1 0 0 16 8 8 0 0 0 0-16z\"  fill-rule=\"evenodd\"/>"};

var conversation = {"viewBox":"0 0 20 20","body":"<path d=\"M13 11h2V9h-2v2zm-4 0h2V9H9v2zm-4 0h2V9H5v2zm5-9c-4.411 0-8 3.589-8 8 0 1.504.425 2.908 1.15 4.111l-1.069 2.495a1 1 0 0 0 1.314 1.313l2.494-1.069A7.939 7.939 0 0 0 10 18c4.411 0 8-3.589 8-8s-3.589-8-8-8z\"  fill-rule=\"evenodd\"/>"};

var deleteIcon = {"viewBox":"0 0 20 20","body":"<path d=\"M16 6H4a1 1 0 1 0 0 2h1v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8h1a1 1 0 1 0 0-2zM9 4a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2H9zm2 12h2V8h-2v8zm-4 0h2V8H7v8z\"  fill-rule=\"evenodd\"/>"};

var disable = {"viewBox":"0 0 20 20","body":"<path d=\"M10 16a5.961 5.961 0 0 1-3.471-1.115l8.356-8.356A5.961 5.961 0 0 1 16 10c0 3.309-2.691 6-6 6m0-12c1.294 0 2.49.416 3.471 1.115l-8.356 8.356A5.961 5.961 0 0 1 4 10c0-3.309 2.691-6 6-6m0-2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8\"  fill-rule=\"evenodd\"/>"};

var dispute = {"viewBox":"0 0 20 20","body":"<path d=\"M9 10h2V6H9v4zm0 4h2v-2H9v2zm-7-4c0 4.411 3.589 8 8 8a7.939 7.939 0 0 0 4.111-1.15l2.494 1.069a1 1 0 0 0 1.314-1.313l-1.069-2.495A7.939 7.939 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8z\"  fill-rule=\"evenodd\"/>"};

var duplicate = {"viewBox":"0 0 20 20","body":"<path d=\"M8 12h8V4H8v8zm4 4H4V8h2v5a1 1 0 0 0 1 1h5v2zm5-14H7a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z\"  fill-rule=\"evenodd\"/>"};

var embed = {"viewBox":"0 0 20 20","body":"<path d=\"M17 13a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a1 1 0 1 1 2 0v2h12v-2a1 1 0 0 1 1-1zm0-11a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V4H4v2a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1h14zm.555 7.168a1.001 1.001 0 0 1 0 1.664l-3 2a1 1 0 0 1-1.109-1.664L15.198 10l-1.752-1.168a1 1 0 1 1 1.109-1.664l3 2zM6.832 7.445a1 1 0 0 1-.277 1.387L4.803 10l1.752 1.168a1 1 0 1 1-1.11 1.664l-3-2a1.001 1.001 0 0 1 0-1.664l3-2a1 1 0 0 1 1.387.277zM9 14.001a1 1 0 0 1-.948-1.317l2-6a1 1 0 0 1 1.896.633l-2 6A.999.999 0 0 1 9 14z\"  fill-rule=\"evenodd\"/>"};

var exportIcon = {"viewBox":"0 0 20 20","body":"<path d=\"M9.293 13.707l-3-3a.999.999 0 1 1 1.414-1.414L9 10.586V3a1 1 0 1 1 2 0v7.586l1.293-1.293a.999.999 0 1 1 1.414 1.414l-3 3a.999.999 0 0 1-1.414 0zM17 16a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h14z\"/>"};

var external = {"viewBox":"0 0 20 20","body":"<path d=\"M17 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V5.414l-7.293 7.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 4H13a1 1 0 1 1 0-2h4zm-4 9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H4v8h8v-4a1 1 0 0 1 1-1z\"  fill-rule=\"evenodd\"/>"};

var help = {"viewBox":"0 0 20 20","body":"<circle cx=\"10\" cy=\"10\" r=\"9\" fill=\"currentColor\"/><path d=\"M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-4a1 1 0 1 0 0 2 1 1 0 1 0 0-2m0-10C8.346 4 7 5.346 7 7a1 1 0 1 0 2 0 1.001 1.001 0 1 1 1.591.808C9.58 8.548 9 9.616 9 10.737V11a1 1 0 1 0 2 0v-.263c0-.653.484-1.105.773-1.317A3.013 3.013 0 0 0 13 7c0-1.654-1.346-3-3-3\" />"};

var horizontalDots = {"viewBox":"0 0 20 20","body":"<path d=\"M6 10a2 2 0 1 1-4.001-.001A2 2 0 0 1 6 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 12 10zm6 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 18 10z\"  fill-rule=\"evenodd\"/>"};

var importIcon = {"viewBox":"0 0 20 20","body":"<path d=\"M13.707 6.707a.997.997 0 0 1-1.414 0L11 5.414V13a1 1 0 1 1-2 0V5.414L7.707 6.707a.999.999 0 1 1-1.414-1.414l3-3a.999.999 0 0 1 1.414 0l3 3a.999.999 0 0 1 0 1.414zM17 18H3a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z\"/>"};

var notes = {"viewBox":"0 0 20 20","body":"<path d=\"M6 11h8V9H6v2zm0 4h8v-2H6v2zm0-8h4V5H6v2zm9.707-1.707l-3-3A.996.996 0 0 0 12 2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a.997.997 0 0 0-.293-.707z\"  fill-rule=\"evenodd\"/>"};

var print = {"viewBox":"0 0 20 20","body":"<path d=\"M14 11h2V9h-2v2zM7 7h6V4H7v3zm0 9h6v-2H7v2zm10-9h-2V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z\"  fill-rule=\"evenodd\"/>"};

var subtract = {"viewBox":"0 0 20 20","body":"<path d=\"M15 9H5a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2\"  fill-rule=\"evenodd\"/>"};

var refresh = {"viewBox":"0 0 20 20","body":"<path d=\"M17 11a1 1 0 0 1 1 1c0 1.654-1.346 3-3 3H5.414l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L5.414 13H15c.552 0 1-.449 1-1a1 1 0 0 1 1-1zM3 9a1 1 0 0 1-1-1c0-1.654 1.346-3 3-3h9.586l-1.293-1.293a.999.999 0 1 1 1.414-1.414l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 7H5c-.552 0-1 .449-1 1a1 1 0 0 1-1 1z\"  fill-rule=\"evenodd\"/>"};

var risk = {"viewBox":"0 0 20 20","body":"<path d=\"M9 12h2V8H9v4zm0 4h2v-2H9v2zm8.895.509l-7-14c-.339-.678-1.451-.678-1.79 0l-7 14A.999.999 0 0 0 3 17.956h14a1.001 1.001 0 0 0 .895-1.447z\"  fill-rule=\"evenodd\"/>"};

var save = {"viewBox":"0 0 20 20","body":"<path d=\"M17 4h-3a1 1 0 1 0 0 2h2v10H4V4h3.586L9 5.414v5.172L7.707 9.293a1 1 0 0 0-1.414 1.414l3 3a.996.996 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 10.586V5a.997.997 0 0 0-.293-.707l-2-2A.994.994 0 0 0 8 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z\"/>"};

var search = {"viewBox":"0 0 20 20","body":"<path d=\"M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414\"  fill-rule=\"evenodd\"/>"};

var view = {"viewBox":"0 0 20 20","body":"<path d=\"M17.928 9.628C17.836 9.399 15.611 4 9.999 4S2.162 9.399 2.07 9.628a1.017 1.017 0 0 0 0 .744C2.162 10.601 4.387 16 9.999 16s7.837-5.399 7.929-5.628a1.017 1.017 0 0 0 0-.744zM9.999 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-6A2 2 0 1 0 10 12.001 2 2 0 0 0 10 8z\"/>"};

var styles$2 = {
  "Icon": "Polaris-Icon",
  "hasBackdrop": "Polaris-Icon--hasBackdrop",
  "colorWhite": "Polaris-Icon--colorWhite",
  "colorBlack": "Polaris-Icon--colorBlack",
  "colorSkyLighter": "Polaris-Icon--colorSkyLighter",
  "colorSkyLight": "Polaris-Icon--colorSkyLight",
  "colorSky": "Polaris-Icon--colorSky",
  "colorSkyDark": "Polaris-Icon--colorSkyDark",
  "colorInkLightest": "Polaris-Icon--colorInkLightest",
  "colorInkLighter": "Polaris-Icon--colorInkLighter",
  "colorInkLight": "Polaris-Icon--colorInkLight",
  "colorInk": "Polaris-Icon--colorInk",
  "colorBlueLighter": "Polaris-Icon--colorBlueLighter",
  "colorBlueLight": "Polaris-Icon--colorBlueLight",
  "colorBlue": "Polaris-Icon--colorBlue",
  "colorBlueDark": "Polaris-Icon--colorBlueDark",
  "colorBlueDarker": "Polaris-Icon--colorBlueDarker",
  "colorIndigoLighter": "Polaris-Icon--colorIndigoLighter",
  "colorIndigoLight": "Polaris-Icon--colorIndigoLight",
  "colorIndigo": "Polaris-Icon--colorIndigo",
  "colorIndigoDark": "Polaris-Icon--colorIndigoDark",
  "colorIndigoDarker": "Polaris-Icon--colorIndigoDarker",
  "colorTealLighter": "Polaris-Icon--colorTealLighter",
  "colorTealLight": "Polaris-Icon--colorTealLight",
  "colorTeal": "Polaris-Icon--colorTeal",
  "colorTealDark": "Polaris-Icon--colorTealDark",
  "colorTealDarker": "Polaris-Icon--colorTealDarker",
  "colorGreenLighter": "Polaris-Icon--colorGreenLighter",
  "colorGreen": "Polaris-Icon--colorGreen",
  "colorGreenDark": "Polaris-Icon--colorGreenDark",
  "colorYellowLighter": "Polaris-Icon--colorYellowLighter",
  "colorYellow": "Polaris-Icon--colorYellow",
  "colorYellowDark": "Polaris-Icon--colorYellowDark",
  "colorOrange": "Polaris-Icon--colorOrange",
  "colorOrangeDark": "Polaris-Icon--colorOrangeDark",
  "colorRedLighter": "Polaris-Icon--colorRedLighter",
  "colorRed": "Polaris-Icon--colorRed",
  "colorRedDark": "Polaris-Icon--colorRedDark",
  "colorPurple": "Polaris-Icon--colorPurple",
  "Svg": "Polaris-Icon__Svg",
  "Placeholder": "Polaris-Icon__Placeholder",
  "skeletonShimmerAnimation": "Polaris-Icon--skeletonShimmerAnimation",
};

var BUNDLED_ICONS = {
    add: add,
    alert: alert,
    arrowDown: arrowDown,
    arrowLeft: arrowLeft,
    arrowRight: arrowRight,
    arrowUp: arrowUp,
    arrowUpDown: arrowUpDown,
    calendar: calendar,
    cancel: cancel,
    cancelSmall: cancelSmall,
    caretDown: caretDown,
    caretUp: caretUp,
    checkmark: checkmark,
    chevronDown: chevronDown,
    chevronLeft: chevronLeft,
    chevronRight: chevronRight,
    chevronUp: chevronUp,
    circleCancel: circleCancel,
    circleChevronDown: circleChevronDown,
    circleChevronLeft: circleChevronLeft,
    circleChevronRight: circleChevronRight,
    circleChevronUp: circleChevronUp,
    circlePlus: circlePlus,
    conversation: conversation,
    delete: deleteIcon,
    disable: disable,
    dispute: dispute,
    duplicate: duplicate,
    embed: embed,
    export: exportIcon,
    external: external,
    help: help,
    horizontalDots: horizontalDots,
    import: importIcon,
    notes: notes,
    print: print,
    refresh: refresh,
    risk: risk,
    save: save,
    search: search,
    subtract: subtract,
    view: view
};
var COLORS_WITH_BACKDROPS = ['teal', 'tealDark', 'greenDark', 'redDark', 'yellowDark', 'ink', 'inkLighter'];
function Icon$1(_ref) {
    var source = _ref.source,
        color = _ref.color,
        backdrop = _ref.backdrop,
        accessibilityLabel = _ref.accessibilityLabel;

    if (color && backdrop && COLORS_WITH_BACKDROPS.indexOf(color) < 0) {
        // tslint:disable-next-line no-console
        console.warn('The ' + color + ' icon doesn\u2019t accept backdrops. The icon colors that have backdrops are: ' + COLORS_WITH_BACKDROPS.join(', '));
    }
    var className = classNames(styles$2.Icon, color && styles$2[variationName('color', color)], backdrop && styles$2.hasBackdrop);
    var contentMarkup = void 0;
    if (source === 'placeholder') {
        contentMarkup = createElement('div', { className: styles$2.Placeholder });
    } else {
        var iconSource = typeof source === 'string' ? BUNDLED_ICONS[source] : source;
        contentMarkup = createElement('svg', { className: styles$2.Svg, viewBox: iconSource.viewBox, dangerouslySetInnerHTML: { __html: iconSource.body } });
    }
    return createElement(
        'span',
        { className: className, 'aria-label': accessibilityLabel },
        contentMarkup
    );
}

var styles$3 = {
  "Spinner": "Polaris-Spinner",
  "loading": "Polaris-Spinner--loading",
  "sizeSmall": "Polaris-Spinner--sizeSmall",
  "sizeLarge": "Polaris-Spinner--sizeLarge",
  "colorWhite": "Polaris-Spinner--colorWhite",
  "colorTeal": "Polaris-Spinner--colorTeal",
  "colorInkLightest": "Polaris-Spinner--colorInkLightest",
  "skeletonShimmerAnimation": "Polaris-Spinner--skeletonShimmerAnimation",
};

var spinnerSVGLarge = {"viewBox":"0 0 44 44","body":"<path d=\"M15.542 1.487A21.507 21.507 0 0 0 .5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 0 0-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 1 0-.9-2.863z\" />"};

var spinnerSVGSmall = {"viewBox":"0 0 20 20","body":"<path d=\"M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z\" />"};

var COLORS_FOR_LARGE_SPINNER = ['teal', 'inkLightest'];
function Spinner$1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === undefined ? 'large' : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? 'teal' : _ref$color,
        accessibilityLabel = _ref.accessibilityLabel;

    if (size === 'large' && COLORS_FOR_LARGE_SPINNER.indexOf(color) < 0) {
        if (process.env.NODE_ENV === 'development') {
            // tslint:disable-next-line no-console
            console.warn('The color ' + color + ' is not meant to be used on ' + size + ' spinners. The colors available on large spinners are: ' + COLORS_FOR_LARGE_SPINNER.join(', '));
        }
        size = 'small';
    }
    var className = classNames(styles$3.Spinner, color && styles$3[variationName('color', color)], size && styles$3[variationName('size', size)]);
    var spinnerSVG = size === 'large' ? spinnerSVGLarge : spinnerSVGSmall;
    return createElement('svg', { viewBox: spinnerSVG.viewBox, dangerouslySetInnerHTML: { __html: spinnerSVG.body }, className: className, 'aria-label': accessibilityLabel, role: 'status' });
}

var styles$4 = {
  "Button": "Polaris-Button",
  "disabled": "Polaris-Button--disabled",
  "primary": "Polaris-Button--primary",
  "destructive": "Polaris-Button--destructive",
  "outline": "Polaris-Button--outline",
  "loading": "Polaris-Button--loading",
  "Spinner": "Polaris-Button__Spinner",
  "plain": "Polaris-Button--plain",
  "Content": "Polaris-Button__Content",
  "fullWidth": "Polaris-Button--fullWidth",
  "sizeSlim": "Polaris-Button--sizeSlim",
  "sizeLarge": "Polaris-Button--sizeLarge",
  "iconOnly": "Polaris-Button--iconOnly",
  "Icon": "Polaris-Button__Icon",
  "skeletonShimmerAnimation": "Polaris-Button--skeletonShimmerAnimation",
};

function Button$1(_ref) {
    var url = _ref.url,
        disabled = _ref.disabled,
        loading = _ref.loading,
        children = _ref.children,
        accessibilityLabel = _ref.accessibilityLabel,
        onClick = _ref.onClick,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        external = _ref.external,
        icon = _ref.icon,
        primary = _ref.primary,
        outline = _ref.outline,
        destructive = _ref.destructive,
        disclosure = _ref.disclosure,
        plain = _ref.plain,
        submit = _ref.submit,
        size = _ref.size,
        fullWidth = _ref.fullWidth;

    var isDisabled = disabled || loading;
    var className = classNames$1(styles$4.Button, primary && styles$4.primary, outline && styles$4.outline, destructive && styles$4.destructive, isDisabled && styles$4.disabled, loading && styles$4.loading, plain && styles$4.plain, size && styles$4[variationName$1('size', size)], fullWidth && styles$4.fullWidth, icon && children == null && styles$4.iconOnly);
    var disclosureIconMarkup = disclosure ? createElement(
        'span',
        { className: styles$4.Icon },
        createElement(Icon$1, { source: loading ? 'placeholder' : 'caretDown' })
    ) : null;
    var iconMarkup = icon ? createElement(
        'span',
        { className: styles$4.Icon },
        createElement(Icon$1, { source: loading ? 'placeholder' : icon })
    ) : null;
    var childMarkup = children ? createElement(
        'span',
        null,
        children
    ) : null;
    var spinnerColor = primary || destructive ? 'white' : 'inkLightest';
    var spinnerSVGMarkup = loading ? createElement(
        'span',
        { className: styles$4.Spinner },
        createElement(Spinner$1, { size: 'small', color: spinnerColor, accessibilityLabel: 'Loading' })
    ) : null;
    var content = iconMarkup || disclosureIconMarkup ? createElement(
        'span',
        { className: styles$4.Content },
        spinnerSVGMarkup,
        iconMarkup,
        childMarkup,
        disclosureIconMarkup
    ) : createElement(
        'span',
        { className: styles$4.Content },
        spinnerSVGMarkup,
        childMarkup
    );
    var type = submit ? 'submit' : 'button';
    return url ? createElement(
        UnstyledLink$1,
        { url: url, external: external, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onMouseUp: handleMouseUpByBlurring, className: className, disabled: isDisabled, 'aria-label': accessibilityLabel },
        content
    ) : createElement(
        'button',
        { type: type, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onMouseUp: handleMouseUpByBlurring, className: className, disabled: isDisabled, 'aria-label': accessibilityLabel, role: loading ? 'alert' : undefined, 'aria-busy': loading ? true : undefined },
        content
    );
}
function buttonsFrom(actions) {
    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (actions.length != null) {
        return actions.map(function (action, index) {
            return buttonFrom(action, overrides, index);
        });
    } else {
        return buttonFrom(actions, overrides);
    }
}
function buttonFrom(_a, overrides, key) {
    var content = _a.content,
        onAction = _a.onAction,
        action = __rest(_a, ["content", "onAction"]);

    return createElement(Button$1, Object.assign({ key: key, children: content, onClick: onAction }, action, overrides));
}

var styles$5 = {
  "ButtonGroup": "Polaris-ButtonGroup",
  "segmented": "Polaris-ButtonGroup--segmented",
  "Item": "Polaris-ButtonGroup__Item",
  "Item-focused": "Polaris-ButtonGroup__Item--focused",
  "Item-plain": "Polaris-ButtonGroup__Item--plain",
  "skeletonShimmerAnimation": "Polaris-ButtonGroup--skeletonShimmerAnimation",
};

var Item = function (_React$PureComponent) {
    _inherits(Item, _React$PureComponent);

    function Item() {
        _classCallCheck(this, Item);

        var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));

        _this.state = { focused: false };
        return _this;
    }

    _createClass(Item, [{
        key: 'render',
        value: function render() {
            var button = this.props.button;
            var focused = this.state.focused;

            var className = classNames(styles$5.Item, focused && styles$5['Item-focused'], button.props.plain && styles$5['Item-plain']);
            return createElement(
                'div',
                { className: className, onFocus: this.handleFocus, onBlur: this.handleBlur },
                button
            );
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus() {
            this.setState({ focused: true });
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur() {
            this.setState({ focused: false });
        }
    }]);

    return Item;
}(PureComponent);

__decorate([autobind], Item.prototype, "handleFocus", null);
__decorate([autobind], Item.prototype, "handleBlur", null);

function ButtonGroup$1(_ref) {
    var children = _ref.children,
        segmented = _ref.segmented;

    var className = classNames(styles$5.ButtonGroup, segmented && styles$5.segmented);
    var contents = elementChildren(children).map(function (child, index) {
        return createElement(Item, { button: child, key: index });
    });
    return createElement(
        'div',
        { className: className },
        contents
    );
}

var styles$6 = {
  "Stack": "Polaris-Stack",
  "Item": "Polaris-Stack__Item",
  "noWrap": "Polaris-Stack--noWrap",
  "vertical": "Polaris-Stack--vertical",
  "spacingNone": "Polaris-Stack--spacingNone",
  "spacingExtraTight": "Polaris-Stack--spacingExtraTight",
  "spacingTight": "Polaris-Stack--spacingTight",
  "spacingLoose": "Polaris-Stack--spacingLoose",
  "spacingExtraLoose": "Polaris-Stack--spacingExtraLoose",
  "distributionLeading": "Polaris-Stack--distributionLeading",
  "distributionTrailing": "Polaris-Stack--distributionTrailing",
  "distributionCenter": "Polaris-Stack--distributionCenter",
  "distributionEqualSpacing": "Polaris-Stack--distributionEqualSpacing",
  "distributionFill": "Polaris-Stack--distributionFill",
  "distributionFillEvenly": "Polaris-Stack--distributionFillEvenly",
  "alignmentLeading": "Polaris-Stack--alignmentLeading",
  "alignmentTrailing": "Polaris-Stack--alignmentTrailing",
  "alignmentCenter": "Polaris-Stack--alignmentCenter",
  "alignmentFill": "Polaris-Stack--alignmentFill",
  "alignmentBaseline": "Polaris-Stack--alignmentBaseline",
  "Item-fill": "Polaris-Stack__Item--fill",
  "skeletonShimmerAnimation": "Polaris-Stack--skeletonShimmerAnimation",
};

function Item$2(_ref) {
    var children = _ref.children,
        fill = _ref.fill;

    var className = classNames(styles$6.Item, fill && styles$6['Item-fill']);
    return createElement(
        'div',
        { className: className },
        children
    );
}

var Stack$1 = function (_React$PureComponent) {
    _inherits(Stack, _React$PureComponent);

    function Stack() {
        _classCallCheck(this, Stack);

        return _possibleConstructorReturn(this, (Stack.__proto__ || Object.getPrototypeOf(Stack)).apply(this, arguments));
    }

    _createClass(Stack, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                vertical = _props.vertical,
                spacing = _props.spacing,
                distribution = _props.distribution,
                alignment = _props.alignment,
                wrap = _props.wrap;

            var className = classNames(styles$6.Stack, vertical && styles$6.vertical, spacing && styles$6[variationName('spacing', spacing)], distribution && styles$6[variationName('distribution', distribution)], alignment && styles$6[variationName('alignment', alignment)], wrap === false && styles$6.noWrap);
            var itemMarkup = elementChildren(children).map(function (child, index) {
                var props = { key: index };
                return wrapWithComponent(child, Item$2, props);
            });
            return createElement(
                'div',
                { className: className },
                itemMarkup
            );
        }
    }]);

    return Stack;
}(PureComponent);

Stack$1.Item = Item$2;

var styles$7 = {
  "Heading": "Polaris-Heading",
  "skeletonShimmerAnimation": "Polaris-Heading--skeletonShimmerAnimation",
};

function Heading$1(_ref) {
    var _ref$element = _ref.element,
        Element = _ref$element === undefined ? 'h2' : _ref$element,
        children = _ref.children;

    return createElement(
        Element,
        { className: styles$7.Heading },
        children
    );
}

var styles$8 = {
  "Card": "Polaris-Card",
  "subdued": "Polaris-Card--subdued",
  "Header": "Polaris-Card__Header",
  "Section": "Polaris-Card__Section",
  "Section-subdued": "Polaris-Card__Section--subdued",
  "SectionHeader": "Polaris-Card__SectionHeader",
  "Footer": "Polaris-Card__Footer",
  "skeletonShimmerAnimation": "Polaris-Card--skeletonShimmerAnimation",
};

function Header(_ref) {
  var children = _ref.children,
      actions = _ref.actions;

  var actionMarkup = actions ? createElement(
    ButtonGroup$1,
    null,
    buttonsFrom(actions, { plain: true })
  ) : null;
  var headingMarkup = actionMarkup ? createElement(
    Stack$1,
    { alignment: 'baseline' },
    createElement(
      Stack$1.Item,
      { fill: true },
      createElement(
        Heading$1,
        null,
        children
      )
    ),
    actionMarkup
  ) : createElement(
    Heading$1,
    null,
    children
  );
  return createElement(
    'div',
    { className: styles$8.Header },
    headingMarkup
  );
}

var styles$9 = {
  "Subheading": "Polaris-Subheading",
  "skeletonShimmerAnimation": "Polaris-Subheading--skeletonShimmerAnimation",
};

function Subheading$1(_ref) {
    var _ref$element = _ref.element,
        Element = _ref$element === undefined ? 'h3' : _ref$element,
        children = _ref.children;

    var ariaLabel = typeof children === 'string' ? children : null;
    return createElement(
        Element,
        { 'aria-label': ariaLabel, className: styles$9.Subheading },
        children
    );
}

function Section(_ref) {
    var children = _ref.children,
        title = _ref.title,
        subdued = _ref.subdued;

    var headerContent = title ? createElement(
        'div',
        { className: styles$8.SectionHeader },
        createElement(
            Subheading$1,
            null,
            title
        )
    ) : null;
    var className = classNames(styles$8.Section, subdued && styles$8['Section-subdued']);
    return createElement(
        'div',
        { className: className },
        headerContent,
        children
    );
}

var Card$1 = function (_React$PureComponent) {
    _inherits(Card, _React$PureComponent);

    function Card() {
        _classCallCheck(this, Card);

        return _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
    }

    _createClass(Card, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                title = _props.title,
                subdued = _props.subdued,
                sectioned = _props.sectioned,
                actions = _props.actions,
                primaryFooterAction = _props.primaryFooterAction,
                secondaryFooterAction = _props.secondaryFooterAction;

            var className = classNames(styles$8.Card, subdued && styles$8.subdued);
            var headerMarkup = title ? createElement(
                Header,
                { actions: actions },
                title
            ) : null;
            var content = sectioned ? createElement(
                Section,
                null,
                children
            ) : children;
            var primaryFooterActionMarkup = primaryFooterAction ? buttonFrom(primaryFooterAction, { primary: true }) : null;
            var secondaryFooterActionMarkup = secondaryFooterAction ? buttonFrom(secondaryFooterAction) : null;
            var footerMarkup = primaryFooterActionMarkup || secondaryFooterActionMarkup ? createElement(
                'div',
                { className: styles$8.Footer },
                createElement(
                    ButtonGroup$1,
                    null,
                    primaryFooterActionMarkup,
                    secondaryFooterActionMarkup
                )
            ) : null;
            return createElement(
                'div',
                { className: className },
                headerMarkup,
                content,
                footerMarkup
            );
        }
    }]);

    return Card;
}(PureComponent);

Card$1.Section = Section;

var styles$10 = {
  "SettingAction": "Polaris-SettingAction",
  "Setting": "Polaris-SettingAction__Setting",
  "Action": "Polaris-SettingAction__Action",
  "skeletonShimmerAnimation": "Polaris-SettingAction--skeletonShimmerAnimation",
};

function SettingAction$1(_ref) {
  var action = _ref.action,
      children = _ref.children;

  return createElement(
    'div',
    { className: styles$10.SettingAction },
    createElement(
      'div',
      { className: styles$10.Setting },
      children
    ),
    createElement(
      'div',
      { className: styles$10.Action },
      action
    )
  );
}

var styles$11 = {
  "variationPositive": "Polaris-TextStyle--variationPositive",
  "variationNegative": "Polaris-TextStyle--variationNegative",
  "variationStrong": "Polaris-TextStyle--variationStrong",
  "variationSubdued": "Polaris-TextStyle--variationSubdued",
  "skeletonShimmerAnimation": "Polaris-TextStyle--skeletonShimmerAnimation",
};

function TextStyle$1(_ref) {
    var variation = _ref.variation,
        children = _ref.children;

    var className = classNames(variation && styles$11[variationName('variation', variation)]);
    return createElement(
        'span',
        { className: className },
        children
    );
}

var styles$12 = {
  "TermsOfService": "Polaris-AccountConnection__TermsOfService",
  "Content": "Polaris-AccountConnection__Content",
  "skeletonShimmerAnimation": "Polaris-AccountConnection--skeletonShimmerAnimation",
};

function AccountConnection$1(_ref) {
    var _ref$connected = _ref.connected,
        connected = _ref$connected === undefined ? false : _ref$connected,
        action = _ref.action,
        avatarUrl = _ref.avatarUrl,
        _ref$accountName = _ref.accountName,
        accountName = _ref$accountName === undefined ? '' : _ref$accountName,
        title = _ref.title,
        details = _ref.details,
        termsOfService = _ref.termsOfService;

    var initials = accountName ? accountName.split(/\s+/).map(function (name) {
        return name[0];
    }).join('') : undefined;
    var avatarMarkup = connected ? createElement(Avatar$1, { accessibilityLabel: '', name: accountName, initials: initials, source: avatarUrl }) : null;
    var titleMarkup = null;
    if (title) {
        titleMarkup = createElement(
            'div',
            null,
            title
        );
    } else if (accountName) {
        titleMarkup = createElement(
            'div',
            null,
            accountName
        );
    }
    var detailsMarkup = details ? createElement(
        'div',
        null,
        createElement(
            TextStyle$1,
            { variation: 'subdued' },
            details
        )
    ) : null;
    var termsOfServiceMarkup = termsOfService ? createElement(
        'div',
        { className: styles$12.TermsOfService },
        termsOfService
    ) : null;
    var actionElement = action ? buttonFrom(action, { primary: !connected }) : null;
    return createElement(
        Card$1,
        { sectioned: true },
        createElement(
            SettingAction$1,
            { action: actionElement },
            createElement(
                Stack$1,
                null,
                avatarMarkup,
                createElement(
                    Stack$1.Item,
                    { fill: true },
                    createElement(
                        'div',
                        { className: styles$12.Content },
                        titleMarkup,
                        detailsMarkup
                    )
                )
            )
        ),
        termsOfServiceMarkup
    );
}

var styles$13 = {
  "ActionList": "Polaris-ActionList",
  "Section-withoutTitle": "Polaris-ActionList__Section--withoutTitle",
  "Actions": "Polaris-ActionList__Actions",
  "Title": "Polaris-ActionList__Title",
  "Item": "Polaris-ActionList__Item",
  "Image": "Polaris-ActionList__Image",
  "disabled": "Polaris-ActionList--disabled",
  "Content": "Polaris-ActionList__Content",
  "Text": "Polaris-ActionList__Text",
  "skeletonShimmerAnimation": "Polaris-ActionList--skeletonShimmerAnimation",
};

function Item$3(_ref) {
    var content = _ref.content,
        url = _ref.url,
        onAction = _ref.onAction,
        icon = _ref.icon,
        image = _ref.image,
        disabled = _ref.disabled;

    var className = classNames$1(styles$13.Item, disabled && styles$13.disabled);
    var imageElement = null;
    if (icon) {
        imageElement = createElement(
            'div',
            { className: styles$13.Image },
            createElement(Icon$1, { source: icon })
        );
    } else if (image) {
        imageElement = createElement('div', { role: 'presentation', className: styles$13.Image, style: { backgroundImage: 'url(' + image } });
    }
    var contentElement = imageElement ? createElement(
        'div',
        { className: styles$13.Content },
        imageElement,
        createElement(
            'div',
            { className: styles$13.Text },
            content
        )
    ) : content;
    var control = url ? createElement(
        UnstyledLink$1,
        { url: url, className: styles$13.Item },
        contentElement
    ) : createElement(
        'button',
        { onClick: onAction, className: className, disabled: disabled },
        contentElement
    );
    return createElement(
        'li',
        null,
        control
    );
}

function ActionList$1(_ref) {
    var items = _ref.items,
        _ref$sections = _ref.sections,
        sections = _ref$sections === undefined ? [] : _ref$sections;

    var finalSections = [];
    if (items) {
        finalSections = [{ items: items }].concat(sections);
    } else if (sections) {
        finalSections = sections;
    }
    var hasMultipleSections = finalSections.length > 1;
    var Element = hasMultipleSections ? 'ul' : 'div';
    var sectionMarkup = finalSections.map(function (section, index) {
        return renderSection(section, hasMultipleSections, index);
    });
    return createElement(
        Element,
        { className: styles$13.ActionList },
        sectionMarkup
    );
}
function renderSection(section, hasMultipleSections, index) {
    var SectionElement = hasMultipleSections ? 'li' : 'div';
    var actionMarkup = section.items.map(function (_a) {
        var content = _a.content,
            item = __rest(_a, ["content"]);
        return createElement(Item$3, Object.assign({ key: content, content: content }, item));
    });
    var className = section.title ? null : styles$13['Section-withoutTitle'];
    var titleMarkup = section.title ? createElement(
        'p',
        { className: styles$13.Title },
        section.title
    ) : null;
    return createElement(
        SectionElement,
        { key: section.title || index, className: className },
        titleMarkup,
        createElement(
            'ul',
            { className: styles$13.Actions },
            actionMarkup
        )
    );
}

var styles$14 = {
  "VisuallyHidden": "Polaris-VisuallyHidden",
  "skeletonShimmerAnimation": "Polaris-VisuallyHidden--skeletonShimmerAnimation",
};

function VisuallyHidden$1(_ref) {
    var children = _ref.children;

    return createElement(
        'span',
        { className: styles$14.VisuallyHidden },
        children
    );
}

var styles$15 = {
  "Badge": "Polaris-Badge",
  "Pip": "Polaris-Badge__Pip",
  "statusSuccess": "Polaris-Badge--statusSuccess",
  "statusInfo": "Polaris-Badge--statusInfo",
  "statusAttention": "Polaris-Badge--statusAttention",
  "statusWarning": "Polaris-Badge--statusWarning",
  "progressIncomplete": "Polaris-Badge--progressIncomplete",
  "progressPartiallyComplete": "Polaris-Badge--progressPartiallyComplete",
  "progressComplete": "Polaris-Badge--progressComplete",
  "skeletonShimmerAnimation": "Polaris-Badge--skeletonShimmerAnimation",
};

var PROGRESS_LABELS = {
    incomplete: 'Incomplete',
    partiallyComplete: 'Partially complete',
    complete: 'Complete'
};
var STATUS_LABELS = {
    info: 'Info',
    success: 'Success',
    warning: 'Warning',
    attention: 'Attention'
};
function Badge$1(_ref) {
    var children = _ref.children,
        status = _ref.status,
        progress = _ref.progress;

    var className = classNames(styles$15.Badge, status && styles$15[variationName('status', status)], progress && styles$15[variationName('progress', progress)]);
    var pipMarkup = progress ? createElement(
        'span',
        { className: styles$15.Pip },
        createElement(
            VisuallyHidden$1,
            null,
            PROGRESS_LABELS[progress]
        )
    ) : null;
    var statusLabelMarkup = status ? createElement(
        VisuallyHidden$1,
        null,
        STATUS_LABELS[status]
    ) : null;
    return createElement(
        'span',
        { className: className },
        statusLabelMarkup,
        pipMarkup,
        children
    );
}

var styles$16 = {
  "Banner": "Polaris-Banner",
  "hasDismiss": "Polaris-Banner--hasDismiss",
  "statusSuccess": "Polaris-Banner--statusSuccess",
  "statusInfo": "Polaris-Banner--statusInfo",
  "statusWarning": "Polaris-Banner--statusWarning",
  "statusCritical": "Polaris-Banner--statusCritical",
  "Ribbon": "Polaris-Banner__Ribbon",
  "Heading": "Polaris-Banner__Heading",
  "Actions": "Polaris-Banner__Actions",
  "Content": "Polaris-Banner__Content",
  "SecondaryAction": "Polaris-Banner__SecondaryAction",
  "Text": "Polaris-Banner__Text",
  "Dismiss": "Polaris-Banner__Dismiss",
  "skeletonShimmerAnimation": "Polaris-Banner--skeletonShimmerAnimation",
};

var successIcon = {"viewBox":"0 0 20 20","body":"<g  fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"10\" cy=\"10\" r=\"9\"/><path d=\"M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m2.293-10.707L9 10.586 7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414\" /></g>"};

var fallbackIcon = {"viewBox":"0 0 20 20","body":"<g  fill-rule=\"evenodd\"><path fill=\"currentColor\" d=\"M2 3h11v4h6l-2 4 2 4H8v-4H3\"/><path d=\"M16.105 11.447L17.381 14H9v-2h4a1 1 0 0 0 1-1V8h3.38l-1.274 2.552a.993.993 0 0 0 0 .895zM2.69 4H12v6H4.027L2.692 4zm15.43 7l1.774-3.553A1 1 0 0 0 19 6h-5V3c0-.554-.447-1-1-1H2.248L1.976.782a1 1 0 1 0-1.953.434l4 18a1.006 1.006 0 0 0 1.193.76 1 1 0 0 0 .76-1.194L4.47 12H7v3a1 1 0 0 0 1 1h11c.346 0 .67-.18.85-.476a.993.993 0 0 0 .044-.972l-1.775-3.553z\" /></g>"};

var warningIcon = {"viewBox":"0 0 20 20","body":"<g  fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"10\" cy=\"10\" r=\"9\"/><path d=\"M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-13a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1m0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2\" /></g>"};

var criticalIcon = {"viewBox":"0 0 20 20","body":"<g  fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"10\" cy=\"10\" r=\"9\"/><path d=\"M2 10c0-1.846.635-3.543 1.688-4.897l11.209 11.209A7.954 7.954 0 0 1 10 18c-4.411 0-8-3.589-8-8m14.312 4.897L5.103 3.688A7.954 7.954 0 0 1 10 2c4.411 0 8 3.589 8 8a7.952 7.952 0 0 1-1.688 4.897M0 10c0 5.514 4.486 10 10 10s10-4.486 10-10S15.514 0 10 0 0 4.486 0 10\" /></g>"};

var infoIcon = {"viewBox":"0 0 20 20","body":"<g  fill-rule=\"evenodd\"><circle cx=\"10\" cy=\"10\" r=\"9\" fill=\"currentColor\"/><path  d=\"M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m1-5v-3a1 1 0 0 0-1-1H9a1 1 0 1 0 0 2v3a1 1 0 0 0 1 1h1a1 1 0 1 0 0-2m-1-5.9a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2\"/></g>"};

function Banner$1(_ref) {
    var icon = _ref.icon,
        action = _ref.action,
        secondaryAction = _ref.secondaryAction,
        title = _ref.title,
        children = _ref.children,
        status = _ref.status,
        onDismiss = _ref.onDismiss;

    var color = void 0;
    var defaultIcon = void 0;
    var ariaRoleType = 'status';
    switch (status) {
        case 'success':
            color = 'greenDark';
            defaultIcon = successIcon;
            break;
        case 'info':
            color = 'tealDark';
            defaultIcon = infoIcon;
            break;
        case 'warning':
            color = 'yellowDark';
            defaultIcon = warningIcon;
            ariaRoleType = 'alert';
            break;
        case 'critical':
            color = 'redDark';
            defaultIcon = criticalIcon;
            ariaRoleType = 'alert';
            break;
        default:
            color = 'inkLighter';
            defaultIcon = fallbackIcon;
    }
    var className = classNames(styles$16.Banner, status && styles$16[variationName('status', status)], onDismiss && styles$16.hasDismiss);
    var id = uniqueID();
    var iconName = icon || defaultIcon;
    var headingMarkup = null;
    var headingID = void 0;
    if (title) {
        headingID = id + 'Heading';
        headingMarkup = createElement(
            'div',
            { className: styles$16.Heading, id: headingID },
            createElement(
                Heading$1,
                { element: 'p' },
                title
            )
        );
    }
    var secondaryActionMarkup = secondaryAction ? secondaryActionFrom(secondaryAction) : null;
    var actionMarkup = action ? createElement(
        'div',
        { className: styles$16.Actions },
        createElement(
            ButtonGroup$1,
            null,
            buttonFrom(action, { outline: true }),
            secondaryActionMarkup
        )
    ) : null;
    var contentMarkup = null;
    var contentID = void 0;
    if (children || actionMarkup) {
        contentID = id + 'Content';
        contentMarkup = createElement(
            'div',
            { className: styles$16.Content, id: contentID },
            children,
            actionMarkup
        );
    }
    var dismissButton = onDismiss ? createElement(
        'div',
        { className: styles$16.Dismiss },
        createElement(Button$1, { plain: true, icon: 'cancelSmall', onClick: onDismiss, accessibilityLabel: 'Dismiss notification' })
    ) : null;
    return createElement(
        'div',
        { className: className, tabIndex: 0, role: ariaRoleType, 'aria-live': 'polite', onMouseUp: handleMouseUp, 'aria-labelledby': headingID, 'aria-describedby': contentID },
        dismissButton,
        createElement(
            'div',
            { className: styles$16.Ribbon },
            createElement(Icon$1, { source: iconName, color: color, backdrop: true })
        ),
        createElement(
            'div',
            null,
            headingMarkup,
            contentMarkup
        )
    );
}
var index = 1;
function uniqueID() {
    return 'Banner' + index++;
}
function handleMouseUp(_ref2) {
    var currentTarget = _ref2.currentTarget;

    currentTarget.blur();
}
function secondaryActionFrom(action) {
    if (action.url) {
        return createElement(
            UnstyledLink$1,
            { className: styles$16.SecondaryAction, url: action.url },
            createElement(
                'span',
                { className: styles$16.Text },
                action.content
            )
        );
    }
    return createElement(
        'button',
        { className: styles$16.SecondaryAction, onClick: action.onAction },
        createElement(
            'span',
            { className: styles$16.Text },
            action.content
        )
    );
}

var styles$17 = {
  "TextContainer": "Polaris-TextContainer",
  "skeletonShimmerAnimation": "Polaris-TextContainer--skeletonShimmerAnimation",
};

function TextContainer$1(_ref) {
    var children = _ref.children;

    return createElement(
        'div',
        { className: styles$17.TextContainer },
        children
    );
}

var styles$18 = {
  "CalloutCard": "Polaris-CalloutCard",
  "Image": "Polaris-CalloutCard__Image",
  "Content": "Polaris-CalloutCard__Content",
  "Title": "Polaris-CalloutCard__Title",
  "Buttons": "Polaris-CalloutCard__Buttons",
  "skeletonShimmerAnimation": "Polaris-CalloutCard--skeletonShimmerAnimation",
};

function CalloutCard$1(_ref) {
  var title = _ref.title,
      children = _ref.children,
      illustration = _ref.illustration,
      primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction;

  var primaryActionMarkup = buttonFrom(primaryAction);
  var secondaryActionMarkup = secondaryAction ? buttonFrom(secondaryAction, { plain: true }) : null;
  var buttonMarkup = secondaryActionMarkup ? createElement(
    ButtonGroup$1,
    null,
    primaryActionMarkup,
    secondaryActionMarkup
  ) : primaryActionMarkup;
  return createElement(
    Card$1,
    { sectioned: true },
    createElement(
      'div',
      { className: styles$18.CalloutCard },
      createElement(
        'div',
        { className: styles$18.Content },
        createElement(
          'div',
          { className: styles$18.Title },
          createElement(
            Heading$1,
            null,
            title
          )
        ),
        createElement(
          TextContainer$1,
          null,
          children
        ),
        createElement(
          'div',
          { className: styles$18.Buttons },
          buttonMarkup
        )
      ),
      createElement(Image$1, { alt: '', className: styles$18.Image, source: illustration })
    )
  );
}

var styles$19 = {
  "Caption": "Polaris-Caption",
  "skeletonShimmerAnimation": "Polaris-Caption--skeletonShimmerAnimation",
};

function Caption$1(_ref) {
    var children = _ref.children;

    return createElement(
        'p',
        { className: styles$19.Caption },
        children
    );
}

var styles$20 = {
  "Choice": "Polaris-Choice",
  "labelHidden": "Polaris-Choice--labelHidden",
  "Label": "Polaris-Choice__Label",
  "Control": "Polaris-Choice__Control",
  "Descriptions": "Polaris-Choice__Descriptions",
  "HelpText": "Polaris-Choice__HelpText",
  "Error": "Polaris-Choice__Error",
  "ErrorIcon": "Polaris-Choice__ErrorIcon",
  "skeletonShimmerAnimation": "Polaris-Choice--skeletonShimmerAnimation",
};

function Choice$1(_ref) {
    var id = _ref.id,
        label = _ref.label,
        error = _ref.error,
        children = _ref.children,
        labelHidden = _ref.labelHidden,
        helpText = _ref.helpText;

    var className = classNames(styles$20.Choice, labelHidden && styles$20.labelHidden);
    var labelMarkup = createElement(
        'label',
        { className: className, htmlFor: id },
        createElement(
            'span',
            { className: styles$20.Control },
            children
        ),
        createElement(
            'span',
            { className: styles$20.Label },
            label
        )
    );
    var helpTextMarkup = helpText ? createElement(
        'div',
        { className: styles$20.HelpText, id: helpTextID(id) },
        helpText
    ) : null;
    var errorMarkup = typeof error === 'string' ? createElement(
        'div',
        { className: styles$20.Error, id: errorID(id) },
        createElement(
            'div',
            { className: styles$20.ErrorIcon },
            createElement(Icon$1, { source: 'alert' })
        ),
        error
    ) : null;
    var descriptionMarkup = helpTextMarkup || errorMarkup ? createElement(
        'div',
        { className: styles$20.Descriptions },
        errorMarkup,
        helpTextMarkup
    ) : null;
    return descriptionMarkup ? createElement(
        'div',
        null,
        labelMarkup,
        descriptionMarkup
    ) : labelMarkup;
}
function helpTextID(id) {
    return id + 'HelpText';
}
function errorID(id) {
    return id + 'Error';
}

var styles$21 = {
  "Checkbox": "Polaris-Checkbox",
  "error": "Polaris-Checkbox--error",
  "Input": "Polaris-Checkbox__Input",
  "Backdrop": "Polaris-Checkbox__Backdrop",
  "Icon": "Polaris-Checkbox__Icon",
  "skeletonShimmerAnimation": "Polaris-Checkbox--skeletonShimmerAnimation",
};

var getUniqueID = createUniqueIDFactory('Checkbox');
function Checkbox$1(_ref) {
    var _ref$id = _ref.id,
        id = _ref$id === undefined ? getUniqueID() : _ref$id,
        label = _ref.label,
        labelHidden = _ref.labelHidden,
        helpText = _ref.helpText,
        checked = _ref.checked,
        error = _ref.error,
        disabled = _ref.disabled,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        name = _ref.name,
        value = _ref.value;

    function handleChange(event) {
        if (onChange == null) {
            return;
        }
        var currentTarget = event.currentTarget;

        onChange(currentTarget.checked, id);
    }
    var describedBy = [];
    if (typeof error === 'string') {
        describedBy.push(errorID(id));
    }
    if (helpText) {
        describedBy.push(helpTextID(id));
    }
    var className = classNames(styles$21.Checkbox, error && styles$21.error);
    return createElement(
        Choice$1,
        { id: id, label: label, labelHidden: labelHidden, helpText: helpText, error: error },
        createElement(
            'div',
            { className: className },
            createElement('input', { id: id, name: name, value: value, type: 'checkbox', checked: checked, disabled: disabled, className: styles$21.Input, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, 'aria-invalid': error != null, 'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined }),
            createElement('div', { className: styles$21.Backdrop }),
            createElement(
                'div',
                { className: styles$21.Icon },
                createElement(Icon$1, { source: 'checkmark' })
            )
        )
    );
}

var styles$22 = {
  "RadioButton": "Polaris-RadioButton",
  "Input": "Polaris-RadioButton__Input",
  "Backdrop": "Polaris-RadioButton__Backdrop",
  "Icon": "Polaris-RadioButton__Icon",
  "skeletonShimmerAnimation": "Polaris-RadioButton--skeletonShimmerAnimation",
};

var getUniqueID$2 = createUniqueIDFactory('RadioButton');
function RadioButton$1(_ref) {
    var label = _ref.label,
        labelHidden = _ref.labelHidden,
        helpText = _ref.helpText,
        checked = _ref.checked,
        disabled = _ref.disabled,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        _ref$id = _ref.id,
        id = _ref$id === undefined ? getUniqueID$2() : _ref$id,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? id : _ref$name,
        value = _ref.value;

    function handleChange(_ref2) {
        var currentTarget = _ref2.currentTarget;

        if (onChange == null) {
            return;
        }
        onChange(currentTarget.checked, id);
    }
    var describedBy = helpText ? helpTextID(id) : null;
    return createElement(
        Choice$1,
        { label: label, labelHidden: labelHidden, id: id, helpText: helpText },
        createElement(
            'div',
            { className: styles$22.RadioButton },
            createElement('input', { id: id, name: name, value: value, type: 'radio', checked: checked, disabled: disabled, className: styles$22.Input, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, 'aria-describedby': describedBy }),
            createElement('div', { className: styles$22.Backdrop }),
            createElement('div', { className: styles$22.Icon })
        )
    );
}

var styles$23 = {
  "ChoiceList": "Polaris-ChoiceList",
  "titleHidden": "Polaris-ChoiceList--titleHidden",
  "Title": "Polaris-ChoiceList__Title",
  "Choices": "Polaris-ChoiceList__Choices",
  "skeletonShimmerAnimation": "Polaris-ChoiceList--skeletonShimmerAnimation",
};

var getUniqueID$1 = createUniqueIDFactory('ChoiceList');
function ChoiceList$1(_ref) {
    var title = _ref.title,
        titleHidden = _ref.titleHidden,
        allowMultiple = _ref.allowMultiple,
        choices = _ref.choices,
        selected = _ref.selected,
        _ref$onChange = _ref.onChange,
        onChange = _ref$onChange === undefined ? noop : _ref$onChange,
        _ref$name = _ref.name,
        name = _ref$name === undefined ? getUniqueID$1() : _ref$name;

    var ControlComponent = allowMultiple ? Checkbox$1 : RadioButton$1;
    var finalName = allowMultiple ? name + '[]' : name;
    var className = classNames(styles$23.ChoiceList, titleHidden && styles$23.titleHidden);
    var titleMarkup = title ? createElement(
        'legend',
        { className: styles$23.Title },
        title
    ) : null;
    var choicesMarkup = choices.map(function (choice) {
        var value = choice.value,
            label = choice.label,
            helpText = choice.helpText,
            disabled = choice.disabled;

        function handleChange(checked) {
            onChange(updateSelectedChoices(choice, checked, selected, allowMultiple), name);
        }
        return createElement(
            'li',
            { key: value },
            createElement(ControlComponent, { name: finalName, value: value, label: label, disabled: disabled, checked: choiceIsSelected(choice, selected), helpText: helpText, onChange: handleChange })
        );
    });
    return createElement(
        'fieldset',
        { className: className },
        titleMarkup,
        createElement(
            'ul',
            { className: styles$23.Choices },
            choicesMarkup
        )
    );
}
function choiceIsSelected(_ref2, selected) {
    var value = _ref2.value;

    return selected.indexOf(value) >= 0;
}
function updateSelectedChoices(_ref3, checked, selected) {
    var value = _ref3.value;
    var allowMultiple = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (checked) {
        return allowMultiple ? [].concat(_toConsumableArray(selected), [value]) : [value];
    }
    return selected.filter(function (selectedChoice) {
        return selectedChoice !== value;
    });
}

var styles$24 = {
  "Collapsible": "Polaris-Collapsible",
  "animating": "Polaris-Collapsible--animating",
  "open": "Polaris-Collapsible--open",
  "skeletonShimmerAnimation": "Polaris-Collapsible--skeletonShimmerAnimation",
};

var CONTEXT_TYPES = {
    parentCollapsibleExpanding: bool
};

var Collapsible$1 = function (_React$Component) {
    _inherits(Collapsible, _React$Component);

    function Collapsible() {
        _classCallCheck(this, Collapsible);

        var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).apply(this, arguments));

        _this.state = {
            height: null,
            animationState: 'idle'
        };
        _this.node = null;
        _this.heightNode = null;
        return _this;
    }

    _createClass(Collapsible, [{
        key: 'getChildContext',
        value: function getChildContext() {
            var open = this.props.open;
            var animationState = this.state.animationState;
            var parentCollapsibleExpanding = this.context.parentCollapsibleExpanding;

            return {
                parentCollapsibleExpanding: parentCollapsibleExpanding || open && animationState !== 'idle'
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var willOpen = _ref.open;
            var open = this.props.open;

            if (open !== willOpen) {
                this.setState({ animationState: 'measuring' });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref2) {
            var _this2 = this;

            var wasOpen = _ref2.open;
            var animationState = this.state.animationState;
            var parentCollapsibleExpanding = this.context.parentCollapsibleExpanding;

            if (parentCollapsibleExpanding && animationState !== 'idle') {
                this.setState({
                    animationState: 'idle'
                });
                return;
            }
            read(function () {
                switch (animationState) {
                    case 'idle':
                        break;
                    case 'measuring':
                        _this2.setState({
                            animationState: wasOpen ? 'closingStart' : 'openingStart',
                            height: wasOpen && _this2.heightNode ? _this2.heightNode.scrollHeight : 0
                        });
                        break;
                    case 'closingStart':
                        _this2.setState({
                            animationState: 'closing',
                            height: 0
                        });
                        break;
                    case 'openingStart':
                        _this2.setState({
                            animationState: 'opening',
                            height: _this2.heightNode ? _this2.heightNode.scrollHeight : 0
                        });
                        break;
                }
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.node == null) {
                return;
            }
            addEventListener(this.node, 'transitionend', this.handleTransitionEnd);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.node == null) {
                return;
            }
            removeEventListener(this.node, 'transitionend', this.handleTransitionEnd);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                open = _props.open;
            var _state = this.state,
                animationState = _state.animationState,
                height = _state.height;

            var animating = animationState !== 'idle';
            var wrapperClassName = classNames(styles$24.Collapsible, open && styles$24.open, animating && styles$24.animating);
            var displayHeight = collapsibleHeight(open, animationState, height);
            var content = animating || open ? children : null;
            return createElement(
                'div',
                { 'aria-hidden': !open, style: { height: displayHeight }, className: wrapperClassName, ref: this.bindNode },
                createElement(
                    'div',
                    { ref: this.bindHeightNode },
                    content
                )
            );
        }
    }, {
        key: 'bindNode',
        value: function bindNode(node) {
            this.node = node;
        }
    }, {
        key: 'bindHeightNode',
        value: function bindHeightNode(node) {
            this.heightNode = node;
        }
    }, {
        key: 'handleTransitionEnd',
        value: function handleTransitionEnd(event) {
            var target = event.target;

            if (target === this.node) {
                this.setState({ animationState: 'idle', height: null });
            }
        }
    }]);

    return Collapsible;
}(Component);

Collapsible$1.contextTypes = CONTEXT_TYPES;
Collapsible$1.childContextTypes = CONTEXT_TYPES;
__decorate([autobind], Collapsible$1.prototype, "bindNode", null);
__decorate([autobind], Collapsible$1.prototype, "bindHeightNode", null);
__decorate([autobind], Collapsible$1.prototype, "handleTransitionEnd", null);
function collapsibleHeight(open, animationState, height) {
    if (animationState === 'idle' && open) {
        return open ? 'auto' : null;
    }
    if (animationState === 'measuring') {
        return open ? null : 'auto';
    }
    return (height || 0) + 'px';
}

function rgbString(color) {
    var red = color.red,
        green = color.green,
        blue = color.blue;

    if (color.hasOwnProperty('alpha')) {
        return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + color.alpha + ')';
    } else {
        return 'rgb(' + red + ', ' + green + ', ' + blue + ')';
    }
}
var rgbaString = rgbString;
function rgbToHex(_ref) {
    var red = _ref.red,
        green = _ref.green,
        blue = _ref.blue;

    return '#' + componentToHex(red) + componentToHex(green) + componentToHex(blue);
}
function componentToHex(component) {
    var hex = component.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
function hsbToHex(color) {
    return rgbToHex(hsbToRgb(color));
}
function hsbToRgb(color) {
    var hue = color.hue,
        saturation = color.saturation,
        brightness = color.brightness,
        _color$alpha = color.alpha,
        alpha = _color$alpha === undefined ? 1 : _color$alpha;

    var chroma = brightness * saturation;
    var huePrime = hue / 60;
    var hueDelta = 1 - Math.abs(huePrime % 2 - 1);
    var intermediateValue = chroma * hueDelta;
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime <= 1) {
        red = chroma;
        green = intermediateValue;
        blue = 0;
    }
    if (huePrime >= 1 && huePrime <= 2) {
        red = intermediateValue;
        green = chroma;
        blue = 0;
    }
    if (huePrime >= 2 && huePrime <= 3) {
        red = 0;
        green = chroma;
        blue = intermediateValue;
    }
    if (huePrime >= 3 && huePrime <= 4) {
        red = 0;
        green = intermediateValue;
        blue = chroma;
    }
    if (huePrime >= 4 && huePrime <= 5) {
        red = intermediateValue;
        green = 0;
        blue = chroma;
    }
    if (huePrime >= 5 && huePrime <= 6) {
        red = chroma;
        green = 0;
        blue = intermediateValue;
    }
    var chromaBrightnessDelta = brightness - chroma;
    red += chromaBrightnessDelta;
    green += chromaBrightnessDelta;
    blue += chromaBrightnessDelta;
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}
function rgbToHsb(color) {
    var red = color.red,
        green = color.green,
        blue = color.blue,
        _color$alpha2 = color.alpha,
        alpha = _color$alpha2 === undefined ? 1 : _color$alpha2;

    var r = red / 255;
    var g = green / 255;
    var b = blue / 255;
    var largestComponent = Math.max(r, g, b);
    var smallestComponent = Math.min(r, g, b);
    var delta = largestComponent - smallestComponent;
    var saturation = largestComponent === 0 ? 0 : delta / largestComponent;
    var huePercentage = 0;
    switch (largestComponent) {
        case r:
            huePercentage = (g - b) / delta % 6;
            break;
        case g:
            huePercentage = (b - r) / delta + 2;
            break;
        case b:
            huePercentage = (r - g) / delta + 4;
            break;
    }
    var hue = Math.round(huePercentage / 6 * 360);
    return {
        hue: clamp(hue, 0, 360) || 0,
        saturation: clamp(saturation, 0, 1),
        brightness: clamp(largestComponent, 0, 1),
        alpha: alpha
    };
}

// see https://github.com/oliviertassinari/react-event-listener/

var EventListener$1 = function (_React$PureComponent) {
    _inherits(EventListener, _React$PureComponent);

    function EventListener() {
        _classCallCheck(this, EventListener);

        return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
    }

    _createClass(EventListener, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.attachListener();
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate() {
            this.detachListener();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.attachListener();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.detachListener();
        }
        // tslint:disable-next-line prefer-function-over-method

    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }, {
        key: 'attachListener',
        value: function attachListener() {
            var _props = this.props,
                event = _props.event,
                handler = _props.handler,
                capture = _props.capture,
                passive = _props.passive;

            addEventListener(window, event, handler, { capture: capture, passive: passive });
        }
    }, {
        key: 'detachListener',
        value: function detachListener() {
            var _props2 = this.props,
                event = _props2.event,
                handler = _props2.handler,
                capture = _props2.capture;

            removeEventListener(window, event, handler, capture);
        }
    }]);

    return EventListener;
}(PureComponent);

var styles$25 = {
  "ColorPicker": "Polaris-ColorPicker",
  "MainColor": "Polaris-ColorPicker__MainColor",
  "Dragger": "Polaris-ColorPicker__Dragger",
  "ColorLayer": "Polaris-ColorPicker__ColorLayer",
  "HuePicker": "Polaris-ColorPicker__HuePicker",
  "AlphaPicker": "Polaris-ColorPicker__AlphaPicker",
  "Slidable": "Polaris-ColorPicker__Slidable",
  "skeletonShimmerAnimation": "Polaris-ColorPicker--skeletonShimmerAnimation",
};

var Slidable = function (_React$PureComponent) {
    _inherits(Slidable, _React$PureComponent);

    function Slidable() {
        _classCallCheck(this, Slidable);

        var _this = _possibleConstructorReturn(this, (Slidable.__proto__ || Object.getPrototypeOf(Slidable)).apply(this, arguments));

        _this.state = {
            dragging: false
        };
        _this.node = null;
        _this.draggerNode = null;
        return _this;
    }

    _createClass(Slidable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var onDraggerHeight = this.props.onDraggerHeight;

            if (onDraggerHeight == null) {
                return;
            }
            var draggerNode = this.draggerNode;

            if (draggerNode == null) {
                return;
            }
            onDraggerHeight(draggerNode.clientWidth);
            if (process.env.NODE_ENV === 'development') {
                setTimeout(function () {
                    onDraggerHeight(draggerNode.clientWidth);
                }, 0);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var dragging = this.state.dragging;
            var _props = this.props,
                _props$draggerX = _props.draggerX,
                draggerX = _props$draggerX === undefined ? 0 : _props$draggerX,
                _props$draggerY = _props.draggerY,
                draggerY = _props$draggerY === undefined ? 0 : _props$draggerY;

            var draggerPositioning = {
                transform: 'translate3d(' + draggerX + 'px, ' + draggerY + 'px, 0)'
            };
            var moveListener = dragging ? createElement(EventListener$1, { event: 'mousemove', handler: this.handleMove }) : null;
            var touchMoveListener = dragging ? createElement(EventListener$1, { event: 'touchmove', handler: this.handleMove }) : null;
            var endDragListener = dragging ? createElement(EventListener$1, { event: 'mouseup', handler: this.handleDragEnd }) : null;
            var touchEndListener = dragging ? createElement(EventListener$1, { event: 'touchend', handler: this.handleDragEnd }) : null;
            var touchCancelListener = dragging ? createElement(EventListener$1, { event: 'touchcancel', handler: this.handleDragEnd }) : null;
            return createElement(
                'div',
                { ref: this.setNode, className: styles$25.Slidable, onMouseDown: this.startDrag, onTouchStart: this.startDrag },
                endDragListener,
                moveListener,
                touchMoveListener,
                touchEndListener,
                touchCancelListener,
                createElement('div', { style: draggerPositioning, className: styles$25.Dragger, ref: this.setDraggerNode })
            );
        }
    }, {
        key: 'setDraggerNode',
        value: function setDraggerNode(node) {
            this.draggerNode = node;
        }
    }, {
        key: 'setNode',
        value: function setNode(node) {
            this.node = node;
        }
    }, {
        key: 'startDrag',
        value: function startDrag(event) {
            if (event.type === 'mousedown') {
                var mouseEvent = event;
                this.handleDraggerMove(mouseEvent.clientX, mouseEvent.clientY);
            }
            this.setState({ dragging: true });
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.setState({ dragging: false });
        }
    }, {
        key: 'handleMove',
        value: function handleMove(event) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
            if (event.type === 'mousemove') {
                var mouseEvent = event;
                this.handleDraggerMove(mouseEvent.clientX, mouseEvent.clientY);
                return;
            }
            var touchEvent = event;
            this.handleDraggerMove(touchEvent.touches[0].clientX, touchEvent.touches[0].clientY);
        }
    }, {
        key: 'handleDraggerMove',
        value: function handleDraggerMove(x, y) {
            if (this.node == null) {
                return;
            }
            var onChange = this.props.onChange;

            var rect = this.node.getBoundingClientRect();
            var offsetX = x - rect.left;
            var offsetY = y - rect.top;
            onChange({ x: offsetX, y: offsetY });
        }
    }]);

    return Slidable;
}(PureComponent);

__decorate([autobind], Slidable.prototype, "setDraggerNode", null);
__decorate([autobind], Slidable.prototype, "setNode", null);
__decorate([autobind], Slidable.prototype, "startDrag", null);
__decorate([autobind], Slidable.prototype, "handleDragEnd", null);
__decorate([autobind], Slidable.prototype, "handleMove", null);
__decorate([autobind], Slidable.prototype, "handleDraggerMove", null);

var VERTICAL_PADDING = 13;

var HuePicker = function (_React$PureComponent) {
    _inherits(HuePicker, _React$PureComponent);

    function HuePicker() {
        _classCallCheck(this, HuePicker);

        var _this = _possibleConstructorReturn(this, (HuePicker.__proto__ || Object.getPrototypeOf(HuePicker)).apply(this, arguments));

        _this.state = {
            dragging: false,
            sliderHeight: 0,
            draggerHeight: 0
        };
        return _this;
    }

    _createClass(HuePicker, [{
        key: 'render',
        value: function render() {
            var hue = this.props.hue;
            var _state = this.state,
                sliderHeight = _state.sliderHeight,
                draggerHeight = _state.draggerHeight;

            var offset = offsetForHue(hue, sliderHeight, draggerHeight);
            var draggerY = clamp(offset, 0, sliderHeight);
            return createElement(
                'div',
                { className: styles$25.HuePicker, ref: this.setSliderHeight },
                createElement(Slidable, { draggerY: draggerY, draggerX: 0, onChange: this.handleChange, onDraggerHeight: this.setDraggerHeight })
            );
        }
    }, {
        key: 'setSliderHeight',
        value: function setSliderHeight(node) {
            var _this2 = this;

            if (node == null) {
                return;
            }
            this.setState({ sliderHeight: node.clientHeight });
            if (process.env.NODE_ENV === 'development') {
                setTimeout(function () {
                    _this2.setState({ sliderHeight: node.clientHeight });
                }, 0);
            }
        }
    }, {
        key: 'setDraggerHeight',
        value: function setDraggerHeight(height) {
            this.setState({
                draggerHeight: height
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(_ref) {
            var y = _ref.y;
            var onChange = this.props.onChange;
            var sliderHeight = this.state.sliderHeight;

            var offsetY = clamp(y, 0, sliderHeight);
            var hue = hueForOffset(offsetY, sliderHeight);
            onChange(hue);
        }
    }]);

    return HuePicker;
}(PureComponent);

__decorate([autobind], HuePicker.prototype, "setSliderHeight", null);
__decorate([autobind], HuePicker.prototype, "setDraggerHeight", null);
__decorate([autobind], HuePicker.prototype, "handleChange", null);
function offsetForHue(hue, sliderHeight, draggerHeight) {
    var slidableArea = sliderHeight - (draggerHeight + VERTICAL_PADDING);
    return clamp(hue / 360 * slidableArea + VERTICAL_PADDING, 0, sliderHeight - draggerHeight);
}
function hueForOffset(offset, sliderHeight) {
    var selectionHeight = offset - VERTICAL_PADDING;
    var slidableArea = sliderHeight - 2 * VERTICAL_PADDING;
    return clamp(selectionHeight / slidableArea * 360, 0, 360);
}

var VERTICAL_PADDING$1 = 13;

var AlphaPicker = function (_React$PureComponent) {
    _inherits(AlphaPicker, _React$PureComponent);

    function AlphaPicker() {
        _classCallCheck(this, AlphaPicker);

        var _this = _possibleConstructorReturn(this, (AlphaPicker.__proto__ || Object.getPrototypeOf(AlphaPicker)).apply(this, arguments));

        _this.state = {
            dragging: false,
            sliderHeight: 0,
            draggerHeight: 0
        };
        return _this;
    }

    _createClass(AlphaPicker, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                color = _props.color,
                alpha = _props.alpha;
            var _state = this.state,
                sliderHeight = _state.sliderHeight,
                draggerHeight = _state.draggerHeight;

            var offset = offsetForAlpha(alpha, sliderHeight, draggerHeight);
            var draggerY = clamp(offset, 0, sliderHeight);
            var background = alphaGradientForColor(color);
            return createElement(
                'div',
                { className: styles$25.AlphaPicker, ref: this.setSliderHeight },
                createElement('div', { className: styles$25.ColorLayer, style: { background: background } }),
                createElement(Slidable, { draggerY: draggerY, draggerX: 0, onChange: this.handleChange, onDraggerHeight: this.setDraggerHeight })
            );
        }
    }, {
        key: 'setSliderHeight',
        value: function setSliderHeight(node) {
            var _this2 = this;

            if (node == null) {
                return;
            }
            this.setState({ sliderHeight: node.clientHeight });
            if (process.env.NODE_ENV === 'development') {
                setTimeout(function () {
                    _this2.setState({ sliderHeight: node.clientHeight });
                }, 0);
            }
        }
    }, {
        key: 'setDraggerHeight',
        value: function setDraggerHeight(height) {
            this.setState({
                draggerHeight: height
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(_ref) {
            var y = _ref.y;
            var onChange = this.props.onChange;
            var sliderHeight = this.state.sliderHeight;

            var offsetY = clamp(y, 0, sliderHeight);
            var alpha = alphaForOffset(offsetY, sliderHeight);
            onChange(alpha);
        }
    }]);

    return AlphaPicker;
}(PureComponent);

__decorate([autobind], AlphaPicker.prototype, "setSliderHeight", null);
__decorate([autobind], AlphaPicker.prototype, "setDraggerHeight", null);
__decorate([autobind], AlphaPicker.prototype, "handleChange", null);
function alphaForOffset(offset, sliderHeight) {
    var selectionHeight = offset - VERTICAL_PADDING$1;
    var slidableArea = sliderHeight - 2 * VERTICAL_PADDING$1;
    return clamp(1 - selectionHeight / slidableArea, 0, 1);
}
function offsetForAlpha(alpha, sliderHeight, draggerHeight) {
    var slidableArea = sliderHeight - (draggerHeight + VERTICAL_PADDING$1);
    return clamp((1 - alpha) * slidableArea + VERTICAL_PADDING$1, 0, sliderHeight - draggerHeight);
}
function alphaGradientForColor(color) {
    var _hsbToRgb = hsbToRgb(color),
        red = _hsbToRgb.red,
        green = _hsbToRgb.green,
        blue = _hsbToRgb.blue;

    var rgb = red + ', ' + green + ', ' + blue;
    return 'linear-gradient(to top, rgba(' + rgb + ', 0) 18px, rgba(' + rgb + ', 1) calc(100% - 18px))';
}

var ColorPicker$1 = function (_React$PureComponent) {
    _inherits(ColorPicker, _React$PureComponent);

    function ColorPicker() {
        _classCallCheck(this, ColorPicker);

        var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).apply(this, arguments));

        _this.state = {
            pickerSize: 0
        };
        _this.colorNode = null;
        return _this;
    }

    _createClass(ColorPicker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var colorNode = this.colorNode;

            if (colorNode == null) {
                return;
            }
            this.setState({ pickerSize: colorNode.clientWidth });
            if (process.env.NODE_ENV === 'development') {
                setTimeout(function () {
                    _this2.setState({ pickerSize: colorNode.clientWidth });
                }, 0);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                color = _props.color,
                allowAlpha = _props.allowAlpha;
            var hue = color.hue,
                saturation = color.saturation,
                brightness = color.brightness,
                providedAlpha = color.alpha;
            var pickerSize = this.state.pickerSize;

            var alpha = providedAlpha != null && allowAlpha ? providedAlpha : 1;

            var _hsbToRgb = hsbToRgb({ hue: hue, saturation: 1, brightness: 1 }),
                red = _hsbToRgb.red,
                green = _hsbToRgb.green,
                blue = _hsbToRgb.blue;

            var colorString = 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')';
            var draggerX = clamp(saturation * pickerSize, 0, pickerSize);
            var draggerY = clamp(pickerSize - brightness * pickerSize, 0, pickerSize);
            var alphaSliderMarkup = allowAlpha ? createElement(AlphaPicker, { alpha: alpha, color: color, onChange: this.handleAlphaChange }) : null;
            return createElement(
                'div',
                { className: styles$25.ColorPicker },
                createElement(
                    'div',
                    { ref: this.setColorNode, className: styles$25.MainColor },
                    createElement('div', { className: styles$25.ColorLayer, style: { backgroundColor: colorString } }),
                    createElement(Slidable, { onChange: this.handleDraggerMove, draggerX: draggerX, draggerY: draggerY })
                ),
                createElement(HuePicker, { hue: hue, onChange: this.handleHueChange }),
                alphaSliderMarkup
            );
        }
    }, {
        key: 'setColorNode',
        value: function setColorNode(node) {
            this.colorNode = node;
        }
    }, {
        key: 'handleHueChange',
        value: function handleHueChange(hue) {
            var _props2 = this.props,
                _props2$color = _props2.color,
                brightness = _props2$color.brightness,
                saturation = _props2$color.saturation,
                _props2$color$alpha = _props2$color.alpha,
                alpha = _props2$color$alpha === undefined ? 1 : _props2$color$alpha,
                onChange = _props2.onChange;

            onChange({ hue: hue, brightness: brightness, saturation: saturation, alpha: alpha });
        }
    }, {
        key: 'handleAlphaChange',
        value: function handleAlphaChange(alpha) {
            var _props3 = this.props,
                _props3$color = _props3.color,
                hue = _props3$color.hue,
                brightness = _props3$color.brightness,
                saturation = _props3$color.saturation,
                onChange = _props3.onChange;

            onChange({ hue: hue, brightness: brightness, saturation: saturation, alpha: alpha });
        }
    }, {
        key: 'handleDraggerMove',
        value: function handleDraggerMove(_ref) {
            var x = _ref.x,
                y = _ref.y;
            var pickerSize = this.state.pickerSize;
            var _props4 = this.props,
                _props4$color = _props4.color,
                hue = _props4$color.hue,
                _props4$color$alpha = _props4$color.alpha,
                alpha = _props4$color$alpha === undefined ? 1 : _props4$color$alpha,
                onChange = _props4.onChange;

            var saturation = clamp(x / pickerSize, 0, 1);
            var brightness = clamp(1 - y / pickerSize, 0, 1);
            onChange({ hue: hue, saturation: saturation, brightness: brightness, alpha: alpha });
        }
    }]);

    return ColorPicker;
}(PureComponent);

__decorate([autobind], ColorPicker$1.prototype, "setColorNode", null);
__decorate([autobind], ColorPicker$1.prototype, "handleHueChange", null);
__decorate([autobind], ColorPicker$1.prototype, "handleAlphaChange", null);
__decorate([autobind], ColorPicker$1.prototype, "handleDraggerMove", null);

var styles$26 = {
  "DatePicker": "Polaris-DatePicker",
  "MonthContainer": "Polaris-DatePicker__MonthContainer",
  "Month": "Polaris-DatePicker__Month",
  "Month-current": "Polaris-DatePicker__Month--current",
  "Week": "Polaris-DatePicker__Week",
  "WeekHeadings": "Polaris-DatePicker__WeekHeadings",
  "Day": "Polaris-DatePicker__Day",
  "EmptyDay": "Polaris-DatePicker__EmptyDay",
  "Day-today": "Polaris-DatePicker__Day--today",
  "Day-inRange": "Polaris-DatePicker__Day--inRange",
  "Day-selected": "Polaris-DatePicker__Day--selected",
  "Day-disabled": "Polaris-DatePicker__Day--disabled",
  "Weekday": "Polaris-DatePicker__Weekday",
  "Weekday-current": "Polaris-DatePicker__Weekday--current",
  "Header": "Polaris-DatePicker__Header",
  "Title": "Polaris-DatePicker__Title",
  "skeletonShimmerAnimation": "Polaris-DatePicker--skeletonShimmerAnimation",
};

var Day = function (_React$PureComponent) {
    _inherits(Day, _React$PureComponent);

    function Day() {
        _classCallCheck(this, Day);

        var _this = _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));

        _this.dayNode = null;
        return _this;
    }

    _createClass(Day, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.focused && this.dayNode) {
                this.dayNode.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                day = _props.day,
                focused = _props.focused,
                onClick = _props.onClick,
                _props$onHover = _props.onHover,
                onHover = _props$onHover === undefined ? noop : _props$onHover,
                _props$onFocus = _props.onFocus,
                onFocus = _props$onFocus === undefined ? noop : _props$onFocus,
                selected = _props.selected,
                inRange = _props.inRange,
                inHoveringRange = _props.inHoveringRange,
                disabled = _props.disabled;

            var handleHover = onHover.bind(null, day);
            if (!day) {
                return createElement('div', { className: styles$26.EmptyDay, onMouseOver: handleHover });
            }
            var handleClick = onClick && !disabled ? onClick.bind(null, day) : noop;
            var today = isSameDay(new Date(), day);
            var className = classNames(styles$26.Day, selected && styles$26['Day-selected'], disabled && styles$26['Day-disabled'], today && styles$26['Day-today'], (inRange || inHoveringRange) && !disabled && styles$26['Day-inRange']);
            var date = day.getDate();
            var tabIndex = (focused || selected || today || date === 1) && !disabled ? 0 : -1;
            var ariaLabel = ['' + (today ? 'Today ' : ''), Months[day.getMonth()] + ' ', date + ' ', '' + day.getFullYear()].join('');
            return createElement(
                'button',
                { onFocus: onFocus.bind(null, day), ref: this.setNode, tabIndex: tabIndex, className: className, onMouseOver: handleHover, onClick: handleClick, 'aria-label': ariaLabel, 'aria-selected': selected, 'aria-disabled': disabled, role: 'gridcell' },
                date
            );
        }
    }, {
        key: 'setNode',
        value: function setNode(node) {
            this.dayNode = node;
        }
    }]);

    return Day;
}(PureComponent);

__decorate([autobind], Day.prototype, "setNode", null);

function Weekday(_ref) {
    var label = _ref.label,
        title = _ref.title,
        current = _ref.current;

    var className = classNames(styles$26.Weekday, current && styles$26['Weekday-current']);
    return createElement(
        'div',
        { 'aria-label': Weekdays[label], className: className },
        title
    );
}

var WEEKDAYS = [Weekdays.Sunday, Weekdays.Monday, Weekdays.Tuesday, Weekdays.Wednesday, Weekdays.Thursday, Weekdays.Friday, Weekdays.Saturday];
function Month(_ref) {
    var focusedDate = _ref.focusedDate,
        selected = _ref.selected,
        hoverDate = _ref.hoverDate,
        disableDatesBefore = _ref.disableDatesBefore,
        disableDatesAfter = _ref.disableDatesAfter,
        allowRange = _ref.allowRange,
        _ref$onChange = _ref.onChange,
        onChange = _ref$onChange === undefined ? noop : _ref$onChange,
        _ref$onHover = _ref.onHover,
        onHover = _ref$onHover === undefined ? noop : _ref$onHover,
        _ref$onFocus = _ref.onFocus,
        onFocus = _ref$onFocus === undefined ? noop : _ref$onFocus,
        month = _ref.month,
        year = _ref.year;

    var isInHoveringRange = allowRange ? hoveringDateIsInRange : function () {
        return false;
    };
    var current = new Date().getMonth() === month;
    var className = classNames(styles$26.Title, current && styles$26['Month-current']);
    var weeks = getWeeksForMonth(month, year);
    var weekdays = WEEKDAYS.map(function (weekday) {
        return createElement(Weekday, { key: weekday, title: abbreviationForWeekday(weekday), current: current && new Date().getDay() === weekday, label: weekday });
    });
    function handleDateClick(selectedDate) {
        onChange(getNewRange(selected, selectedDate));
    }
    function renderWeek(day, dayIndex) {
        if (day == null) {
            var lastDayOfMonth = new Date(year, month + 1, 0);
            return createElement(Day, { key: dayIndex, onHover: onHover.bind(null, lastDayOfMonth) });
        }
        var disabled = disableDatesBefore && isDateBefore(day, disableDatesBefore) || disableDatesAfter && isDateAfter(day, disableDatesAfter);
        return createElement(Day, { focused: focusedDate != null && isSameDay(day, focusedDate), day: day, key: dayIndex, onFocus: onFocus, onClick: handleDateClick, onHover: onHover, selected: selected != null && dateIsSelected(day, selected), inRange: selected != null && dateIsInRange(day, selected), disabled: disabled, inHoveringRange: selected != null && hoverDate != null && isInHoveringRange(day, selected, hoverDate) });
    }
    var weeksMarkup = weeks.map(function (week, index) {
        return createElement(
            'div',
            { role: 'row', className: styles$26.Week, key: index },
            week.map(renderWeek)
        );
    });
    return createElement(
        'div',
        { role: 'grid', className: styles$26.Month },
        createElement(
            'div',
            { className: className },
            Months[month],
            ' ',
            year
        ),
        createElement(
            'div',
            { role: 'rowheader', className: styles$26.WeekHeadings },
            weekdays
        ),
        weeksMarkup
    );
}
function hoveringDateIsInRange(day, range, hoverEndDate) {
    if (day == null) {
        return false;
    }
    var start = range.start,
        end = range.end;

    return Boolean(start === end && day > start && day <= hoverEndDate);
}

var DatePicker$1 = function (_React$PureComponent) {
    _inherits(DatePicker, _React$PureComponent);

    function DatePicker(props) {
        _classCallCheck(this, DatePicker);

        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

        var selected = props.selected;

        var range = selected instanceof Date ? { start: selected, end: selected } : selected;
        _this.state = {
            hoverDate: range && range.end
        };
        return _this;
    }

    _createClass(DatePicker, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                month = _props.month,
                year = _props.year,
                multiMonth = _props.multiMonth,
                disableDatesBefore = _props.disableDatesBefore,
                disableDatesAfter = _props.disableDatesAfter,
                selected = _props.selected;
            var _state = this.state,
                hoverDate = _state.hoverDate,
                focusDate = _state.focusDate;

            var allowRange = selected != null && !(selected instanceof Date);
            var range = selected != null && selected instanceof Date ? { start: selected, end: selected } : selected;
            var showNextYear = getNextDisplayYear(month, year);
            var showNextMonth = getNextDisplayMonth(month);
            var showNextToNextYear = getNextDisplayYear(showNextMonth, showNextYear);
            var showNextToNextMonth = getNextDisplayMonth(showNextMonth);
            var showPreviousYear = getPreviousDisplayYear(month, year);
            var showPreviousMonth = getPreviousDisplayMonth(month);
            var previousMonthName = Months[showPreviousMonth];
            var nextMonth = multiMonth ? Months[showNextToNextMonth] : Months[showNextMonth];
            var nextYear = multiMonth ? showNextToNextYear : showNextYear;
            var secondDatePicker = multiMonth ? createElement(Month, { onFocus: this.handleFocus, focusedDate: focusDate, month: showNextMonth, year: showNextYear, selected: range, hoverDate: hoverDate, onChange: this.handleDateSelection, onHover: this.handleHover, disableDatesBefore: disableDatesBefore, disableDatesAfter: disableDatesAfter, allowRange: allowRange }) : null;
            return createElement(
                'div',
                { className: styles$26.DatePicker, onKeyDown: handleKeyDown, onKeyUp: this.handleKeyUp },
                createElement(
                    'div',
                    { className: styles$26.Header },
                    createElement(Button$1, { plain: true, icon: 'arrowLeft', accessibilityLabel: 'Show previous month, ' + previousMonthName + ' ' + showPreviousYear, onClick: this.handleMonthChangeClick.bind(null, showPreviousMonth, showPreviousYear) }),
                    createElement(Button$1, { plain: true, icon: 'arrowRight', accessibilityLabel: 'Show next month, ' + nextMonth + ' ' + nextYear, onClick: this.handleMonthChangeClick.bind(null, showNextMonth, showNextYear) })
                ),
                createElement(
                    'div',
                    { className: styles$26.MonthContainer },
                    createElement(Month, { onFocus: this.handleFocus, focusedDate: focusDate, month: month, year: year, selected: range, hoverDate: hoverDate, onChange: this.handleDateSelection, onHover: this.handleHover, disableDatesBefore: disableDatesBefore, disableDatesAfter: disableDatesAfter, allowRange: allowRange }),
                    secondDatePicker
                )
            );
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus(date) {
            this.setState({
                focusDate: date
            });
        }
    }, {
        key: 'handleKeyUp',
        value: function handleKeyUp(event) {
            var key = event.key;
            var _props2 = this.props,
                selected = _props2.selected,
                disableDatesBefore = _props2.disableDatesBefore,
                disableDatesAfter = _props2.disableDatesAfter;
            var focusDate = this.state.focusDate;

            var range = selected instanceof Date ? { start: selected, end: selected } : selected;
            var focusedDate = focusDate || range && range.start;
            if (focusedDate == null) {
                return;
            }
            if (key === 'ArrowUp') {
                var previousWeek = new Date(focusedDate);
                previousWeek.setDate(focusedDate.getDate() - 7);
                if (!(disableDatesBefore && isDateBefore(previousWeek, disableDatesBefore))) {
                    this.setFocusDateAndHandleMonthChange(previousWeek);
                }
            }
            if (key === 'ArrowDown') {
                var nextWeek = new Date(focusedDate);
                nextWeek.setDate(focusedDate.getDate() + 7);
                if (!(disableDatesAfter && isDateAfter(nextWeek, disableDatesAfter))) {
                    this.setFocusDateAndHandleMonthChange(nextWeek);
                }
            }
            if (key === 'ArrowRight') {
                var tomorrow = new Date(focusedDate);
                tomorrow.setDate(focusedDate.getDate() + 1);
                if (!(disableDatesAfter && isDateAfter(tomorrow, disableDatesAfter))) {
                    this.setFocusDateAndHandleMonthChange(tomorrow);
                }
            }
            if (key === 'ArrowLeft') {
                var yesterday = new Date(focusedDate);
                yesterday.setDate(focusedDate.getDate() - 1);
                if (!(disableDatesBefore && isDateBefore(yesterday, disableDatesBefore))) {
                    this.setFocusDateAndHandleMonthChange(yesterday);
                }
            }
        }
    }, {
        key: 'setFocusDateAndHandleMonthChange',
        value: function setFocusDateAndHandleMonthChange(date) {
            var onMonthChange = this.props.onMonthChange;

            if (onMonthChange) {
                onMonthChange(date.getMonth(), date.getFullYear());
            }
            this.setState({
                hoverDate: date,
                focusDate: date
            });
        }
    }, {
        key: 'handleDateSelection',
        value: function handleDateSelection(selected) {
            var endDate = selected.end;
            var _props$onChange = this.props.onChange,
                onChange = _props$onChange === undefined ? noop : _props$onChange;

            this.setState({
                hoverDate: endDate,
                focusDate: new Date(endDate)
            });
            onChange(selected);
        }
    }, {
        key: 'handleMonthChangeClick',
        value: function handleMonthChangeClick(month, year) {
            var onMonthChange = this.props.onMonthChange;

            if (!onMonthChange) {
                return;
            }
            this.setState({
                focusDate: undefined
            });
            onMonthChange(month, year);
        }
    }, {
        key: 'handleHover',
        value: function handleHover(date) {
            this.setState({
                hoverDate: date
            });
        }
    }]);

    return DatePicker;
}(PureComponent);

__decorate([autobind], DatePicker$1.prototype, "handleFocus", null);
__decorate([autobind], DatePicker$1.prototype, "handleKeyUp", null);
__decorate([autobind], DatePicker$1.prototype, "setFocusDateAndHandleMonthChange", null);
__decorate([autobind], DatePicker$1.prototype, "handleDateSelection", null);
__decorate([autobind], DatePicker$1.prototype, "handleMonthChangeClick", null);
__decorate([autobind], DatePicker$1.prototype, "handleHover", null);
function handleKeyDown(event) {
    var key = event.key;

    if (key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight') {
        event.preventDefault();
        event.stopPropagation();
    }
}

var styles$27 = {
  "DescriptionList": "Polaris-DescriptionList",
  "Term": "Polaris-DescriptionList__Term",
  "Description": "Polaris-DescriptionList__Description",
  "skeletonShimmerAnimation": "Polaris-DescriptionList--skeletonShimmerAnimation",
};

function DescriptionList$1(_ref) {
    var items = _ref.items;

    var terms = items.reduce(function (allTerms, _ref2) {
        var term = _ref2.term,
            description = _ref2.description;
        return [].concat(_toConsumableArray(allTerms), [createElement(
            'dt',
            { key: term + '-term', className: styles$27.Term },
            term
        ), createElement(
            'dd',
            { key: term + '-description', className: styles$27.Description },
            description
        )]);
    }, []);
    return createElement(
        'dl',
        { className: styles$27.DescriptionList },
        terms
    );
}

var styles$28 = {
  "DisplayText": "Polaris-DisplayText",
  "sizeSmall": "Polaris-DisplayText--sizeSmall",
  "sizeMedium": "Polaris-DisplayText--sizeMedium",
  "sizeLarge": "Polaris-DisplayText--sizeLarge",
  "sizeExtraLarge": "Polaris-DisplayText--sizeExtraLarge",
  "skeletonShimmerAnimation": "Polaris-DisplayText--skeletonShimmerAnimation",
};

function DisplayText$1(_ref) {
    var _ref$element = _ref.element,
        Element = _ref$element === undefined ? 'p' : _ref$element,
        children = _ref.children,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 'medium' : _ref$size;

    var className = classNames(styles$28.DisplayText, size && styles$28[variationName('size', size)]);
    return createElement(
        Element,
        { className: className },
        children
    );
}

var styles$29 = {
  "EmptyState": "Polaris-EmptyState",
  "imageContained": "Polaris-EmptyState--imageContained",
  "Image": "Polaris-EmptyState__Image",
  "Section": "Polaris-EmptyState__Section",
  "ImageContainer": "Polaris-EmptyState__ImageContainer",
  "DetailsContainer": "Polaris-EmptyState__DetailsContainer",
  "Details": "Polaris-EmptyState__Details",
  "Content": "Polaris-EmptyState__Content",
  "Actions": "Polaris-EmptyState__Actions",
  "skeletonShimmerAnimation": "Polaris-EmptyState--skeletonShimmerAnimation",
};

var EmptyState$1 = function (_React$PureComponent) {
  _inherits(EmptyState, _React$PureComponent);

  function EmptyState() {
    _classCallCheck(this, EmptyState);

    return _possibleConstructorReturn(this, (EmptyState.__proto__ || Object.getPrototypeOf(EmptyState)).apply(this, arguments));
  }

  _createClass(EmptyState, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          heading = _props.heading,
          image = _props.image,
          largeImage = _props.largeImage,
          imageContained = _props.imageContained,
          action = _props.action,
          secondaryAction = _props.secondaryAction;

      var className = classNames(styles$29.EmptyState, imageContained && styles$29.imageContained);
      var imageMarkup = largeImage ? createElement(Image$1, { alt: '', role: 'presentation', className: styles$29.Image, source: largeImage, sourceSet: [{ source: image, descriptor: '568w' }, { source: largeImage, descriptor: '1136w' }], sizes: '(max-width: 568px) 60vw' }) : createElement(Image$1, { role: 'presentation', alt: '', className: styles$29.Image, source: image });
      var secondaryActionMarkup = secondaryAction ? buttonFrom(secondaryAction, { plain: true }) : null;
      return createElement(
        'div',
        { className: className },
        createElement(
          'div',
          { className: styles$29.Section },
          createElement(
            'div',
            { className: styles$29.DetailsContainer },
            createElement(
              'div',
              { className: styles$29.Details },
              createElement(
                TextContainer$1,
                null,
                createElement(
                  DisplayText$1,
                  { size: 'medium' },
                  heading
                ),
                createElement(
                  'div',
                  { className: styles$29.Content },
                  children
                )
              ),
              createElement(
                'div',
                { className: styles$29.Actions },
                createElement(
                  ButtonGroup$1,
                  null,
                  buttonFrom(action, { primary: true, size: 'large' }),
                  secondaryActionMarkup
                )
              )
            )
          ),
          createElement(
            'div',
            { className: styles$29.ImageContainer },
            imageMarkup
          )
        )
      );
    }
  }]);

  return EmptyState;
}(PureComponent);

var styles$30 = {
  "FooterHelp": "Polaris-FooterHelp",
  "Content": "Polaris-FooterHelp__Content",
  "Icon": "Polaris-FooterHelp__Icon",
  "Text": "Polaris-FooterHelp__Text",
  "skeletonShimmerAnimation": "Polaris-FooterHelp--skeletonShimmerAnimation",
};

function FooterHelp$1(_ref) {
  var children = _ref.children;

  return createElement(
    'div',
    { className: styles$30.FooterHelp },
    createElement(
      'div',
      { className: styles$30.Content },
      createElement(
        'div',
        { className: styles$30.Icon },
        createElement(Icon$1, { source: 'help', color: 'teal', backdrop: true })
      ),
      createElement(
        'div',
        { className: styles$30.Text },
        children
      )
    )
  );
}

var styles$31 = {
  "FormLayout": "Polaris-FormLayout",
  "condensed": "Polaris-FormLayout--condensed",
  "Item": "Polaris-FormLayout__Item",
  "Title": "Polaris-FormLayout__Title",
  "Items": "Polaris-FormLayout__Items",
  "HelpText": "Polaris-FormLayout__HelpText",
  "skeletonShimmerAnimation": "Polaris-FormLayout--skeletonShimmerAnimation",
};

function Item$4(props) {
    return createElement(
        'div',
        { className: styles$31.Item },
        props.children
    );
}

var getUniqueID$3 = createUniqueIDFactory('FormLayoutGroup');
function Group(_ref) {
    var children = _ref.children,
        condensed = _ref.condensed,
        title = _ref.title,
        helpText = _ref.helpText;

    var className = classNames(condensed && styles$31.condensed);
    var id = getUniqueID$3();
    var helpTextElement = null;
    var helpTextID = void 0;
    var titleElement = null;
    var titleID = void 0;
    if (helpText) {
        helpTextID = id + 'HelpText';
        helpTextElement = createElement(
            'div',
            { id: helpTextID, className: styles$31.HelpText },
            helpText
        );
    }
    if (title) {
        titleID = id + 'Title';
        titleElement = createElement(
            'div',
            { id: titleID, className: styles$31.Title },
            title
        );
    }
    var itemsMarkup = Children.map(children, function (child) {
        return wrapWithComponent(child, Item$4);
    });
    return createElement(
        'div',
        { role: 'group', className: className, 'aria-labelledby': titleID, 'aria-describedby': helpTextID },
        titleElement,
        createElement(
            'div',
            { className: styles$31.Items },
            itemsMarkup
        ),
        helpTextElement
    );
}

var FormLayout$1 = function (_React$PureComponent) {
    _inherits(FormLayout, _React$PureComponent);

    function FormLayout() {
        _classCallCheck(this, FormLayout);

        return _possibleConstructorReturn(this, (FormLayout.__proto__ || Object.getPrototypeOf(FormLayout)).apply(this, arguments));
    }

    _createClass(FormLayout, [{
        key: 'render',
        value: function render() {
            var children = this.props.children;

            return createElement(
                'div',
                { className: styles$31.FormLayout },
                Children.map(children, wrapChildren)
            );
        }
    }]);

    return FormLayout;
}(PureComponent);

FormLayout$1.Group = Group;
function wrapChildren(child, index) {
    if (isElementOfType(child, Group)) {
        return child;
    }
    var props = { key: index };
    return wrapWithComponent(child, Item$4, props);
}

var styles$32 = {
  "KeyboardKey": "Polaris-KeyboardKey",
  "skeletonShimmerAnimation": "Polaris-KeyboardKey--skeletonShimmerAnimation",
};

function KeyboardKey$1(_ref) {
    var children = _ref.children;

    var key = children || '';
    key = key.length > 1 ? key.toLowerCase() : key.toUpperCase();
    return createElement(
        'kbd',
        { className: styles$32.KeyboardKey },
        key
    );
}

var KeypressListener$1 = function (_React$Component) {
    _inherits(KeypressListener, _React$Component);

    function KeypressListener() {
        _classCallCheck(this, KeypressListener);

        return _possibleConstructorReturn(this, (KeypressListener.__proto__ || Object.getPrototypeOf(KeypressListener)).apply(this, arguments));
    }

    _createClass(KeypressListener, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            addEventListener(document, 'keyup', this.handleKeyEvent);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            removeEventListener(document, 'keyup', this.handleKeyEvent);
        }
        // tslint:disable-next-line prefer-function-over-method

    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }, {
        key: 'handleKeyEvent',
        value: function handleKeyEvent(event) {
            var _props = this.props,
                keyCode = _props.keyCode,
                handler = _props.handler;

            if (event.keyCode === keyCode) {
                handler(event);
            }
        }
    }]);

    return KeypressListener;
}(Component);

__decorate([autobind], KeypressListener$1.prototype, "handleKeyEvent", null);

var styles$33 = {
  "Label": "Polaris-Label",
  "hidden": "Polaris-Label--hidden",
  "Text": "Polaris-Label__Text",
  "skeletonShimmerAnimation": "Polaris-Label--skeletonShimmerAnimation",
};

function labelID(id) {
    return id + 'Label';
}
function Label$1(_ref) {
    var children = _ref.children,
        id = _ref.id,
        hidden = _ref.hidden;

    var className = classNames(styles$33.Label, hidden && styles$33.hidden);
    return createElement(
        'div',
        { className: className },
        createElement(
            'label',
            { id: labelID(id), htmlFor: id, className: styles$33.Text },
            children
        )
    );
}

var styles$34 = {
  "hidden": "Polaris-Labelled--hidden",
  "LabelWrapper": "Polaris-Labelled__LabelWrapper",
  "HelpText": "Polaris-Labelled__HelpText",
  "Error": "Polaris-Labelled__Error",
  "ErrorIcon": "Polaris-Labelled__ErrorIcon",
  "skeletonShimmerAnimation": "Polaris-Labelled--skeletonShimmerAnimation",
};

function Labelled$1(_a) {
    var id = _a.id,
        label = _a.label,
        error = _a.error,
        action = _a.action,
        helpText = _a.helpText,
        children = _a.children,
        labelHidden = _a.labelHidden,
        rest = __rest(_a, ["id", "label", "error", "action", "helpText", "children", "labelHidden"]);

    var className = classNames(labelHidden && styles$34.hidden);
    var actionMarkup = action ? buttonFrom(action, { plain: true }) : null;
    var helpTextMarkup = helpText ? createElement(
        'div',
        { className: styles$34.HelpText, id: helpTextID$1(id) },
        helpText
    ) : null;
    var errorMarkup = typeof error === 'string' ? createElement(
        'div',
        { id: errorID$1(id), className: styles$34.Error },
        createElement(
            'div',
            { className: styles$34.ErrorIcon },
            createElement(Icon$1, { source: 'alert' })
        ),
        error
    ) : null;
    var labelMarkup = label ? createElement(
        'div',
        { className: styles$34.LabelWrapper },
        createElement(
            Label$1,
            Object.assign({ id: id }, rest, { hidden: false }),
            label
        ),
        actionMarkup
    ) : null;
    return createElement(
        'div',
        { className: className },
        labelMarkup,
        children,
        errorMarkup,
        helpTextMarkup
    );
}
function errorID$1(id) {
    return id + 'Error';
}
function helpTextID$1(id) {
    return id + 'HelpText';
}

var styles$35 = {
  "Layout": "Polaris-Layout",
  "Section": "Polaris-Layout__Section",
  "Section-secondary": "Polaris-Layout__Section--secondary",
  "AnnotatedSection": "Polaris-Layout__AnnotatedSection",
  "AnnotationWrapper": "Polaris-Layout__AnnotationWrapper",
  "AnnotationContent": "Polaris-Layout__AnnotationContent",
  "Annotation": "Polaris-Layout__Annotation",
  "skeletonShimmerAnimation": "Polaris-Layout--skeletonShimmerAnimation",
};

function Section$1(_ref) {
    var children = _ref.children,
        secondary = _ref.secondary;

    var className = classNames(styles$35.Section, secondary && styles$35['Section-secondary']);
    return createElement(
        'div',
        { className: className },
        children
    );
}

function AnnotatedSection(props) {
  var children = props.children,
      title = props.title,
      description = props.description;

  var wrappedDescription = typeof description === 'string' ? createElement(
    'p',
    null,
    description
  ) : description;
  return createElement(
    'div',
    { className: styles$35.AnnotatedSection },
    createElement(
      'div',
      { className: styles$35.AnnotationWrapper },
      createElement(
        'div',
        { className: styles$35.Annotation },
        createElement(
          TextContainer$1,
          null,
          createElement(
            Heading$1,
            null,
            title
          ),
          wrappedDescription
        )
      ),
      createElement(
        'div',
        { className: styles$35.AnnotationContent },
        children
      )
    )
  );
}

var Layout$1 = function (_React$Component) {
    _inherits(Layout, _React$Component);

    function Layout() {
        _classCallCheck(this, Layout);

        return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
    }

    _createClass(Layout, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                sectioned = _props.sectioned;

            var content = sectioned ? createElement(
                Section$1,
                null,
                children
            ) : children;
            return createElement(
                'div',
                { className: styles$35.Layout },
                content
            );
        }
    }]);

    return Layout;
}(Component);

Layout$1.AnnotatedSection = AnnotatedSection;
Layout$1.Section = Section$1;

var styles$36 = {
  "Link": "Polaris-Link",
  "skeletonShimmerAnimation": "Polaris-Link--skeletonShimmerAnimation",
};

function Link$1(_ref) {
  var url = _ref.url,
      children = _ref.children,
      onClick = _ref.onClick,
      external = _ref.external;

  return url ? createElement(
    UnstyledLink$1,
    { className: styles$36.Link, url: url, external: external },
    children
  ) : createElement(
    'button',
    { onClick: onClick, className: styles$36.Link },
    children
  );
}

var styles$37 = {
  "List": "Polaris-List",
  "typeBullet": "Polaris-List--typeBullet",
  "Item": "Polaris-List__Item",
  "typeNumber": "Polaris-List--typeNumber",
  "skeletonShimmerAnimation": "Polaris-List--skeletonShimmerAnimation",
};

function Item$5(_ref) {
    var children = _ref.children;

    return createElement(
        'li',
        { className: styles$37.Item },
        children
    );
}

var ContentList = function (_React$PureComponent) {
    _inherits(ContentList, _React$PureComponent);

    function ContentList() {
        _classCallCheck(this, ContentList);

        return _possibleConstructorReturn(this, (ContentList.__proto__ || Object.getPrototypeOf(ContentList)).apply(this, arguments));
    }

    _createClass(ContentList, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                _props$type = _props.type,
                type = _props$type === undefined ? 'bullet' : _props$type;

            var className = classNames(styles$37.List, type && styles$37[variationName('type', type)]);
            var ListElement = type === 'bullet' ? 'ul' : 'ol';
            return createElement(
                ListElement,
                { className: className },
                children
            );
        }
    }]);

    return ContentList;
}(PureComponent);

ContentList.Item = Item$5;

var styles$38 = {
  "Breadcrumb": "Polaris-Breadcrumbs__Breadcrumb",
  "Icon": "Polaris-Breadcrumbs__Icon",
  "Content": "Polaris-Breadcrumbs__Content",
  "skeletonShimmerAnimation": "Polaris-Breadcrumbs--skeletonShimmerAnimation",
};

var Breadcrumbs$1 = function (_React$PureComponent) {
    _inherits(Breadcrumbs, _React$PureComponent);

    function Breadcrumbs() {
        _classCallCheck(this, Breadcrumbs);

        return _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).apply(this, arguments));
    }

    _createClass(Breadcrumbs, [{
        key: 'render',
        value: function render() {
            var breadcrumbs = this.props.breadcrumbs;

            var breadcrumb = breadcrumbs[breadcrumbs.length - 1];
            if (breadcrumb == null) {
                return null;
            }
            var content = breadcrumb.content,
                url = breadcrumb.url;

            return createElement(
                'nav',
                { role: 'navigation' },
                createElement(
                    UnstyledLink$1,
                    { key: content, url: url, className: styles$38.Breadcrumb, onMouseUp: handleMouseUpByBlurring },
                    createElement(
                        'span',
                        { className: styles$38.Icon },
                        createElement(Icon$1, { source: 'chevronLeft' })
                    ),
                    createElement(
                        'span',
                        { className: styles$38.Content },
                        content
                    )
                )
            );
        }
    }]);

    return Breadcrumbs;
}(PureComponent);

var styles$39 = {
  "Pagination": "Polaris-Pagination",
  "plain": "Polaris-Pagination--plain",
  "Button": "Polaris-Pagination__Button",
  "skeletonShimmerAnimation": "Polaris-Pagination--skeletonShimmerAnimation",
};

function Pagination$1(_ref) {
  var hasNext = _ref.hasNext,
      hasPrevious = _ref.hasPrevious,
      nextURL = _ref.nextURL,
      previousURL = _ref.previousURL,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious,
      plain = _ref.plain,
      accessibilityLabel = _ref.accessibilityLabel;

  var label = void 0;
  if (accessibilityLabel) {
    label = accessibilityLabel;
  } else {
    label = 'Pagination';
  }
  var className = classNames$1(styles$39.Pagination, plain && styles$39.plain);
  var previousButton = previousURL ? createElement(
    UnstyledLink$1,
    { className: styles$39.Button, url: previousURL, onMouseUp: handleMouseUpByBlurring, 'aria-label': 'Previous' },
    createElement(Icon$1, { source: 'arrowLeft' })
  ) : createElement(
    'button',
    { onClick: onPrevious, onMouseUp: handleMouseUpByBlurring, className: styles$39.Button, 'aria-label': 'Previous', disabled: !hasPrevious },
    createElement(Icon$1, { source: 'arrowLeft' })
  );
  var nextButton = nextURL ? createElement(
    UnstyledLink$1,
    { className: styles$39.Button, url: nextURL, onMouseUp: handleMouseUpByBlurring, 'aria-label': 'Next' },
    createElement(Icon$1, { source: 'arrowRight' })
  ) : createElement(
    'button',
    { onClick: onNext, onMouseUp: handleMouseUpByBlurring, className: styles$39.Button, 'aria-label': 'Next', disabled: !hasNext },
    createElement(Icon$1, { source: 'arrowRight' })
  );
  return createElement(
    'nav',
    { className: className, 'aria-label': label },
    previousButton,
    nextButton
  );
}

var styles$40 = {
  "Scrollable": "Polaris-Scrollable",
  "horizontal": "Polaris-Scrollable--horizontal",
  "vertical": "Polaris-Scrollable--vertical",
  "hasTopShadow": "Polaris-Scrollable--hasTopShadow",
  "hasBottomShadow": "Polaris-Scrollable--hasBottomShadow",
  "skeletonShimmerAnimation": "Polaris-Scrollable--skeletonShimmerAnimation",
};

var MAX_SCROLL_DISTANCE = 100;
var DELTA_THRESHOLD = 0.2;
var DELTA_PERCENTAGE = 0.2;
var EVENTS_TO_LOCK = ['scroll', 'touchmove', 'wheel'];
var PREFERS_REDUCED_MOTION = prefersReducedMotion();

var Scrollable$1 = function (_React$Component) {
    _inherits(Scrollable, _React$Component);

    function Scrollable() {
        _classCallCheck(this, Scrollable);

        var _this = _possibleConstructorReturn(this, (Scrollable.__proto__ || Object.getPrototypeOf(Scrollable)).apply(this, arguments));

        _this.state = {
            topShadow: false,
            bottomShadow: false,
            scrollPosition: 0
        };
        return _this;
    }

    _createClass(Scrollable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.scrollArea == null) {
                return;
            }
            addEventListener(this.scrollArea, 'scroll', function () {
                window.requestAnimationFrame(_this2.handleScroll);
            });
            addEventListener(window, 'resize', this.handleResize);
            window.requestAnimationFrame(function () {
                _this2.handleScroll();
                if (_this2.props.hint) {
                    _this2.scrollHint();
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.scrollArea == null) {
                return;
            }
            removeEventListener(this.scrollArea, 'scroll', this.handleScroll);
            removeEventListener(window, 'resize', this.handleResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var scrollPosition = this.state.scrollPosition;

            if (scrollPosition && this.scrollArea && scrollPosition > 0) {
                this.scrollArea.scrollTop = scrollPosition;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                topShadow = _state.topShadow,
                bottomShadow = _state.bottomShadow;
            var _a = this.props,
                children = _a.children,
                className = _a.className,
                horizontal = _a.horizontal,
                _a$vertical = _a.vertical,
                vertical = _a$vertical === undefined ? true : _a$vertical,
                shadow = _a.shadow,
                hint = _a.hint,
                rest = __rest(_a, ["children", "className", "horizontal", "vertical", "shadow", "hint"]);
            var finalClassName = classNames(className, styles$40.Scrollable, vertical && styles$40.vertical, horizontal && styles$40.horizontal, topShadow && styles$40.hasTopShadow, bottomShadow && styles$40.hasBottomShadow);
            return createElement(
                'div',
                Object.assign({ className: finalClassName }, scrollable.props, rest, { ref: this.setScrollArea }),
                children
            );
        }
    }, {
        key: 'setScrollArea',
        value: function setScrollArea(scrollArea) {
            this.scrollArea = scrollArea;
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            var scrollArea = this.scrollArea;
            var shadow = this.props.shadow;

            if (scrollArea == null) {
                return;
            }
            var scrollTop = scrollArea.scrollTop,
                clientHeight = scrollArea.clientHeight,
                scrollHeight = scrollArea.scrollHeight;

            var shouldBottomShadow = Boolean(shadow && !(scrollTop + clientHeight >= scrollHeight));
            var shouldTopShadow = Boolean(shadow && scrollTop > 0);
            this.setState({
                topShadow: shouldTopShadow,
                bottomShadow: shouldBottomShadow,
                scrollPosition: scrollTop
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.handleScroll();
        }
    }, {
        key: 'scrollHint',
        value: function scrollHint() {
            var _this3 = this;

            var scrollArea = this.scrollArea;

            if (scrollArea == null) {
                return;
            }
            var clientHeight = scrollArea.clientHeight,
                scrollHeight = scrollArea.scrollHeight;

            if (PREFERS_REDUCED_MOTION || this.state.scrollPosition > 0 || scrollHeight <= clientHeight) {
                return;
            }
            var scrollDistance = scrollHeight - clientHeight;
            this.toggleLock();
            this.setState({ scrollPosition: scrollDistance > MAX_SCROLL_DISTANCE ? MAX_SCROLL_DISTANCE : scrollDistance }, function () {
                window.requestAnimationFrame(_this3.scrollStep);
            });
        }
    }, {
        key: 'scrollStep',
        value: function scrollStep() {
            var _this4 = this;

            this.setState(function (_ref) {
                var scrollPosition = _ref.scrollPosition;

                var delta = scrollPosition * DELTA_PERCENTAGE;
                return {
                    scrollPosition: delta < DELTA_THRESHOLD ? 0 : scrollPosition - delta
                };
            }, function () {
                if (_this4.state.scrollPosition > 0) {
                    window.requestAnimationFrame(_this4.scrollStep);
                } else {
                    _this4.toggleLock(false);
                }
            });
        }
    }, {
        key: 'toggleLock',
        value: function toggleLock() {
            var shouldLock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var scrollArea = this.scrollArea;

            if (scrollArea == null) {
                return;
            }
            EVENTS_TO_LOCK.forEach(function (eventName) {
                if (shouldLock) {
                    addEventListener(scrollArea, eventName, prevent);
                } else {
                    removeEventListener(scrollArea, eventName, prevent);
                }
            });
        }
    }], [{
        key: 'forNode',
        value: function forNode(node) {
            return closest(node, scrollable.selector) || document;
        }
    }]);

    return Scrollable;
}(Component);

__decorate([autobind], Scrollable$1.prototype, "setScrollArea", null);
__decorate([autobind], Scrollable$1.prototype, "handleScroll", null);
__decorate([autobind, debounce(50, { trailing: true })], Scrollable$1.prototype, "handleResize", null);
__decorate([autobind], Scrollable$1.prototype, "scrollHint", null);
__decorate([autobind], Scrollable$1.prototype, "scrollStep", null);
function prevent(evt) {
    evt.preventDefault();
}
function prefersReducedMotion() {
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
        return false;
    }
}

function calculateVerticalPosition(activatorRect, overlayRect, overlayMargins, scrollableContainerRect, containerRect, preferredPosition) {
    var activatorTop = activatorRect.top;
    var activatorBottom = activatorTop + activatorRect.height;
    var spaceAbove = activatorRect.top;
    var spaceBelow = containerRect.height - activatorRect.top - activatorRect.height;
    var desiredHeight = overlayRect.height;
    var verticalMargins = overlayMargins.activator + overlayMargins.container;
    var minimumSpaceToScroll = overlayMargins.container;
    var distanceToTopScroll = activatorRect.top - Math.max(scrollableContainerRect.top, 0);
    var distanceToBottomScroll = containerRect.top + Math.min(containerRect.height, scrollableContainerRect.top + scrollableContainerRect.height) - (activatorRect.top + activatorRect.height);
    var enoughSpaceFromTopScroll = distanceToTopScroll >= minimumSpaceToScroll;
    var enoughSpaceFromBottomScroll = distanceToBottomScroll >= minimumSpaceToScroll;
    var heightIfBelow = Math.min(spaceBelow, desiredHeight);
    var heightIfAbove = Math.min(spaceAbove, desiredHeight);
    var positionIfAbove = {
        height: heightIfAbove - verticalMargins,
        top: activatorTop + containerRect.top - heightIfAbove,
        positioning: 'above'
    };
    var positionIfBelow = {
        height: heightIfBelow - verticalMargins,
        top: activatorBottom + containerRect.top,
        positioning: 'below'
    };
    if (preferredPosition === 'above') {
        return (enoughSpaceFromTopScroll || distanceToTopScroll >= distanceToBottomScroll && !enoughSpaceFromBottomScroll) && (spaceAbove > desiredHeight || spaceAbove > spaceBelow) ? positionIfAbove : positionIfBelow;
    }
    if (preferredPosition === 'below') {
        return (enoughSpaceFromBottomScroll || distanceToBottomScroll >= distanceToTopScroll && !enoughSpaceFromTopScroll) && (spaceBelow > desiredHeight || spaceBelow > spaceAbove) ? positionIfBelow : positionIfAbove;
    }
    if (enoughSpaceFromTopScroll && enoughSpaceFromBottomScroll) {
        return spaceAbove > spaceBelow ? positionIfAbove : positionIfBelow;
    }
    return distanceToTopScroll > minimumSpaceToScroll ? positionIfAbove : positionIfBelow;
}
function calculateHorizontalPosition(activatorRect, overlayRect, containerRect) {
    var maximum = containerRect.width - overlayRect.width;
    return Math.min(maximum, Math.max(0, activatorRect.center.x - overlayRect.width / 2));
}
function rectIsOutsideOfRect(inner, outer) {
    var center = inner.center;

    return center.y < outer.top || center.y > outer.top + outer.height;
}

var styles$41 = {
  "PositionedOverlay": "Polaris-PositionedOverlay",
  "calculating": "Polaris-PositionedOverlay--calculating",
  "skeletonShimmerAnimation": "Polaris-PositionedOverlay--skeletonShimmerAnimation",
};

var PositionedOverlay$1 = function (_React$PureComponent) {
    _inherits(PositionedOverlay, _React$PureComponent);

    function PositionedOverlay() {
        _classCallCheck(this, PositionedOverlay);

        var _this = _possibleConstructorReturn(this, (PositionedOverlay.__proto__ || Object.getPrototypeOf(PositionedOverlay)).apply(this, arguments));

        _this.state = {
            measuring: true,
            activatorRect: getRectForNode(_this.props.activator),
            left: 0,
            top: 0,
            height: 0,
            width: null,
            positioning: 'below',
            zIndex: null,
            outsideScrollableContainer: false
        };
        return _this;
    }

    _createClass(PositionedOverlay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scrollableContainer = Scrollable$1.forNode(this.props.activator);
            this.handleMeasurement();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.handleMeasurement();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _state = this.state,
                outsideScrollableContainer = _state.outsideScrollableContainer,
                top = _state.top;
            var _props = this.props,
                onScrollOut = _props.onScrollOut,
                active = _props.active;

            if (active && onScrollOut != null && top !== 0 && outsideScrollableContainer) {
                onScrollOut();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                left = _state2.left,
                top = _state2.top,
                zIndex = _state2.zIndex,
                width = _state2.width;
            var render = this.props.render;

            var style = {
                top: top,
                left: left,
                width: width,
                zIndex: zIndex == null ? undefined : zIndex
            };
            return createElement(
                'div',
                { className: styles$41.PositionedOverlay, style: style, ref: this.setOverlay },
                createElement(EventListener$1, { event: 'resize', handler: this.handleMeasurement }),
                createElement(EventListener$1, { event: 'scroll', handler: this.handleMeasurement }),
                render(this.overlayDetails())
            );
        }
    }, {
        key: 'overlayDetails',
        value: function overlayDetails() {
            var _state3 = this.state,
                measuring = _state3.measuring,
                left = _state3.left,
                positioning = _state3.positioning,
                height = _state3.height,
                activatorRect = _state3.activatorRect;

            return {
                measuring: measuring,
                left: left,
                desiredHeight: height,
                positioning: positioning,
                activatorRect: activatorRect
            };
        }
    }, {
        key: 'setOverlay',
        value: function setOverlay(node) {
            this.overlay = node;
        }
    }, {
        key: 'handleMeasurement',
        value: function handleMeasurement() {
            var _this2 = this;

            this.setState({
                left: 0,
                top: 0,
                height: 0,
                positioning: 'below',
                measuring: true
            }, function () {
                if (_this2.overlay == null || _this2.scrollableContainer == null) {
                    return;
                }
                var _props2 = _this2.props,
                    activator = _props2.activator,
                    _props2$preferredPosi = _props2.preferredPosition,
                    preferredPosition = _props2$preferredPosi === undefined ? 'below' : _props2$preferredPosi,
                    onScrollOut = _props2.onScrollOut,
                    fullWidth = _props2.fullWidth;

                var activatorRect = getRectForNode(activator);
                var currentOverlayRect = getRectForNode(_this2.overlay);
                var scrollableElement = isDocument(_this2.scrollableContainer) ? document.body : _this2.scrollableContainer;
                var scrollableContainerRect = getRectForNode(scrollableElement);
                var overlayRect = fullWidth ? Object.assign({}, currentOverlayRect, { width: activatorRect.width }) : currentOverlayRect;
                // If `body` is 100% height, it still acts as though it were not constrained
                // to that size. This adjusts for that.
                if (scrollableElement === document.body) {
                    scrollableContainerRect.height = document.body.scrollHeight;
                }
                var overlayMargins = _this2.overlay.firstElementChild ? getMarginsForNode(_this2.overlay.firstElementChild) : { activator: 0, container: 0, horizontal: 0 };
                var containerRect = windowRect();
                var zIndexForLayer = getZIndexForLayerFromNode(activator);
                var zIndex = zIndexForLayer == null ? zIndexForLayer : zIndexForLayer + 1;
                var verticalPosition = calculateVerticalPosition(activatorRect, overlayRect, overlayMargins, scrollableContainerRect, containerRect, preferredPosition);
                var horizontalPosition = calculateHorizontalPosition(activatorRect, overlayRect, containerRect);
                _this2.setState({
                    measuring: false,
                    activatorRect: getRectForNode(activator),
                    left: horizontalPosition,
                    top: verticalPosition.top,
                    height: verticalPosition.height,
                    width: fullWidth ? overlayRect.width : null,
                    positioning: verticalPosition.positioning,
                    outsideScrollableContainer: onScrollOut != null && rectIsOutsideOfRect(activatorRect, intersectionWithViewport(scrollableContainerRect)),
                    zIndex: zIndex
                });
            });
        }
    }]);

    return PositionedOverlay;
}(PureComponent);

__decorate([autobind], PositionedOverlay$1.prototype, "overlayDetails", null);
__decorate([autobind], PositionedOverlay$1.prototype, "setOverlay", null);
__decorate([autobind], PositionedOverlay$1.prototype, "handleMeasurement", null);
function intersectionWithViewport(rect) {
    var viewport = windowRect();
    return new Rect({
        top: Math.max(rect.top, 0),
        left: Math.max(rect.left, 0),
        height: Math.min(rect.height - rect.top + viewport.top, viewport.height, viewport.height - rect.top),
        width: Math.min(rect.width - rect.left + viewport.left, viewport.width, viewport.width - rect.left)
    });
}
function getMarginsForNode(node) {
    var styles$$1 = window.getComputedStyle(node);
    return {
        activator: parseFloat(styles$$1.marginTop || ''),
        container: parseFloat(styles$$1.marginBottom || ''),
        horizontal: parseFloat(styles$$1.marginLeft || '')
    };
}
function getZIndexForLayerFromNode(node) {
    var layerNode = closest(node, layer.selector) || document.body;
    var zIndex = parseInt(window.getComputedStyle(layerNode).zIndex || '0', 10);
    return isNaN(zIndex) ? null : zIndex;
}
function windowRect() {
    return new Rect({
        top: window.scrollY,
        left: window.scrollX,
        height: window.innerHeight,
        width: window.innerWidth
    });
}
function isDocument(node) {
    return node === document;
}

var styles$42 = {
  "Popover": "Polaris-Popover",
  "fullWidth": "Polaris-Popover--fullWidth",
  "Content": "Polaris-Popover__Content",
  "measuring": "Polaris-Popover--measuring",
  "exiting": "Polaris-Popover--exiting",
  "positionedAbove": "Polaris-Popover--positionedAbove",
  "Tip": "Polaris-Popover__Tip",
  "Wrapper": "Polaris-Popover__Wrapper",
  "Pane": "Polaris-Popover__Pane",
  "Pane-fixed": "Polaris-Popover__Pane--fixed",
  "Section": "Polaris-Popover__Section",
  "FocusTracker": "Polaris-Popover__FocusTracker",
  "skeletonShimmerAnimation": "Polaris-Popover--skeletonShimmerAnimation",
};

function Section$2(_ref) {
    var children = _ref.children;

    return createElement(
        'div',
        { className: styles$42.Section },
        children
    );
}

function Pane(_ref) {
    var fixed = _ref.fixed,
        sectioned = _ref.sectioned,
        children = _ref.children;

    var className = classNames(styles$42.Pane, fixed && styles$42['Pane-fixed']);
    var content = sectioned ? wrapWithComponent(children, Section$2) : children;
    return fixed ? createElement(
        'div',
        { className: className },
        content
    ) : createElement(
        Scrollable$1,
        { hint: true, shadow: true, className: className },
        content
    );
}

var CloseSource;
(function (CloseSource) {
    CloseSource[CloseSource["Click"] = 0] = "Click";
    CloseSource[CloseSource["EscapeKeypress"] = 1] = "EscapeKeypress";
    CloseSource[CloseSource["FocusOut"] = 2] = "FocusOut";
    CloseSource[CloseSource["ScrollOut"] = 3] = "ScrollOut";
})(CloseSource || (CloseSource = {}));

var PopoverOverlay = function (_React$PureComponent) {
    _inherits(PopoverOverlay, _React$PureComponent);

    function PopoverOverlay() {
        _classCallCheck(this, PopoverOverlay);

        return _possibleConstructorReturn(this, (PopoverOverlay.__proto__ || Object.getPrototypeOf(PopoverOverlay)).apply(this, arguments));
    }

    _createClass(PopoverOverlay, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref) {
            var _this2 = this;

            var wasActive = _ref.active;
            var _props = this.props,
                active = _props.active,
                preventAutofocus = _props.preventAutofocus;

            if (!active || preventAutofocus || !active || active === wasActive) {
                return;
            }
            if (this.contentNode == null) {
                return;
            }
            write(function () {
                if (_this2.contentNode == null) {
                    return;
                }
                var focusableChild = findFirstFocusableNode(_this2.contentNode);
                (focusableChild || _this2.contentNode).focus();
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var active = this.props.active;

            return createElement(
                Transition,
                { 'in': active, timeout: 500 },
                this.renderOverlay
            );
        }
    }, {
        key: 'renderOverlay',
        value: function renderOverlay(transitionStatus) {
            var _props2 = this.props,
                active = _props2.active,
                activator = _props2.activator,
                fullWidth = _props2.fullWidth,
                _props2$preferredPosi = _props2.preferredPosition,
                preferredPosition = _props2$preferredPosi === undefined ? 'below' : _props2$preferredPosi;

            if (transitionStatus === 'exited') {
                return null;
            }
            return createElement(PositionedOverlay$1, { fullWidth: fullWidth, active: active, activator: activator, preferredPosition: preferredPosition, render: this.renderPopover.bind(this, transitionStatus), onScrollOut: this.handleScrollOut });
        }
    }, {
        key: 'renderPopover',
        value: function renderPopover(transitionStatus, overlayDetails) {
            var measuring = overlayDetails.measuring,
                left = overlayDetails.left,
                desiredHeight = overlayDetails.desiredHeight,
                positioning = overlayDetails.positioning,
                activatorRect = overlayDetails.activatorRect;
            var _props3 = this.props,
                id = _props3.id,
                children = _props3.children,
                sectioned = _props3.sectioned,
                fullWidth = _props3.fullWidth;

            var className = classNames(styles$42.Popover, transitionStatus && animationVariations(transitionStatus), positioning === 'above' && styles$42.positionedAbove, fullWidth && styles$42.fullWidth, measuring && styles$42.measuring);
            this.transitionStatus = transitionStatus;
            var tipMarkup = !measuring ? createElement('div', { style: { left: activatorRect.center.x - left }, className: styles$42.Tip }) : null;
            var contentStyles = measuring ? undefined : { height: desiredHeight };
            var content = createElement(
                'div',
                { id: id, tabIndex: -1, className: styles$42.Content, style: contentStyles, ref: this.setContentNode },
                renderPopoverContent(children, { sectioned: sectioned })
            );
            return createElement(
                'div',
                Object.assign({ className: className }, overlay.props),
                createElement(EventListener$1, { event: 'click', handler: this.handleClick }),
                createElement(EventListener$1, { event: 'touchstart', handler: this.handleClick }),
                createElement(KeypressListener$1, { keyCode: Keys.ESCAPE, handler: this.handleEscape }),
                tipMarkup,
                createElement('div', { className: styles$42.FocusTracker, tabIndex: 0, onFocus: this.handleFocusFirstItem }),
                createElement(
                    'div',
                    { className: styles$42.Wrapper },
                    content
                ),
                createElement('div', { className: styles$42.FocusTracker, tabIndex: 0, onFocus: this.handleFocusLastItem })
            );
        }
    }, {
        key: 'setContentNode',
        value: function setContentNode(node) {
            this.contentNode = node;
        }
    }, {
        key: 'handleClick',
        value: function handleClick(event) {
            var target = event.target;
            var contentNode = this.contentNode,
                _props4 = this.props,
                activator = _props4.activator,
                onClose = _props4.onClose;

            if (contentNode != null && nodeContainsDescendant(contentNode, target) || nodeContainsDescendant(activator, target) || this.transitionStatus !== 'entered') {
                return;
            }
            onClose(CloseSource.Click);
        }
    }, {
        key: 'handleScrollOut',
        value: function handleScrollOut() {
            this.props.onClose(CloseSource.ScrollOut);
        }
    }, {
        key: 'handleEscape',
        value: function handleEscape() {
            this.props.onClose(CloseSource.EscapeKeypress);
        }
    }, {
        key: 'handleFocusFirstItem',
        value: function handleFocusFirstItem() {
            this.props.onClose(CloseSource.FocusOut);
        }
    }, {
        key: 'handleFocusLastItem',
        value: function handleFocusLastItem() {
            this.props.onClose(CloseSource.FocusOut);
        }
    }]);

    return PopoverOverlay;
}(PureComponent);

__decorate([autobind], PopoverOverlay.prototype, "renderOverlay", null);
__decorate([autobind], PopoverOverlay.prototype, "renderPopover", null);
__decorate([autobind], PopoverOverlay.prototype, "setContentNode", null);
__decorate([autobind], PopoverOverlay.prototype, "handleClick", null);
__decorate([autobind], PopoverOverlay.prototype, "handleScrollOut", null);
__decorate([autobind], PopoverOverlay.prototype, "handleEscape", null);
__decorate([autobind], PopoverOverlay.prototype, "handleFocusFirstItem", null);
__decorate([autobind], PopoverOverlay.prototype, "handleFocusLastItem", null);
function renderPopoverContent(children, props) {
    var childrenArray = Children.toArray(children);
    if (isElementOfType(childrenArray[0], Pane)) {
        return childrenArray;
    }
    return wrapWithComponent(childrenArray, Pane, props);
}
function animationVariations(status) {
    switch (status) {
        case 'exiting':
            return styles$42.exiting;
        default:
            return null;
    }
}

var getUniqueID$4 = createUniqueIDFactory('Popover');
var Popover$1 = function (_React$PureComponent) {
    _inherits(Popover, _React$PureComponent);

    function Popover() {
        _classCallCheck(this, Popover);

        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));

        _this.state = {
            activatorFocused: false
        };
        _this.id = getUniqueID$4();
        return _this;
    }

    _createClass(Popover, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setAccessibilityAttributes();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.setAccessibilityAttributes();
        }
    }, {
        key: 'renderLayer',
        value: function renderLayer() {
            var _a = this.props,
                children = _a.children,
                onClose = _a.onClose,
                activator = _a.activator,
                activatorWrapper = _a.activatorWrapper,
                rest = __rest(_a, ["children", "onClose", "activator", "activatorWrapper"]);
            if (this.activatorNode == null) {
                return null;
            }
            return createElement(
                PopoverOverlay,
                Object.assign({ id: this.id, activator: this.activatorNode, onClose: this.handleClose }, rest),
                children
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$activatorWrapp = this.props.activatorWrapper,
                WrapperComponent = _props$activatorWrapp === undefined ? 'div' : _props$activatorWrapp;

            return createElement(
                WrapperComponent,
                { ref: this.setActivator },
                Children.only(this.props.activator)
            );
        }
    }, {
        key: 'setAccessibilityAttributes',
        value: function setAccessibilityAttributes() {
            var id = this.id,
                activatorContainer = this.activatorContainer;

            if (activatorContainer == null) {
                return;
            }
            var firstFocusable = findFirstFocusableNode(activatorContainer);
            var focusableActivator = firstFocusable || activatorContainer;
            focusableActivator.tabIndex = focusableActivator.tabIndex || 0;
            focusableActivator.setAttribute('aria-controls', id);
            focusableActivator.setAttribute('aria-owns', id);
            focusableActivator.setAttribute('aria-haspopup', 'true');
            focusableActivator.setAttribute('aria-expanded', String(this.props.active));
        }
    }, {
        key: 'handleClose',
        value: function handleClose(source) {
            this.props.onClose(source);
            if (this.activatorContainer == null) {
                return;
            }
            if (source === CloseSource.FocusOut || source === CloseSource.EscapeKeypress) {
                focusFirstFocusableNode(this.activatorContainer, false);
            }
        }
    }, {
        key: 'setActivator',
        value: function setActivator(node) {
            if (node == null) {
                this.activatorNode = null;
                this.activatorContainer = null;
                return;
            }
            this.activatorNode = node.firstElementChild;
            this.activatorContainer = node;
        }
    }]);

    return Popover;
}(PureComponent);
Popover$1.Pane = Pane;
Popover$1.Section = Section$2;
__decorate([autobind], Popover$1.prototype, "handleClose", null);
__decorate([autobind], Popover$1.prototype, "setActivator", null);
Popover$1 = __decorate([layeredComponent({ idPrefix: 'Popover' })], Popover$1);
var Popover$2 = Popover$1;

var styles$43 = {
  "Page": "Polaris-Page",
  "fullWidth": "Polaris-Page--fullWidth",
  "Content": "Polaris-Page__Content",
  "Header": "Polaris-Page__Header",
  "Header-hasPagination": "Polaris-Page__Header--hasPagination",
  "Header-hasBreadcrumbs": "Polaris-Page__Header--hasBreadcrumbs",
  "Header-hasSecondaryActions": "Polaris-Page__Header--hasSecondaryActions",
  "Header-hasSeparator": "Polaris-Page__Header--hasSeparator",
  "Header-hasRollup": "Polaris-Page__Header--hasRollup",
  "IndividualActions": "Polaris-Page__IndividualActions",
  "Rollup": "Polaris-Page__Rollup",
  "Navigation": "Polaris-Page__Navigation",
  "Pagination": "Polaris-Page__Pagination",
  "MainContent": "Polaris-Page__MainContent",
  "TitleAndActions": "Polaris-Page__TitleAndActions",
  "Title": "Polaris-Page__Title",
  "Actions": "Polaris-Page__Actions",
  "SecondaryActions": "Polaris-Page__SecondaryActions",
  "Action": "Polaris-Page__Action",
  "ActionGroup": "Polaris-Page__ActionGroup",
  "PrimaryAction": "Polaris-Page__PrimaryAction",
  "ActionIcon": "Polaris-Page__ActionIcon",
  "disabled": "Polaris-Page--disabled",
  "ActionContent": "Polaris-Page__ActionContent",
  "Details": "Polaris-Page__Details",
  "skeletonShimmerAnimation": "Polaris-Page--skeletonShimmerAnimation",
};

function Action(_ref) {
    var icon = _ref.icon,
        url = _ref.url,
        external = _ref.external,
        onAction = _ref.onAction,
        children = _ref.children,
        disclosure = _ref.disclosure,
        accessibilityLabel = _ref.accessibilityLabel,
        disabled = _ref.disabled;

    var iconMarkup = icon ? createElement(
        'span',
        { className: styles$43.ActionIcon },
        createElement(Icon$1, { source: icon })
    ) : null;
    var disclosureIconMarkup = disclosure ? createElement(
        'span',
        { className: styles$43.ActionIcon },
        createElement(Icon$1, { source: 'caretDown' })
    ) : null;
    var contentMarkup = iconMarkup || disclosureIconMarkup ? createElement(
        'span',
        { className: styles$43.ActionContent },
        iconMarkup,
        createElement(
            'span',
            null,
            children
        ),
        disclosureIconMarkup
    ) : children;
    if (url) {
        return createElement(
            UnstyledLink$1,
            { key: children, external: external, url: url, onMouseUp: handleMouseUpByBlurring, className: styles$43.Action, 'aria-label': accessibilityLabel },
            contentMarkup
        );
    }
    var className = classNames$1(styles$43.Action, disabled && styles$43.disabled, icon && children == null && styles$43.iconOnly);
    return createElement(
        'button',
        { key: children, className: className, onClick: onAction, onMouseUp: handleMouseUpByBlurring, 'aria-label': accessibilityLabel, type: 'button', disabled: disabled },
        contentMarkup
    );
}

var Header$1 = function (_React$PureComponent) {
    _inherits(Header, _React$PureComponent);

    function Header() {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));

        _this.state = {
            rollupOpen: false
        };
        return _this;
    }

    _createClass(Header, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                _props$breadcrumbs = _props.breadcrumbs,
                breadcrumbs = _props$breadcrumbs === undefined ? [] : _props$breadcrumbs,
                primaryAction = _props.primaryAction,
                pagination = _props.pagination,
                separator = _props.separator,
                secondaryActions = _props.secondaryActions;

            var className = classNames(styles$43.Header, pagination && styles$43['Header-hasPagination'], separator && styles$43['Header-hasSeparator'], breadcrumbs && breadcrumbs.length && styles$43['Header-hasBreadcrumbs'], this.hasRollup && styles$43['Header-hasRollup'], secondaryActions && secondaryActions.length && styles$43['Header-hasSecondaryActions']);
            var breadcrumbMarkup = breadcrumbs.length > 0 ? createElement(Breadcrumbs$1, { breadcrumbs: breadcrumbs }) : null;
            var primaryActionMarkup = primaryAction ? createElement(
                'div',
                { className: styles$43.PrimaryAction },
                buttonsFrom(primaryAction, { primary: true })
            ) : null;
            var paginationMarkup = pagination ? createElement(
                'div',
                { className: styles$43.Pagination },
                createElement(Pagination$1, Object.assign({}, pagination, { plain: true }))
            ) : null;
            var nonPrimaryActionsMarkup = this.renderSecondaryActions();
            var actionsMarkup = createElement(
                'div',
                { className: styles$43.Actions },
                primaryActionMarkup,
                nonPrimaryActionsMarkup
            );
            var navigationMarkup = breadcrumbMarkup || paginationMarkup ? createElement(
                'div',
                { className: styles$43.Navigation },
                breadcrumbMarkup,
                paginationMarkup
            ) : null;
            var titleMarkup = createElement(
                'div',
                { className: styles$43.Title },
                createElement(
                    DisplayText$1,
                    { size: 'large', element: 'h1' },
                    title
                )
            );
            return primaryActionMarkup ? createElement(
                'div',
                { className: className },
                navigationMarkup,
                createElement(
                    'div',
                    { className: styles$43.MainContent },
                    createElement(
                        'div',
                        { className: styles$43.TitleAndActions },
                        titleMarkup,
                        actionsMarkup
                    ),
                    primaryActionMarkup
                )
            ) : createElement(
                'div',
                { className: className },
                navigationMarkup,
                titleMarkup,
                actionsMarkup
            );
        }
    }, {
        key: 'renderSecondaryActions',
        value: function renderSecondaryActions() {
            var _this2 = this;

            var _state = this.state,
                openActionGroup = _state.openActionGroup,
                rollupOpen = _state.rollupOpen;
            var _props2 = this.props,
                _props2$secondaryActi = _props2.secondaryActions,
                secondaryActions = _props2$secondaryActi === undefined ? [] : _props2$secondaryActi,
                _props2$actionGroups = _props2.actionGroups,
                actionGroups = _props2$actionGroups === undefined ? [] : _props2$actionGroups;

            if (secondaryActions.length === 0 && actionGroups.length === 0) {
                return null;
            }
            var secondaryActionMarkup = secondaryActions.length > 0 ? secondaryActionsFrom(secondaryActions) : null;
            var actionGroupsMarkup = actionGroups.length > 0 ? actionGroups.map(function (_ref) {
                var title = _ref.title,
                    icon = _ref.icon,
                    actions = _ref.actions,
                    details = _ref.details;

                var detailsMarkup = details ? createElement(
                    'div',
                    { className: styles$43.Details },
                    details
                ) : null;
                return createElement(
                    'div',
                    { className: styles$43.ActionGroup, key: 'ActionGroup-' + title },
                    createElement(
                        Popover$2,
                        { key: title, active: title === openActionGroup, onClose: _this2.handleActionGroupClose.bind(_this2, title), activator: createElement(
                                Action,
                                { disclosure: true, icon: icon, onAction: _this2.handleActionGroupOpen.bind(_this2, title) },
                                title
                            ) },
                        createElement(ActionList$1, { items: actions }),
                        detailsMarkup
                    )
                );
            }) : null;
            var rollupMarkup = this.hasRollup ? createElement(
                'div',
                { className: styles$43.Rollup },
                createElement(
                    Popover$2,
                    { active: rollupOpen, onClose: this.handleRollupToggle, activator: createElement(
                            Button$1,
                            { disclosure: true, onClick: this.handleRollupToggle },
                            'Actions'
                        ) },
                    createElement(ActionList$1, { items: secondaryActions, sections: actionGroups.map(convertActionGroupToActionListSection) })
                )
            ) : null;
            return createElement(
                'div',
                { className: styles$43.SecondaryActions },
                rollupMarkup,
                createElement(
                    'div',
                    { className: styles$43.IndividualActions },
                    secondaryActionMarkup,
                    actionGroupsMarkup
                )
            );
        }
    }, {
        key: 'handleRollupToggle',
        value: function handleRollupToggle() {
            this.setState(function (_ref2) {
                var rollupOpen = _ref2.rollupOpen;
                return { rollupOpen: !rollupOpen };
            });
        }
    }, {
        key: 'handleActionGroupClose',
        value: function handleActionGroupClose(group) {
            this.setState(function (_ref3) {
                var openActionGroup = _ref3.openActionGroup;
                return openActionGroup === group ? { openActionGroup: undefined } : {};
            });
        }
    }, {
        key: 'handleActionGroupOpen',
        value: function handleActionGroupOpen(group) {
            this.setState({ openActionGroup: group });
        }
    }, {
        key: 'hasRollup',
        get: function get() {
            var _props3 = this.props,
                _props3$secondaryActi = _props3.secondaryActions,
                secondaryActions = _props3$secondaryActi === undefined ? [] : _props3$secondaryActi,
                _props3$actionGroups = _props3.actionGroups,
                actionGroups = _props3$actionGroups === undefined ? [] : _props3$actionGroups;

            return secondaryActions.length + actionGroups.length > 1;
        }
    }]);

    return Header;
}(PureComponent);

__decorate([autobind], Header$1.prototype, "handleRollupToggle", null);
function convertActionGroupToActionListSection(_ref4) {
    var title = _ref4.title,
        actions = _ref4.actions;

    return { title: title, items: actions };
}
function secondaryActionsFrom(actions) {
    return actions.map(function (_a, index) {
        var content = _a.content,
            action = __rest(_a, ["content"]);
        return createElement(
            Action,
            Object.assign({}, action, { key: 'Action-' + (content || index) }),
            content
        );
    });
}

var EASDK_PROPS = ['title', 'icon', 'breadcrumbs', 'secondaryActions', 'actionGroups', 'primaryAction', 'pagination'];

var Page$1 = function (_React$PureComponent) {
    _inherits(Page, _React$PureComponent);

    function Page() {
        _classCallCheck(this, Page);

        return _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
    }

    _createClass(Page, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.context.easdk == null) {
                return;
            }
            this.handleEASDKMessaging();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.context.easdk == null) {
                return;
            }
            var prevEASDKProps = pick(prevProps, EASDK_PROPS);
            var currentEASDKProps = pick(this.props, EASDK_PROPS);
            if (!isEqual(prevEASDKProps, currentEASDKProps)) {
                this.handleEASDKMessaging();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                children = _a.children,
                fullWidth = _a.fullWidth,
                rest = __rest(_a, ["children", "fullWidth"]);
            var className = classNames(styles$43.Page, fullWidth && styles$43.fullWidth);
            var headerMarkup = this.context.easdk || !this.hasHeaderContent() ? null : createElement(Header$1, rest);
            return createElement(
                'div',
                { className: className },
                headerMarkup,
                createElement(
                    'div',
                    { className: styles$43.Content },
                    children
                )
            );
        }
    }, {
        key: 'handleEASDKMessaging',
        value: function handleEASDKMessaging() {
            var easdk = this.context.easdk;

            if (easdk) {
                easdk.Bar.update(this.props);
            }
        }
    }, {
        key: 'hasHeaderContent',
        value: function hasHeaderContent() {
            var _props = this.props,
                title = _props.title,
                primaryAction = _props.primaryAction,
                secondaryActions = _props.secondaryActions,
                breadcrumbs = _props.breadcrumbs;

            return title && title !== '' || primaryAction || secondaryActions && secondaryActions.length > 0 || breadcrumbs && breadcrumbs.length > 0;
        }
    }]);

    return Page;
}(PureComponent);

Page$1.contextTypes = { easdk: object };

var styles$44 = {
  "PageActions": "Polaris-PageActions",
  "skeletonShimmerAnimation": "Polaris-PageActions--skeletonShimmerAnimation",
};

function PageActions$1(_ref) {
    var primaryAction = _ref.primaryAction,
        secondaryActions = _ref.secondaryActions;

    var primaryActionMarkup = primaryAction ? buttonsFrom(primaryAction, { primary: true }) : null;
    var secondaryActionsMarkup = secondaryActions ? createElement(
        ButtonGroup$1,
        null,
        buttonsFrom(secondaryActions)
    ) : null;
    var distribution = secondaryActionsMarkup ? 'equalSpacing' : 'trailing';
    return createElement(
        'div',
        { className: styles$44.PageActions },
        createElement(
            Stack$1,
            { distribution: distribution, spacing: 'tight' },
            secondaryActionsMarkup,
            primaryActionMarkup
        )
    );
}

var styles$45 = {
  "Thumbnail": "Polaris-Thumbnail",
  "sizeSmall": "Polaris-Thumbnail--sizeSmall",
  "sizeMedium": "Polaris-Thumbnail--sizeMedium",
  "sizeLarge": "Polaris-Thumbnail--sizeLarge",
  "Image": "Polaris-Thumbnail__Image",
  "skeletonShimmerAnimation": "Polaris-Thumbnail--skeletonShimmerAnimation",
};

function Thumbnail$1(_ref) {
    var source = _ref.source,
        alt = _ref.alt,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 'medium' : _ref$size;

    var className = classNames(styles$45.Thumbnail, size && styles$45[variationName('size', size)]);
    return createElement(
        'span',
        { className: className },
        createElement(Image$1, { alt: alt, source: source, className: styles$45.Image })
    );
}

var styles$46 = {
  "ResourceList": "Polaris-ResourceList",
  "ItemWrapper": "Polaris-ResourceList__ItemWrapper",
  "Item": "Polaris-ResourceList__Item",
  "Item-persistActions": "Polaris-ResourceList__Item--persistActions",
  "Actions": "Polaris-ResourceList__Actions",
  "Item-focused": "Polaris-ResourceList__Item--focused",
  "AttributeThree": "Polaris-ResourceList__AttributeThree",
  "Item-link": "Polaris-ResourceList__Item--link",
  "Item-mediaAvatar": "Polaris-ResourceList__Item--mediaAvatar",
  "Item-sizeSmall": "Polaris-ResourceList__Item--sizeSmall",
  "Item-sizeMedium": "Polaris-ResourceList__Item--sizeMedium",
  "Item-sizeLarge": "Polaris-ResourceList__Item--sizeLarge",
  "Item-mediaThumbnail": "Polaris-ResourceList__Item--mediaThumbnail",
  "Media": "Polaris-ResourceList__Media",
  "Container": "Polaris-ResourceList__Container",
  "Content": "Polaris-ResourceList__Content",
  "Attributes": "Polaris-ResourceList__Attributes",
  "AttributeOne": "Polaris-ResourceList__AttributeOne",
  "AttributeTwo": "Polaris-ResourceList__AttributeTwo",
  "Badge": "Polaris-ResourceList__Badge",
  "Disclosure": "Polaris-ResourceList__Disclosure",
  "ExceptionList": "Polaris-ResourceList__ExceptionList",
  "ExceptionItem": "Polaris-ResourceList__ExceptionItem",
  "ExceptionItem-statusWarning": "Polaris-ResourceList__ExceptionItem--statusWarning",
  "Title": "Polaris-ResourceList__Title",
  "ExceptionItem-statusCritical": "Polaris-ResourceList__ExceptionItem--statusCritical",
  "Description": "Polaris-ResourceList__Description",
  "Link": "Polaris-ResourceList__Link",
  "skeletonShimmerAnimation": "Polaris-ResourceList--skeletonShimmerAnimation",
};

var getUniqueID$5 = createUniqueIDFactory('ResourceListItem');

var Item$6 = function (_React$PureComponent) {
    _inherits(Item, _React$PureComponent);

    function Item() {
        _classCallCheck(this, Item);

        var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));

        _this.state = {
            actionsMenuVisible: false,
            focused: false
        };
        _this.node = null;
        _this.id = getUniqueID$5();
        return _this;
    }

    _createClass(Item, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                url = _props.url,
                media = _props.media,
                attributeOne = _props.attributeOne,
                attributeTwo = _props.attributeTwo,
                attributeThree = _props.attributeThree,
                badges = _props.badges,
                exceptions = _props.exceptions,
                actions = _props.actions,
                _props$persistActions = _props.persistActions,
                persistActions = _props$persistActions === undefined ? false : _props$persistActions;
            var _state = this.state,
                actionsMenuVisible = _state.actionsMenuVisible,
                focused = _state.focused;

            var attributeTwoMarkup = attributeTwo ? createElement(
                'div',
                { className: styles$46.AttributeTwo },
                attributeTwo
            ) : null;
            var badgeMarkup = badges ? createElement(
                'div',
                { className: styles$46.Badge },
                badges.map(renderBadge)
            ) : null;
            var attributeThreeMarkup = attributeThree ? createElement(
                'div',
                { className: styles$46.AttributeThree },
                attributeThree
            ) : null;
            var exceptionsMarkup = exceptions ? createElement(
                'ul',
                { className: styles$46.ExceptionList },
                exceptions.map(renderException)
            ) : null;
            var mediaSize = null;
            var mediaType = null;
            var mediaMarkup = null;
            if (media) {
                if (isElementOfType(media, Avatar$1)) {
                    mediaSize = media.props.size || 'medium';
                    mediaType = 'avatar';
                }
                if (isElementOfType(media, Thumbnail$1)) {
                    mediaSize = media.props.size || 'medium';
                    mediaType = 'thumbnail';
                }
                mediaMarkup = createElement(
                    'div',
                    { className: styles$46.Media },
                    media
                );
            }
            var className = classNames(styles$46.Item, url && styles$46['Item-link'], focused && styles$46['Item-focused'], persistActions && styles$46['Item-persistActions'], mediaType && styles$46[variationName('Item-media', mediaType)], mediaSize && styles$46[variationName('Item-size', mediaSize)]);
            var actionsMarkup = null;
            var disclosureMarkup = null;
            if (actions) {
                if (persistActions) {
                    actionsMarkup = createElement(
                        'div',
                        { className: styles$46.Actions },
                        createElement(
                            ButtonGroup$1,
                            null,
                            buttonsFrom(actions, { size: 'slim', plain: true })
                        )
                    );
                    disclosureMarkup = createElement(
                        'div',
                        { className: styles$46.Disclosure },
                        createElement(
                            Popover$2,
                            { activator: createElement(Button$1, { 'aria-label': 'Actions dropdown', onClick: this.handleClick, plain: true, icon: 'horizontalDots' }), onClose: this.handleCloseRequest, active: actionsMenuVisible },
                            createElement(ActionList$1, { items: actions })
                        )
                    );
                } else {
                    actionsMarkup = createElement(
                        'div',
                        { className: styles$46.Actions },
                        createElement(
                            ButtonGroup$1,
                            { segmented: true },
                            buttonsFrom(actions, { size: 'slim' })
                        )
                    );
                }
            }
            var containerMarkup = createElement(
                'div',
                { className: styles$46.Container, id: this.id },
                mediaMarkup,
                createElement(
                    'div',
                    { className: styles$46.Content },
                    createElement(
                        'div',
                        { className: styles$46.Attributes },
                        createElement(
                            'p',
                            { className: styles$46.AttributeOne },
                            attributeOne
                        ),
                        attributeTwoMarkup,
                        badgeMarkup,
                        attributeThreeMarkup
                    ),
                    exceptionsMarkup
                ),
                actionsMarkup,
                disclosureMarkup
            );
            return url ? createElement(
                'div',
                { ref: this.setNode, className: className, onFocus: this.handleFocus, onBlur: this.handleBlur, onMouseEnter: this.mouseEnter, onMouseLeave: this.mouseLeave },
                createElement(UnstyledLink$1, { 'aria-describedby': this.id, className: styles$46.Link, url: url }),
                containerMarkup
            ) : createElement(
                'div',
                { ref: this.setNode, className: className, onFocus: this.handleFocus, onBlur: this.handleBlur, onMouseEnter: this.mouseEnter, onMouseLeave: this.mouseLeave },
                containerMarkup
            );
        }
    }, {
        key: 'setNode',
        value: function setNode(node) {
            this.node = node;
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus() {
            this.setState({ focused: true });
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur(event) {
            if (this.node == null || !this.node.contains(event.relatedTarget)) {
                this.setState({ focused: false });
            }
        }
    }, {
        key: 'mouseEnter',
        value: function mouseEnter() {
            this.setState({ focused: true });
        }
    }, {
        key: 'mouseLeave',
        value: function mouseLeave() {
            this.setState({ focused: false });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.setState({ actionsMenuVisible: true });
        }
    }, {
        key: 'handleCloseRequest',
        value: function handleCloseRequest() {
            this.setState({ actionsMenuVisible: false });
        }
    }]);

    return Item;
}(PureComponent);

__decorate([autobind], Item$6.prototype, "setNode", null);
__decorate([autobind], Item$6.prototype, "handleFocus", null);
__decorate([autobind], Item$6.prototype, "handleBlur", null);
__decorate([autobind], Item$6.prototype, "mouseEnter", null);
__decorate([autobind], Item$6.prototype, "mouseLeave", null);
__decorate([autobind], Item$6.prototype, "handleClick", null);
__decorate([autobind], Item$6.prototype, "handleCloseRequest", null);
function renderBadge(badge) {
    return createElement(
        Badge$1,
        { key: badge.content, status: badge.status },
        badge.content
    );
}
function renderException(exception, index) {
    var status = exception.status,
        title = exception.title,
        description = exception.description;

    var className = classNames(styles$46.ExceptionItem, status && styles$46[variationName('ExceptionItem-status', status)]);
    var titleMarkup = title != null ? createElement(
        'div',
        { className: styles$46.Title },
        title
    ) : null;
    var descriptionMarkup = description != null ? createElement(
        'div',
        { className: styles$46.Description },
        description
    ) : null;
    return createElement(
        'li',
        { key: index, className: className },
        titleMarkup,
        descriptionMarkup
    );
}

var ResourceList$1 = function (_React$PureComponent) {
    _inherits(ResourceList, _React$PureComponent);

    function ResourceList() {
        _classCallCheck(this, ResourceList);

        return _possibleConstructorReturn(this, (ResourceList.__proto__ || Object.getPrototypeOf(ResourceList)).apply(this, arguments));
    }

    _createClass(ResourceList, [{
        key: 'render',
        value: function render() {
            var items = this.props.items;

            return createElement(
                'ul',
                { className: styles$46.ResourceList },
                items.map(this.renderItem)
            );
        }
    }, {
        key: 'renderItem',
        value: function renderItem(item, index) {
            var renderItem = this.props.renderItem;

            return createElement(
                'li',
                { key: index, className: styles$46.ItemWrapper },
                renderItem(item, index)
            );
        }
    }]);

    return ResourceList;
}(PureComponent);

ResourceList$1.Item = Item$6;
__decorate([autobind], ResourceList$1.prototype, "renderItem", null);

var styles$47 = {
  "Select": "Polaris-Select",
  "disabled": "Polaris-Select--disabled",
  "Backdrop": "Polaris-Select__Backdrop",
  "Icon": "Polaris-Select__Icon",
  "error": "Polaris-Select--error",
  "Input": "Polaris-Select__Input",
  "placeholder": "Polaris-Select--placeholder",
  "skeletonShimmerAnimation": "Polaris-Select--skeletonShimmerAnimation",
};

var PLACEHOLDER_VALUE = '__placeholder__';
var getUniqueID$6 = createUniqueIDFactory('Select');
function Select$1(_ref) {
    var _ref$id = _ref.id,
        id = _ref$id === undefined ? getUniqueID$6() : _ref$id,
        name = _ref.name,
        groups = _ref.groups,
        options = _ref.options,
        labelHidden = _ref.labelHidden,
        labelAction = _ref.labelAction,
        helpText = _ref.helpText,
        label = _ref.label,
        error = _ref.error,
        value = _ref.value,
        placeholder = _ref.placeholder,
        disabled = _ref.disabled,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur;

    var optionsMarkup = void 0;
    if (options != null) {
        optionsMarkup = options.map(renderOption);
    } else if (groups != null) {
        optionsMarkup = groups.map(renderGroup);
    }
    var isPlaceholder = value == null && placeholder != null;
    var className = classNames(styles$47.Select, error && styles$47.error, disabled && styles$47.disabled, isPlaceholder && styles$47.placeholder);
    var handleChange = onChange ? function (event) {
        return onChange(event.currentTarget.value, id);
    } : undefined;
    var describedBy = [];
    if (helpText) {
        describedBy.push(helpTextID$1(id));
    }
    if (error && typeof error === 'string') {
        describedBy.push(errorID$1(id));
    }
    var placeholderOption = isPlaceholder ? createElement('option', { label: placeholder, value: PLACEHOLDER_VALUE, disabled: true, hidden: true }) : null;
    // When we have no onChange, React will complain about providing a `value`
    // (and vice versa for `defaultValue`)
    var defaultValue = onChange ? undefined : value || PLACEHOLDER_VALUE;
    var finalValue = onChange ? value || PLACEHOLDER_VALUE : undefined;
    return createElement(
        Labelled$1,
        { id: id, label: label, error: error, action: labelAction, labelHidden: labelHidden, helpText: helpText },
        createElement(
            'div',
            { className: className },
            createElement(
                'select',
                { id: id, name: name, defaultValue: defaultValue, value: finalValue, className: styles$47.Input, disabled: disabled, onFocus: onFocus, onBlur: onBlur, onChange: handleChange, 'aria-invalid': Boolean(error), 'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined },
                placeholderOption,
                optionsMarkup
            ),
            createElement(
                'div',
                { className: styles$47.Icon },
                createElement(Icon$1, { source: 'arrowUpDown' })
            ),
            createElement('div', { className: styles$47.Backdrop })
        )
    );
}
function renderOption(option) {
    if (typeof option === 'string') {
        return createElement(
            'option',
            { key: option, value: option },
            option
        );
    } else {
        return createElement(
            'option',
            { key: option.value, value: option.value, disabled: option.disabled },
            option.label
        );
    }
}
function renderGroup(groupOrOption) {
    if (groupOrOption.hasOwnProperty('title')) {
        var title = groupOrOption.title,
            options = groupOrOption.options;

        return createElement(
            'optgroup',
            { label: title, key: title },
            options.map(renderOption)
        );
    }
    return renderOption(groupOrOption);
}

function SettingToggle$1(_ref) {
    var enabled = _ref.enabled,
        action = _ref.action,
        children = _ref.children;

    var actionMarkup = action ? buttonFrom(action, { primary: !enabled }) : null;
    return createElement(
        Card$1,
        { sectioned: true },
        createElement(
            SettingAction$1,
            { action: actionMarkup },
            children
        )
    );
}

var styles$48 = {
  "Tabs": "Polaris-Tabs",
  "fitted": "Polaris-Tabs--fitted",
  "TabContainer": "Polaris-Tabs__TabContainer",
  "Tab": "Polaris-Tabs__Tab",
  "Title": "Polaris-Tabs__Title",
  "fillSpace": "Polaris-Tabs--fillSpace",
  "Tab-selected": "Polaris-Tabs__Tab--selected",
  "Panel": "Polaris-Tabs__Panel",
  "List": "Polaris-Tabs__List",
  "Item": "Polaris-Tabs__Item",
  "DisclosureTab": "Polaris-Tabs__DisclosureTab",
  "DisclosureTab-visible": "Polaris-Tabs__DisclosureTab--visible",
  "DisclosureActivator": "Polaris-Tabs__DisclosureActivator",
  "TabMeasurer": "Polaris-Tabs__TabMeasurer",
  "skeletonShimmerAnimation": "Polaris-Tabs--skeletonShimmerAnimation",
};

var Item$8 = function (_React$PureComponent) {
    _inherits(Item, _React$PureComponent);

    function Item() {
        _classCallCheck(this, Item);

        var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));

        _this.focusedNode = null;
        return _this;
    }

    _createClass(Item, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var focusedNode = this.focusedNode;
            var focused = this.props.focused;

            if (focusedNode && focused) {
                focusedNode.focus();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var focusedNode = this.focusedNode;
            var focused = this.props.focused;

            if (focusedNode && focused) {
                focusedNode.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                children = _props.children,
                panelID = _props.panelID,
                _props$onClick = _props.onClick,
                onClick = _props$onClick === undefined ? noop : _props$onClick,
                accessibilityLabel = _props.accessibilityLabel;

            var className = classNames(styles$48.Item);
            return createElement(
                'li',
                { role: 'presentation' },
                createElement(
                    'button',
                    { id: id, ref: this.setFocusedNode, onClick: onClick, className: className, 'aria-controls': panelID, 'aria-selected': false, 'aria-label': accessibilityLabel },
                    children
                )
            );
        }
    }, {
        key: 'setFocusedNode',
        value: function setFocusedNode(node) {
            this.focusedNode = node;
        }
    }]);

    return Item;
}(PureComponent);

__decorate([autobind], Item$8.prototype, "setFocusedNode", null);

var List$2 = function (_React$PureComponent) {
    _inherits(List, _React$PureComponent);

    function List() {
        _classCallCheck(this, List);

        return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
    }

    _createClass(List, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                focusIndex = _props.focusIndex,
                disclosureTabs = _props.disclosureTabs,
                _props$onClick = _props.onClick,
                onClick = _props$onClick === undefined ? noop : _props$onClick;

            var tabs = disclosureTabs.map(function (_ref, index) {
                var id = _ref.id,
                    panelID = _ref.panelID,
                    title = _ref.title,
                    accessibilityLabel = _ref.accessibilityLabel;

                return createElement(
                    Item$8,
                    { key: id, id: id, panelID: panelID, focused: index === focusIndex, accessibilityLabel: accessibilityLabel, onClick: onClick.bind(null, id) },
                    title
                );
            });
            return createElement(
                'ul',
                { className: styles$48.List, onKeyDown: handleKeyDown$2, onKeyUp: this.handleKeypress },
                tabs
            );
        }
    }, {
        key: 'handleKeypress',
        value: function handleKeypress(event) {
            var _props$onKeyPress = this.props.onKeyPress,
                onKeyPress = _props$onKeyPress === undefined ? noop : _props$onKeyPress;

            onKeyPress(event);
        }
    }]);

    return List;
}(PureComponent);

__decorate([autobind], List$2.prototype, "handleKeypress", null);
function handleKeyDown$2(event) {
    var key = event.key;

    if (key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight') {
        event.preventDefault();
        event.stopPropagation();
    }
}

var Tab = function (_React$PureComponent) {
    _inherits(Tab, _React$PureComponent);

    function Tab() {
        _classCallCheck(this, Tab);

        var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));

        _this.node = null;
        return _this;
    }
    // A tab can start selected when it is moved from the disclosure dropdown
    // into the main list, so we need to send focus from the tab to the panel
    // on mount and update


    _createClass(Tab, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                id = _props.id,
                measuring = _props.measuring,
                selected = _props.selected,
                panelID = _props.panelID,
                focused = _props.focused;

            if (measuring) {
                return;
            }
            // Because of timing issues with the render, we may still have the old,
            // in-disclosure version of the tab that has focus. Check for this
            // as a second indicator of focus
            var itemHadFocus = focused || document.activeElement && document.activeElement.id === id;
            // If we just check for selected, the panel for the active tab will
            // be focused on page load, which we don’t want
            if (itemHadFocus && selected && panelID != null) {
                focusPanelID(panelID);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(previousProps) {
            var wasSelected = previousProps.selected;
            var _props2 = this.props,
                focused = _props2.focused,
                measuring = _props2.measuring,
                selected = _props2.selected,
                panelID = _props2.panelID;

            if (measuring) {
                return;
            }
            if (selected && !wasSelected && panelID != null) {
                focusPanelID(panelID);
            } else if (focused && this.node != null) {
                focusFirstFocusableNode(this.node);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                id = _props3.id,
                focused = _props3.focused,
                siblingTabHasFocus = _props3.siblingTabHasFocus,
                children = _props3.children,
                onClick = _props3.onClick,
                selected = _props3.selected,
                url = _props3.url,
                panelID = _props3.panelID,
                measuring = _props3.measuring,
                accessibilityLabel = _props3.accessibilityLabel;

            var handleClick = onClick && onClick.bind(null, id);
            var className = classNames(styles$48.Tab, selected && styles$48['Tab-selected']);
            var tabIndex = void 0;
            if (selected && !siblingTabHasFocus && !measuring) {
                tabIndex = 0;
            } else if (focused && !measuring) {
                tabIndex = 0;
            } else {
                tabIndex = -1;
            }
            var markup = url ? createElement(
                UnstyledLink$1,
                { id: id, url: url, role: 'tab', tabIndex: tabIndex, onClick: handleClick, className: className, 'aria-selected': selected, 'aria-controls': panelID, 'aria-label': accessibilityLabel, onMouseUp: handleMouseUpByBlurring },
                createElement(
                    'span',
                    { className: styles$48.Title },
                    children
                )
            ) : createElement(
                'button',
                { id: id, role: 'tab', tabIndex: tabIndex, className: className, onClick: handleClick, 'aria-selected': selected, 'aria-controls': panelID, 'aria-label': accessibilityLabel, onMouseUp: handleMouseUpByBlurring },
                createElement(
                    'span',
                    { className: styles$48.Title },
                    children
                )
            );
            return createElement(
                'li',
                { role: 'presentation', className: styles$48.TabContainer, ref: this.setNode },
                markup
            );
        }
    }, {
        key: 'setNode',
        value: function setNode(node) {
            this.node = node;
        }
    }]);

    return Tab;
}(PureComponent);

__decorate([autobind], Tab.prototype, "setNode", null);
function focusPanelID(panelID) {
    var panel = document.getElementById(panelID);
    if (panel) {
        panel.focus();
    }
}

var TabMeasurer = function (_React$PureComponent) {
    _inherits(TabMeasurer, _React$PureComponent);

    function TabMeasurer() {
        _classCallCheck(this, TabMeasurer);

        var _this = _possibleConstructorReturn(this, (TabMeasurer.__proto__ || Object.getPrototypeOf(TabMeasurer)).apply(this, arguments));

        _this.containerNode = null;
        return _this;
    }

    _createClass(TabMeasurer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.handleMeasurement();
            if (process.env.NODE_ENV === 'development') {
                // We need to defer the calculation in development so the
                // styles have time to be injected.
                setTimeout(this.handleMeasurement, 0);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.tabs !== this.props.tabs) {
                this.handleMeasurement();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                selected = _props.selected,
                tabs = _props.tabs,
                activator = _props.activator,
                tabToFocus = _props.tabToFocus,
                siblingTabHasFocus = _props.siblingTabHasFocus;

            var tabsMarkup = tabs.map(function (tab, index) {
                return createElement(
                    Tab,
                    { measuring: true, key: '' + index + tab.id + 'Hidden', id: tab.id + 'Measurer', siblingTabHasFocus: siblingTabHasFocus, focused: index === tabToFocus, selected: index === selected, onClick: noop, url: tab.url },
                    tab.title
                );
            });
            var classname = classNames(styles$48.Tabs, styles$48.TabMeasurer);
            return createElement(
                'div',
                { className: classname, ref: this.setContainerNode },
                createElement(EventListener$1, { event: 'resize', handler: this.handleMeasurement }),
                tabsMarkup,
                activator
            );
        }
    }, {
        key: 'setContainerNode',
        value: function setContainerNode(node) {
            this.containerNode = node;
        }
    }, {
        key: 'handleMeasurement',
        value: function handleMeasurement() {
            if (this.containerNode == null) {
                return;
            }
            var handleMeasurement = this.props.handleMeasurement;

            var containerWidth = this.containerNode.offsetWidth;
            var hiddenTabNodes = findDOMNode(this).children;
            var hiddenTabNodesArray = [].slice.call(hiddenTabNodes);
            var hiddenTabWidths = hiddenTabNodesArray.map(function (node) {
                return node.getBoundingClientRect().width;
            });
            var disclosureWidth = hiddenTabWidths.pop();
            handleMeasurement({
                containerWidth: containerWidth,
                disclosureWidth: disclosureWidth,
                hiddenTabWidths: hiddenTabWidths
            });
        }
    }]);

    return TabMeasurer;
}(PureComponent);

__decorate([autobind], TabMeasurer.prototype, "setContainerNode", null);
__decorate([autobind], TabMeasurer.prototype, "handleMeasurement", null);

function Panel(_ref) {
  var id = _ref.id,
      tabID = _ref.tabID,
      children = _ref.children;

  return createElement(
    'div',
    { className: styles$48.Panel, id: id, role: 'tabpanel', 'aria-labelledby': tabID, tabIndex: -1 },
    children
  );
}

var Tabs$1 = function (_React$PureComponent) {
    _inherits(Tabs, _React$PureComponent);

    function Tabs() {
        _classCallCheck(this, Tabs);

        var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));

        _this.state = {
            disclosureWidth: 0,
            containerWidth: Infinity,
            tabWidths: [],
            visibleTabs: [],
            hiddenTabs: [],
            showDisclosure: false,
            tabToFocus: -1
        };
        return _this;
    }

    _createClass(Tabs, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var selected = this.props.selected;
            var _state = this.state,
                disclosureWidth = _state.disclosureWidth,
                tabWidths = _state.tabWidths,
                containerWidth = _state.containerWidth,
                tabToFocus = _state.tabToFocus;

            var _getVisibleAndHiddenT = getVisibleAndHiddenTabIndices(nextProps.tabs, nextProps.selected, disclosureWidth, tabWidths, containerWidth),
                visibleTabs = _getVisibleAndHiddenT.visibleTabs,
                hiddenTabs = _getVisibleAndHiddenT.hiddenTabs;

            this.setState({
                visibleTabs: visibleTabs,
                hiddenTabs: hiddenTabs,
                tabToFocus: selected === nextProps.selected ? -1 : tabToFocus,
                showDisclosure: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                tabs = _props.tabs,
                selected = _props.selected,
                fitted = _props.fitted,
                children = _props.children;
            var _state2 = this.state,
                tabToFocus = _state2.tabToFocus,
                visibleTabs = _state2.visibleTabs,
                hiddenTabs = _state2.hiddenTabs,
                showDisclosure = _state2.showDisclosure;

            var disclosureTabs = hiddenTabs.map(function (tabIndex) {
                return tabs[tabIndex];
            });
            var panelMarkup = children ? createElement(
                Panel,
                { id: tabs[selected].panelID || tabs[selected].id + '-panel', tabID: tabs[selected].id },
                children
            ) : null;
            var tabsMarkup = visibleTabs.sort(function (tabA, tabB) {
                return tabA - tabB;
            }).map(function (tabIndex) {
                return _this2.renderTabMarkup(tabs[tabIndex], tabIndex);
            });
            var disclosureActivatorVisible = visibleTabs.length < tabs.length;
            var classname = classNames(styles$48.Tabs, fitted && styles$48.fitted, disclosureActivatorVisible && styles$48.fillSpace);
            var disclosureTabClassName = classNames(styles$48.DisclosureTab, disclosureActivatorVisible && styles$48['DisclosureTab-visible']);
            var activator = createElement(
                'button',
                { tabIndex: -1, className: styles$48.DisclosureActivator, onClick: this.handleDisclosureActivatorClick },
                createElement(Icon$1, { source: 'horizontalDots' })
            );
            return createElement(
                'div',
                null,
                createElement(
                    'ul',
                    { role: 'tablist', className: classname, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeyDown: handleKeyDown$1, onKeyUp: this.handleKeyPress },
                    tabsMarkup,
                    createElement(
                        'li',
                        { role: 'presentation', className: disclosureTabClassName },
                        createElement(
                            Popover$2,
                            { preventAutofocus: true, preferredPosition: 'below', activator: activator, active: disclosureActivatorVisible && showDisclosure, onClose: this.handleClose },
                            createElement(List$2, { focusIndex: hiddenTabs.indexOf(tabToFocus), disclosureTabs: disclosureTabs, onClick: this.handleTabClick, onKeyPress: this.handleKeyPress })
                        )
                    )
                ),
                createElement(TabMeasurer, { tabToFocus: tabToFocus, activator: activator, selected: selected, tabs: tabs, siblingTabHasFocus: tabToFocus > -1, handleMeasurement: this.handleMeasurement }),
                panelMarkup
            );
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(event) {
            var _state3 = this.state,
                tabToFocus = _state3.tabToFocus,
                visibleTabs = _state3.visibleTabs,
                hiddenTabs = _state3.hiddenTabs;

            var tabsArrayInOrder = visibleTabs.concat(hiddenTabs);
            var key = event.key;
            var newFocus = tabsArrayInOrder.indexOf(tabToFocus);
            if (key === 'ArrowRight' || key === 'ArrowDown') {
                newFocus += 1;
                if (newFocus === tabsArrayInOrder.length) {
                    newFocus = 0;
                }
            }
            if (key === 'ArrowLeft' || key === 'ArrowUp') {
                newFocus -= 1;
                if (newFocus === -1) {
                    newFocus = tabsArrayInOrder.length - 1;
                }
            }
            this.setState({
                showDisclosure: hiddenTabs.indexOf(tabsArrayInOrder[newFocus]) > -1,
                tabToFocus: tabsArrayInOrder[newFocus]
            });
        }
    }, {
        key: 'renderTabMarkup',
        value: function renderTabMarkup(tab, index) {
            var selected = this.props.selected;
            var tabToFocus = this.state.tabToFocus;

            return createElement(
                Tab,
                { key: index + '-' + tab.id, id: tab.id, siblingTabHasFocus: tabToFocus > -1, focused: index === tabToFocus, selected: index === selected, onClick: this.handleTabClick, panelID: tab.panelID || tab.id + '-panel', accessibilityLabel: tab.accessibilityLabel, url: tab.url },
                tab.title
            );
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus(event) {
            var _props2 = this.props,
                selected = _props2.selected,
                tabs = _props2.tabs;
            // If we are explicitly focusing one of the non-selected tabs, use it
            // move the focus to it

            var target = event.target;
            if (target.classList.contains(styles$48.Tab) || target.classList.contains(styles$48.Item)) {
                var tabToFocus = -1;
                tabs.every(function (tab, index) {
                    if (tab.id === target.id) {
                        tabToFocus = index;
                        return false;
                    }
                    return true;
                });
                this.setState({ tabToFocus: tabToFocus });
                return;
            }
            if (target.classList.contains(styles$48.DisclosureActivator)) {
                return;
            }
            // If we are coming in from somewhere other than another tab, focus the
            // selected tab, and the focus (click) is not on the disclosure activator,
            // focus the selected tab
            if (!event.relatedTarget) {
                this.setState({ tabToFocus: selected });
                return;
            }
            var relatedTarget = event.relatedTarget;
            if (!relatedTarget.classList.contains(styles$48.Tab) && !relatedTarget.classList.contains(styles$48.Item) && !relatedTarget.classList.contains(styles$48.DisclosureActivator)) {
                this.setState({ tabToFocus: selected });
            }
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur(event) {
            // If we blur and the target is not another tab, forget the focus position
            if (event.relatedTarget == null) {
                this.setState({ tabToFocus: -1 });
                return;
            }
            var target = event.relatedTarget;
            // If we are going to anywhere other than another tab, lose the last focused tab
            if (!target.classList.contains(styles$48.Tab) && !target.classList.contains(styles$48.Item)) {
                this.setState({ tabToFocus: -1 });
            }
        }
    }, {
        key: 'handleDisclosureActivatorClick',
        value: function handleDisclosureActivatorClick() {
            this.setState(function (_ref) {
                var showDisclosure = _ref.showDisclosure;
                return { showDisclosure: !showDisclosure };
            });
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.setState({
                showDisclosure: false
            });
        }
    }, {
        key: 'handleMeasurement',
        value: function handleMeasurement(measurements) {
            var _props3 = this.props,
                tabs = _props3.tabs,
                selected = _props3.selected;
            var tabToFocus = this.state.tabToFocus;
            var tabWidths = measurements.hiddenTabWidths,
                containerWidth = measurements.containerWidth,
                disclosureWidth = measurements.disclosureWidth;

            var _getVisibleAndHiddenT2 = getVisibleAndHiddenTabIndices(tabs, selected, disclosureWidth, tabWidths, containerWidth),
                visibleTabs = _getVisibleAndHiddenT2.visibleTabs,
                hiddenTabs = _getVisibleAndHiddenT2.hiddenTabs;

            this.setState({
                tabToFocus: tabToFocus === -1 ? -1 : selected,
                visibleTabs: visibleTabs,
                hiddenTabs: hiddenTabs,
                disclosureWidth: disclosureWidth,
                containerWidth: containerWidth,
                tabWidths: tabWidths
            });
        }
    }, {
        key: 'handleTabClick',
        value: function handleTabClick(id) {
            var _props4 = this.props,
                tabs = _props4.tabs,
                _props4$onSelect = _props4.onSelect,
                onSelect = _props4$onSelect === undefined ? noop : _props4$onSelect;

            var tab = tabs.find(function (aTab) {
                return aTab.id === id;
            });
            if (tab == null) {
                return;
            }
            var selectedIndex = tabs.indexOf(tab);
            onSelect(selectedIndex);
        }
    }]);

    return Tabs;
}(PureComponent);

Tabs$1.Panel = Panel;
__decorate([autobind], Tabs$1.prototype, "handleKeyPress", null);
__decorate([autobind], Tabs$1.prototype, "renderTabMarkup", null);
__decorate([autobind], Tabs$1.prototype, "handleFocus", null);
__decorate([autobind], Tabs$1.prototype, "handleBlur", null);
__decorate([autobind], Tabs$1.prototype, "handleDisclosureActivatorClick", null);
__decorate([autobind], Tabs$1.prototype, "handleClose", null);
__decorate([autobind], Tabs$1.prototype, "handleMeasurement", null);
__decorate([autobind], Tabs$1.prototype, "handleTabClick", null);
function handleKeyDown$1(event) {
    var key = event.key;

    if (key === 'ArrowUp' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowRight') {
        event.preventDefault();
        event.stopPropagation();
    }
}
function getVisibleAndHiddenTabIndices(tabs, selected, disclosureWidth, tabWidths, containerWidth) {
    var sumTabWidths = tabWidths.reduce(function (sum, width) {
        return sum + width;
    }, 0);
    var arrayOfTabIndices = tabs.map(function (_, index) {
        return index;
    });
    var visibleTabs = [];
    var hiddenTabs = [];
    if (containerWidth > sumTabWidths) {
        visibleTabs.push.apply(visibleTabs, _toConsumableArray(arrayOfTabIndices));
    } else {
        visibleTabs.push(selected);
        var newTabWidth = tabWidths[selected];
        arrayOfTabIndices.forEach(function (index) {
            if (index !== selected) {
                if (newTabWidth + tabWidths[index] > containerWidth - disclosureWidth) {
                    hiddenTabs.push(index);
                    return;
                }
                visibleTabs.push(index);
                newTabWidth += tabWidths[index];
            }
        });
    }
    return {
        visibleTabs: visibleTabs,
        hiddenTabs: hiddenTabs
    };
}

var styles$49 = {
  "Tag": "Polaris-Tag",
  "Button": "Polaris-Tag__Button",
  "skeletonShimmerAnimation": "Polaris-Tag--skeletonShimmerAnimation",
};

function Tag$1(_ref) {
  var children = _ref.children,
      onRemove = _ref.onRemove;

  return createElement(
    'span',
    { className: styles$49.Tag },
    createElement(
      'span',
      null,
      children
    ),
    createElement(
      'button',
      { 'aria-label': 'Remove', className: styles$49.Button, onClick: onRemove, onMouseUp: handleMouseUpByBlurring },
      createElement(Icon$1, { source: 'cancelSmall' })
    )
  );
}

var styles$50 = {
  "Connected": "Polaris-Connected",
  "Item": "Polaris-Connected__Item",
  "Item-primary": "Polaris-Connected__Item--primary",
  "Item-connection": "Polaris-Connected__Item--connection",
  "Item-focused": "Polaris-Connected__Item--focused",
  "skeletonShimmerAnimation": "Polaris-Connected--skeletonShimmerAnimation",
};

var Position;
(function (Position) {
    Position[Position["Left"] = 0] = "Left";
    Position[Position["Primary"] = 1] = "Primary";
    Position[Position["Right"] = 2] = "Right";
})(Position || (Position = {}));

var Item$10 = function (_React$PureComponent) {
    _inherits(Item, _React$PureComponent);

    function Item() {
        _classCallCheck(this, Item);

        var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));

        _this.state = { focused: false };
        return _this;
    }

    _createClass(Item, [{
        key: 'render',
        value: function render() {
            var focused = this.state.focused;
            var _props = this.props,
                children = _props.children,
                position = _props.position;

            var className = classNames(styles$50.Item, focused && styles$50['Item-focused'], position === Position.Primary ? styles$50['Item-primary'] : styles$50['Item-connection']);
            return createElement(
                'div',
                { onBlur: this.handleBlur, onFocus: this.handleFocus, className: className },
                children
            );
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur() {
            this.setState({ focused: false });
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus() {
            this.setState({ focused: true });
        }
    }]);

    return Item;
}(PureComponent);

__decorate([autobind], Item$10.prototype, "handleBlur", null);
__decorate([autobind], Item$10.prototype, "handleFocus", null);

function Connected$1(_ref) {
    var children = _ref.children,
        left = _ref.left,
        right = _ref.right;

    if (left == null && right == null) {
        return Children.only(children);
    }
    var leftConnectionMarkup = left ? createElement(
        Item$10,
        { position: Position.Left },
        left
    ) : null;
    var rightConnectionMarkup = right ? createElement(
        Item$10,
        { position: Position.Right },
        right
    ) : null;
    return createElement(
        'div',
        { className: styles$50.Connected },
        leftConnectionMarkup,
        createElement(
            Item$10,
            { position: Position.Primary },
            children
        ),
        rightConnectionMarkup
    );
}

var styles$51 = {
  "TextField": "Polaris-TextField",
  "multiline": "Polaris-TextField--multiline",
  "Input": "Polaris-TextField__Input",
  "hasValue": "Polaris-TextField--hasValue",
  "focus": "Polaris-TextField--focus",
  "Backdrop": "Polaris-TextField__Backdrop",
  "error": "Polaris-TextField--error",
  "readOnly": "Polaris-TextField--readOnly",
  "disabled": "Polaris-TextField--disabled",
  "Prefix": "Polaris-TextField__Prefix",
  "Suffix": "Polaris-TextField__Suffix",
  "Spinner": "Polaris-TextField__Spinner",
  "SpinnerIcon": "Polaris-TextField__SpinnerIcon",
  "Resizer": "Polaris-TextField__Resizer",
  "DummyInput": "Polaris-TextField__DummyInput",
  "Segment": "Polaris-TextField__Segment",
  "skeletonShimmerAnimation": "Polaris-TextField--skeletonShimmerAnimation",
};

var Resizer = function (_React$PureComponent) {
    _inherits(Resizer, _React$PureComponent);

    function Resizer() {
        _classCallCheck(this, Resizer);

        var _this = _possibleConstructorReturn(this, (Resizer.__proto__ || Object.getPrototypeOf(Resizer)).apply(this, arguments));

        _this.contentNode = null;
        _this.minimumLinesNode = null;
        return _this;
    }

    _createClass(Resizer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.handleHeightCheck();
            if (process.env.NODE_ENV === 'development') {
                // We need to defer the calculation in development so the
                // styles have time to be injected.
                setTimeout(this.handleHeightCheck, 0);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.handleHeightCheck();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                contents = _props.contents,
                minimumLines = _props.minimumLines;

            var minimumLinesMarkup = minimumLines ? createElement('div', { ref: this.setMinimumLinesNode, className: styles$51.DummyInput, dangerouslySetInnerHTML: { __html: getContentsForMinimumLines(minimumLines) } }) : null;
            return createElement(
                'div',
                { 'aria-hidden': true, className: styles$51.Resizer },
                createElement(EventListener$1, { event: 'resize', handler: this.handleHeightCheck }),
                createElement('div', { ref: this.setContentNode, className: styles$51.DummyInput, dangerouslySetInnerHTML: { __html: getFinalContents(contents) } }),
                minimumLinesMarkup
            );
        }
    }, {
        key: 'handleHeightCheck',
        value: function handleHeightCheck() {
            if (this.contentNode == null || this.minimumLinesNode == null) {
                return;
            }
            var contentHeight = this.contentNode.offsetHeight;
            var minimumHeight = this.setMinimumLinesNode ? this.minimumLinesNode.offsetHeight : 0;
            var newHeight = Math.max(contentHeight, minimumHeight);
            var _props2 = this.props,
                currentHeight = _props2.currentHeight,
                onHeightChange = _props2.onHeightChange;

            if (newHeight !== currentHeight) {
                onHeightChange(newHeight);
            }
        }
    }, {
        key: 'setContentNode',
        value: function setContentNode(node) {
            this.contentNode = node;
        }
    }, {
        key: 'setMinimumLinesNode',
        value: function setMinimumLinesNode(node) {
            this.minimumLinesNode = node;
        }
    }]);

    return Resizer;
}(PureComponent);

__decorate([autobind], Resizer.prototype, "handleHeightCheck", null);
__decorate([autobind], Resizer.prototype, "setContentNode", null);
__decorate([autobind], Resizer.prototype, "setMinimumLinesNode", null);
var ENTITIES_TO_REPLACE = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '\n': '<br>'
};
var REPLACE_REGEX = /[\n&<>]/g;
function replaceEntity(entity) {
    return ENTITIES_TO_REPLACE[entity] || entity;
}
function getContentsForMinimumLines(minimumLines) {
    var content = '';
    for (var line = 0; line < minimumLines; line++) {
        content += '<br>';
    }
    return content;
}
function getFinalContents(contents) {
    return contents ? contents.replace(REPLACE_REGEX, replaceEntity) + '<br>' : '<br>';
}

function Spinner$2(_ref) {
  var onChange = _ref.onChange,
      onClick = _ref.onClick;

  function handleStep(step) {
    return function () {
      return onChange(step);
    };
  }
  return createElement(
    'div',
    { className: styles$51.Spinner, onClick: onClick, 'aria-hidden': true },
    createElement(
      'div',
      { role: 'button', className: styles$51.Segment, tabIndex: -1, onClick: handleStep(1) },
      createElement(
        'div',
        { className: styles$51.SpinnerIcon },
        createElement(Icon$1, { source: 'caretUp' })
      )
    ),
    createElement(
      'div',
      { role: 'button', className: styles$51.Segment, tabIndex: -1, onClick: handleStep(-1) },
      createElement(
        'div',
        { className: styles$51.SpinnerIcon },
        createElement(Icon$1, { source: 'caretDown' })
      )
    )
  );
}

var getUniqueID$7 = createUniqueIDFactory('TextField');

var TextField$1 = function (_React$PureComponent) {
    _inherits(TextField, _React$PureComponent);

    function TextField(props) {
        _classCallCheck(this, TextField);

        var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this));

        _this.state = {
            height: null,
            focus: false,
            id: props.id || getUniqueID$7()
        };
        return _this;
    }

    _createClass(TextField, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.setState({
                id: newProps.id || this.state.id
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                _a$id = _a.id,
                id = _a$id === undefined ? this.state.id : _a$id,
                _a$value = _a.value,
                value = _a$value === undefined ? '' : _a$value,
                placeholder = _a.placeholder,
                disabled = _a.disabled,
                readOnly = _a.readOnly,
                autoFocus = _a.autoFocus,
                type = _a.type,
                name = _a.name,
                error = _a.error,
                multiline = _a.multiline,
                connectedRight = _a.connectedRight,
                connectedLeft = _a.connectedLeft,
                label = _a.label,
                labelAction = _a.labelAction,
                labelHidden = _a.labelHidden,
                helpText = _a.helpText,
                prefix = _a.prefix,
                suffix = _a.suffix,
                onFocus = _a.onFocus,
                onBlur = _a.onBlur,
                autoComplete = _a.autoComplete,
                rest = __rest(_a, ["id", "value", "placeholder", "disabled", "readOnly", "autoFocus", "type", "name", "error", "multiline", "connectedRight", "connectedLeft", "label", "labelAction", "labelHidden", "helpText", "prefix", "suffix", "onFocus", "onBlur", "autoComplete"]);var height = this.state.height;

            var className = classNames(styles$51.TextField, Boolean(value) && styles$51.hasValue, disabled && styles$51.disabled, readOnly && styles$51.readOnly, error && styles$51.error, multiline && styles$51.multiline, this.state.focus && styles$51.focus);
            var prefixMarkup = prefix ? createElement(
                'div',
                { className: styles$51.Prefix, id: id + 'Prefix' },
                prefix
            ) : null;
            var suffixMarkup = suffix ? createElement(
                'div',
                { className: styles$51.Suffix, id: id + 'Suffix' },
                suffix
            ) : null;
            var spinnerMarkup = type === 'number' && !disabled ? createElement(Spinner$2, { onChange: this.handleNumberChange }) : null;
            var style = multiline && height ? { height: height } : null;
            var resizer = multiline != null ? createElement(Resizer, { contents: value || placeholder, currentHeight: height, minimumLines: typeof multiline === 'number' ? multiline : 1, onHeightChange: this.handleExpandingResize }) : null;
            var describedBy = [];
            if (error && typeof error === 'string') {
                describedBy.push(errorID$1(id));
            }
            if (helpText) {
                describedBy.push(helpTextID$1(id));
            }
            var labelledBy = [labelID(id)];
            if (prefix) {
                labelledBy.push(id + 'Prefix');
            }
            if (suffix) {
                labelledBy.push(id + 'Suffix');
            }
            var input = createElement(multiline ? 'textarea' : 'input', Object.assign({}, rest, { name: name,
                id: id,
                type: type,
                disabled: disabled,
                readOnly: readOnly,
                autoFocus: autoFocus,
                value: value,
                placeholder: placeholder,
                onFocus: onFocus,
                onBlur: onBlur,
                style: style, autoComplete: normalizeAutoComplete(autoComplete), className: styles$51.Input, onChange: this.handleChange, ref: this.setInput, 'aria-describedby': describedBy.length ? describedBy.join(' ') : undefined, 'aria-labelledby': labelledBy.join(' '), 'aria-invalid': Boolean(error) }));
            return createElement(
                Labelled$1,
                { label: label, id: id, error: error, action: labelAction, labelHidden: labelHidden, helpText: helpText },
                createElement(
                    Connected$1,
                    { left: connectedLeft, right: connectedRight },
                    createElement(
                        'div',
                        { className: className, onFocus: this.handleFocus, onBlur: this.handleBlur, onClick: this.handleClick },
                        prefixMarkup,
                        input,
                        suffixMarkup,
                        spinnerMarkup,
                        createElement('div', { className: styles$51.Backdrop }),
                        resizer
                    )
                )
            );
        }
    }, {
        key: 'setInput',
        value: function setInput(input) {
            this.input = input;
        }
    }, {
        key: 'handleNumberChange',
        value: function handleNumberChange(steps) {
            var _props = this.props,
                onChange = _props.onChange,
                value = _props.value,
                _props$step = _props.step,
                step = _props$step === undefined ? 1 : _props$step,
                _props$min = _props.min,
                min = _props$min === undefined ? -Infinity : _props$min,
                _props$max = _props.max,
                max = _props$max === undefined ? Infinity : _props$max;

            if (onChange == null) {
                return;
            }
            var numericValue = value ? parseFloat(value) : 0;
            if (isNaN(numericValue)) {
                return;
            }
            var newValue = Math.min(max, Math.max(numericValue + steps * step, min));
            onChange(String(newValue), this.state.id);
        }
    }, {
        key: 'handleExpandingResize',
        value: function handleExpandingResize(height) {
            this.setState({ height: height });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            var onChange = this.props.onChange;

            if (onChange == null) {
                return;
            }
            onChange(event.currentTarget.value, this.state.id);
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus() {
            this.setState({ focus: true });
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur() {
            this.setState({ focus: false });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.input.focus();
        }
    }]);

    return TextField;
}(PureComponent);

__decorate([autobind], TextField$1.prototype, "setInput", null);
__decorate([autobind], TextField$1.prototype, "handleNumberChange", null);
__decorate([autobind], TextField$1.prototype, "handleExpandingResize", null);
__decorate([autobind], TextField$1.prototype, "handleChange", null);
__decorate([autobind], TextField$1.prototype, "handleFocus", null);
__decorate([autobind], TextField$1.prototype, "handleBlur", null);
__decorate([autobind], TextField$1.prototype, "handleClick", null);
function normalizeAutoComplete(autoComplete) {
    if (autoComplete == null) {
        return autoComplete;
    }
    return autoComplete ? 'on' : 'off';
}

var styles$52 = {
  "Tooltip": "Polaris-Tooltip",
  "measuring": "Polaris-Tooltip--measuring",
  "positionedAbove": "Polaris-Tooltip--positionedAbove",
  "Tip": "Polaris-Tooltip__Tip",
  "light": "Polaris-Tooltip--light",
  "Wrapper": "Polaris-Tooltip__Wrapper",
  "Content": "Polaris-Tooltip__Content",
  "Label": "Polaris-Tooltip__Label",
  "skeletonShimmerAnimation": "Polaris-Tooltip--skeletonShimmerAnimation",
};

var TooltipOverlay = function (_React$PureComponent) {
    _inherits(TooltipOverlay, _React$PureComponent);

    function TooltipOverlay() {
        _classCallCheck(this, TooltipOverlay);

        return _possibleConstructorReturn(this, (TooltipOverlay.__proto__ || Object.getPrototypeOf(TooltipOverlay)).apply(this, arguments));
    }

    _createClass(TooltipOverlay, [{
        key: 'render',
        value: function render() {
            var markup = this.props.active ? this.renderOverlay() : null;
            return markup;
        }
    }, {
        key: 'renderOverlay',
        value: function renderOverlay() {
            var _props = this.props,
                active = _props.active,
                activator = _props.activator,
                _props$preferredPosit = _props.preferredPosition,
                preferredPosition = _props$preferredPosit === undefined ? 'below' : _props$preferredPosit;

            return createElement(PositionedOverlay$1, { active: active, activator: activator, preferredPosition: preferredPosition, render: this.renderTooltip });
        }
    }, {
        key: 'renderTooltip',
        value: function renderTooltip(overlayDetails) {
            var left = overlayDetails.left,
                measuring = overlayDetails.measuring,
                desiredHeight = overlayDetails.desiredHeight,
                positioning = overlayDetails.positioning,
                activatorRect = overlayDetails.activatorRect;
            var _props2 = this.props,
                id = _props2.id,
                children = _props2.children,
                light = _props2.light;

            var tipStyle = calculateTipPosition(activatorRect.center.x, left);
            var containerClassName = classNames(styles$52.Tooltip, light && styles$52.light, measuring && styles$52.measuring, positioning === 'above' && styles$52.positionedAbove);
            var contentStyles = measuring ? undefined : { maxHeight: desiredHeight };
            var tipMarkup = !measuring ? createElement('div', { style: tipStyle, className: styles$52.Tip }) : null;
            return createElement(
                'div',
                Object.assign({ className: containerClassName }, layer.props),
                tipMarkup,
                createElement(
                    'div',
                    { className: styles$52.Wrapper },
                    createElement(
                        'div',
                        { id: id, role: 'tooltip', className: styles$52.Content, style: contentStyles },
                        children
                    )
                )
            );
        }
    }]);

    return TooltipOverlay;
}(PureComponent);

__decorate([autobind], TooltipOverlay.prototype, "renderOverlay", null);
__decorate([autobind], TooltipOverlay.prototype, "renderTooltip", null);
function calculateTipPosition(activatorRectXAxisCenter, left) {
    return { left: activatorRectXAxisCenter - left };
}

var getUniqueID$8 = createUniqueIDFactory('TooltipContent');
var Tooltip$1 = function (_React$PureComponent) {
    _inherits(Tooltip, _React$PureComponent);

    function Tooltip() {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.id = getUniqueID$8();
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setAccessibilityAttributes();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.setAccessibilityAttributes();
        }
    }, {
        key: 'renderLayer',
        value: function renderLayer() {
            var id = this.id,
                activatorNode = this.activatorNode;

            if (activatorNode == null) {
                return null;
            }
            var _props = this.props,
                _props$preferredPosit = _props.preferredPosition,
                preferredPosition = _props$preferredPosit === undefined ? 'below' : _props$preferredPosit,
                active = _props.active,
                light = _props.light,
                content = _props.content;

            return createElement(
                TooltipOverlay,
                { id: id, preferredPosition: preferredPosition, activator: activatorNode, active: active || this.state.active, onClose: noop, light: light },
                createElement(
                    'div',
                    { className: styles$52.Label },
                    content
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$activatorWrapp = this.props.activatorWrapper,
                WrapperComponent = _props$activatorWrapp === undefined ? 'span' : _props$activatorWrapp;

            return createElement(
                WrapperComponent,
                { onFocus: this.handleFocus, onBlur: this.handleBlur, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, ref: this.setActivator },
                this.props.children
            );
        }
    }, {
        key: 'setActivator',
        value: function setActivator(node) {
            if (node == null) {
                this.activatorNode = null;
                this.activatorContainer = null;
                return;
            }
            this.activatorNode = node.firstElementChild;
            this.activatorContainer = node;
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus() {
            this.setState({ active: true });
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur() {
            this.setState({ active: false });
        }
    }, {
        key: 'handleMouseEnter',
        value: function handleMouseEnter() {
            this.setState({ active: true });
        }
    }, {
        key: 'handleMouseLeave',
        value: function handleMouseLeave() {
            this.setState({ active: false });
        }
    }, {
        key: 'setAccessibilityAttributes',
        value: function setAccessibilityAttributes() {
            var activatorContainer = this.activatorContainer,
                id = this.id;

            if (activatorContainer == null) {
                return;
            }
            var firstFocusable = findFirstFocusableNode(activatorContainer);
            var accessibilityNode = firstFocusable || activatorContainer;
            accessibilityNode.tabIndex = 0;
            accessibilityNode.setAttribute('aria-describedby', id);
        }
    }]);

    return Tooltip;
}(PureComponent);
__decorate([autobind], Tooltip$1.prototype, "setActivator", null);
__decorate([autobind], Tooltip$1.prototype, "handleFocus", null);
__decorate([autobind], Tooltip$1.prototype, "handleBlur", null);
__decorate([autobind], Tooltip$1.prototype, "handleMouseEnter", null);
__decorate([autobind], Tooltip$1.prototype, "handleMouseLeave", null);
Tooltip$1 = __decorate([layeredComponent({ idPrefix: 'Tooltip' })], Tooltip$1);
var Tooltip$2 = Tooltip$1;

var styles$53 = {
  "DisplayText": "Polaris-SkeletonDisplayText__DisplayText",
  "skeletonShimmerAnimation": "Polaris-SkeletonDisplayText--skeletonShimmerAnimation",
  "sizeSmall": "Polaris-SkeletonDisplayText--sizeSmall",
  "sizeMedium": "Polaris-SkeletonDisplayText--sizeMedium",
  "sizeLarge": "Polaris-SkeletonDisplayText--sizeLarge",
  "sizeExtraLarge": "Polaris-SkeletonDisplayText--sizeExtraLarge",
};

function SkeletonDisplayText$1(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === undefined ? 'medium' : _ref$size;

    var className = classNames(styles$53.DisplayText, size && styles$53[variationName('size', size)]);
    return createElement('div', { className: className });
}

var styles$54 = {
  "SkeletonBodyTextContainer": "Polaris-SkeletonBodyText__SkeletonBodyTextContainer",
  "skeletonShimmerAnimation": "Polaris-SkeletonBodyText--skeletonShimmerAnimation",
  "SkeletonBodyText": "Polaris-SkeletonBodyText",
};

function SkeletonBodyText$1(_ref) {
    var _ref$lines = _ref.lines,
        lines = _ref$lines === undefined ? 3 : _ref$lines;

    var bodyTextLines = [];
    for (var i = 0; i < lines; i++) {
        bodyTextLines.push(createElement('div', { className: styles$54.SkeletonBodyText, key: i }));
    }
    return createElement(
        'div',
        { className: styles$54.SkeletonBodyTextContainer },
        bodyTextLines
    );
}

var styles$55 = {
  "Page": "Polaris-SkeletonPage__Page",
  "fullWidth": "Polaris-SkeletonPage--fullWidth",
  "Content": "Polaris-SkeletonPage__Content",
  "Header": "Polaris-SkeletonPage__Header",
  "Header-hasSecondaryActions": "Polaris-SkeletonPage__Header--hasSecondaryActions",
  "Actions": "Polaris-SkeletonPage__Actions",
  "Action": "Polaris-SkeletonPage__Action",
  "skeletonShimmerAnimation": "Polaris-SkeletonPage--skeletonShimmerAnimation",
};

var SkeletonPage = function (_React$PureComponent) {
    _inherits(SkeletonPage, _React$PureComponent);

    function SkeletonPage() {
        _classCallCheck(this, SkeletonPage);

        return _possibleConstructorReturn(this, (SkeletonPage.__proto__ || Object.getPrototypeOf(SkeletonPage)).apply(this, arguments));
    }

    _createClass(SkeletonPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                fullWidth = _props.fullWidth,
                secondaryActions = _props.secondaryActions,
                _props$title = _props.title,
                title = _props$title === undefined ? '' : _props$title;

            var className = classNames(styles$55.Page, fullWidth && styles$55.fullWidth);
            var headerClassName = classNames(styles$55.Header, secondaryActions && styles$55['Header-hasSecondaryActions']);
            var titleMarkup = title !== null ? renderTitle(title) : null;
            var secondaryActionsMarkup = secondaryActions ? renderSecondaryActions(secondaryActions) : null;
            var headerMarkup = !this.context.easdk ? createElement(
                'div',
                { className: headerClassName },
                titleMarkup,
                secondaryActionsMarkup
            ) : null;
            return createElement(
                'div',
                { className: className, role: 'status', 'aria-label': 'Page loading' },
                headerMarkup,
                createElement(
                    'div',
                    { className: styles$55.Content },
                    children
                )
            );
        }
    }]);

    return SkeletonPage;
}(PureComponent);

SkeletonPage.contextTypes = { easdk: object };
function renderSecondaryActions(actionCount) {
    var actions = [];
    for (var i = 0; i < actionCount; i++) {
        var width = Math.round(Math.random() * 40 + 60);
        actions.push(createElement(
            'div',
            { className: styles$55.Action, style: { width: width }, key: i },
            createElement(SkeletonBodyText$1, { lines: 1 })
        ));
    }
    return createElement(
        'div',
        { className: styles$55.Actions },
        actions
    );
}
function renderTitle(title) {
    var titleContent = title === '' ? createElement(SkeletonDisplayText$1, { size: 'large' }) : createElement(
        DisplayText$1,
        { size: 'large', element: 'h1' },
        title
    );
    return createElement(
        'div',
        { className: styles$55.Title },
        titleContent
    );
}

var styles$56 = {
  "ProgressBar": "Polaris-ProgressBar",
  "sizeSmall": "Polaris-ProgressBar--sizeSmall",
  "sizeMedium": "Polaris-ProgressBar--sizeMedium",
  "sizeLarge": "Polaris-ProgressBar--sizeLarge",
  "Indicator": "Polaris-ProgressBar__Indicator",
  "fillup": "Polaris-ProgressBar--fillup",
  "Progress": "Polaris-ProgressBar__Progress",
  "Label": "Polaris-ProgressBar__Label",
  "skeletonShimmerAnimation": "Polaris-ProgressBar--skeletonShimmerAnimation",
};

function ProgressBar$1(_ref) {
    var _ref$progress = _ref.progress,
        progress = _ref$progress === undefined ? 0 : _ref$progress,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 'medium' : _ref$size;

    var className = classNames(styles$56.ProgressBar, size && styles$56[variationName('size', size)]);
    var parsedProgress = parseProgress(progress);
    return createElement(
        'div',
        { className: className },
        createElement('progress', { className: styles$56.Progress, value: parsedProgress, max: '100' }),
        createElement(
            'div',
            { className: styles$56.Indicator, role: 'progressbar', 'aria-hidden': 'true', style: { width: parsedProgress + '%' } },
            createElement(
                'span',
                { className: styles$56.Label },
                parsedProgress,
                '%'
            )
        )
    );
}
function parseProgress(progress) {
    var progressWidth = void 0;
    if (progress < 0) {
        if (process.env.NODE_ENV === 'development') {
            // tslint:disable-next-line no-console
            console.warn('Values passed to the progress prop shouldn\u2019t be negative. Resetting ' + progress + ' to 0.');
        }
        progressWidth = 0;
    } else if (progress > 100) {
        if (process.env.NODE_ENV === 'development') {
            // tslint:disable-next-line no-console
            console.warn('Values passed to the progress prop shouldn\u2019t exceed 100. Setting ' + progress + ' to 100.');
        }
        progressWidth = 100;
    } else {
        progressWidth = progress;
    }
    return progressWidth;
}

function useLinkComponent(LinkComponent) {
    UnstyledLink$1.use(LinkComponent);
}

export { Keys, AccountConnection$1 as AccountConnection, ActionList$1 as ActionList, Avatar$1 as Avatar, Badge$1 as Badge, Banner$1 as Banner, Button$1 as Button, buttonFrom, buttonsFrom, ButtonGroup$1 as ButtonGroup, CalloutCard$1 as CalloutCard, Caption$1 as Caption, Card$1 as Card, Checkbox$1 as Checkbox, ChoiceList$1 as ChoiceList, Collapsible$1 as Collapsible, ColorPicker$1 as ColorPicker, rgbToHex, rgbToHsb, hsbToRgb, hsbToHex, rgbString, rgbaString, DatePicker$1 as DatePicker, DescriptionList$1 as DescriptionList, DisplayText$1 as DisplayText, EmptyState$1 as EmptyState, EventListener$1 as EventListener, FooterHelp$1 as FooterHelp, FormLayout$1 as FormLayout, Heading$1 as Heading, Icon$1 as Icon, Image$1 as Image, KeyboardKey$1 as KeyboardKey, KeypressListener$1 as KeypressListener, Label$1 as Label, Labelled$1 as Labelled, Layout$1 as Layout, Link$1 as Link, ContentList as List, Page$1 as Page, PageActions$1 as PageActions, Pagination$1 as Pagination, Popover$2 as Popover, CloseSource as PopoverCloseSource, RadioButton$1 as RadioButton, ResourceList$1 as ResourceList, Scrollable$1 as Scrollable, Select$1 as Select, SettingToggle$1 as SettingToggle, Spinner$1 as Spinner, Stack$1 as Stack, Subheading$1 as Subheading, Tabs$1 as Tabs, Tag$1 as Tag, TextContainer$1 as TextContainer, TextField$1 as TextField, TextStyle$1 as TextStyle, Thumbnail$1 as Thumbnail, Tooltip$2 as Tooltip, UnstyledLink$1 as UnstyledLink, VisuallyHidden$1 as VisuallyHidden, SkeletonPage, SkeletonBodyText$1 as SkeletonBodyText, SkeletonDisplayText$1 as SkeletonDisplayText, ProgressBar$1 as ProgressBar, useLinkComponent };
export { Months } from '@shopify/javascript-utilities/dates';



//////////////////
// WEBPACK FOOTER
// ./~/@shopify/polaris/index.es.js
// module id = ./node_modules/@shopify/polaris/index.es.js
// module chunks = 0